import React, { useEffect, useMemo, useContext, useCallback, createContext, useState, useRef, Children, cloneElement } from 'react';
import { useDispatch, useSelector, Provider } from 'react-redux';
import { createSlice, createAsyncThunk, createSelector, createEntityAdapter, combineReducers, configureStore } from '@reduxjs/toolkit';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import intl from 'react-intl-universal';
import queryString from 'query-string';
import _styled, { css, keyframes, ThemeProvider } from 'styled-components';
import { darken, rgba } from 'polished';
import { useQuery } from 'react-query';
import head from 'lodash-es/head';
import sortBy from 'lodash-es/sortBy';
import { useForm } from 'react-hook-form';
import { isValid, format } from 'date-fns';

var getSession = function getSession(_ref) {
  var session = _ref.session;
  return session;
};

var initialState = '';
var session = /*#__PURE__*/createSlice({
  name: "Session",
  initialState: initialState,
  reducers: {
    SessionGetSuccess: function SessionGetSuccess(_, _ref) {
      var payload = _ref.payload;
      return payload;
    }
  }
});
var SessionGetSuccess = session.actions.SessionGetSuccess;
var session$1 = session.reducer;

var SessionProvider = function SessionProvider(_ref) {
  var children = _ref.children,
    session = _ref.session;
  var dispatch = useDispatch();
  var isSessionInStore = useSelector(getSession);
  useEffect(function () {
    dispatch(SessionGetSuccess(session));
  }, [dispatch, session]);
  if (!isSessionInStore) return null;
  return React.createElement(React.Fragment, null, children);
};
var useSession = function useSession(name) {
  if (name === void 0) {
    name = "X-ODDS-SESSION";
  }
  return document.cookie.split("; ").reduce(function (r, v) {
    var parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

var useLang = function useLang(_ref, isMobile) {
  var _ref$config = _ref.config,
    lang = _ref$config.lang,
    mainCountryCode = _ref$config.mainCountryCode;
  var path = useMemo(function () {
    return ("lang_" + lang + "_" + mainCountryCode + "_1_" + (isMobile ? "2" : "1")).toLowerCase();
  }, [lang, mainCountryCode]);
  return path;
};

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

var SESSION = "X-ODDS-SESSION";
var http = /*#__PURE__*/axios.create({
  baseURL: "" + (process.env.NODE_ENV !== "production" ? "https://test-api.etoto.pl" : process.env.DOMAIN_API_URL)
});
var http2 = {
  get: function get(url, session) {
    var _headers;
    return http.get(url, {
      headers: (_headers = {}, _headers[SESSION] = session, _headers)
    });
  },
  post: function post(url, data, session) {
    var _headers2;
    return http.post(url, data, {
      headers: (_headers2 = {}, _headers2[SESSION] = session, _headers2)
    });
  }
};

var updateCustomerDataBalance = function updateCustomerDataBalance(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", http2.get("/rest/customer/session/customerData/true/true", session));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};

var initialState$1 = {
  balance: 0,
  currencyCode: undefined
};
var fetchBalance = /*#__PURE__*/createAsyncThunk("Balance/FetchBalance", /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, _ref) {
    var getState, rejectWithValue, _yield$updateCustomer, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.next = 3;
          return updateCustomerDataBalance(getState().session)();
        case 3:
          _yield$updateCustomer = _context.sent;
          data = _yield$updateCustomer.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(initialState$1));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var balance = /*#__PURE__*/createSlice({
  name: "Balance",
  initialState: initialState$1,
  reducers: {
    hydrateBalance: function hydrateBalance(_, _ref3) {
      var payload = _ref3.payload;
      return payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchBalance.fulfilled, function (_, _ref4) {
      var payload = _ref4.payload;
      return payload;
    });
  }
});
var hydrateBalance = balance.actions.hydrateBalance;
var balance$1 = balance.reducer;

var getBalance = function getBalance(_ref) {
  var balance = _ref.balance;
  return balance;
};
var getBalanceValue = /*#__PURE__*/createSelector(getBalance, function (_ref2) {
  var balance = _ref2.balance;
  return balance;
});
var getBalanceCurrencyCode = /*#__PURE__*/createSelector(getBalance, function (_ref3) {
  var currencyCode = _ref3.currencyCode;
  return currencyCode;
});

var CallbackContext = /*#__PURE__*/createContext(function () {});
var BalanceProvider = function BalanceProvider(_ref) {
  var children = _ref.children,
    balance = _ref.balance,
    currencyCode = _ref.currencyCode,
    onSuccess = _ref.onSuccess;
  var dispatch = useDispatch();
  useEffect(function () {
    dispatch(hydrateBalance({
      balance: balance,
      currencyCode: currencyCode
    }));
  }, [dispatch, balance, currencyCode]);
  return React.createElement(CallbackContext.Provider, {
    value: onSuccess
  }, children);
};
var useBalance = function useBalance() {
  var dispatch = useDispatch();
  var onSuccess = useContext(CallbackContext);
  var balance = useSelector(getBalanceValue);
  var currencyCode = useSelector(getBalanceCurrencyCode);
  var updateBalance = useCallback(function () {
    onSuccess();
    dispatch(fetchBalance());
  }, [dispatch, onSuccess]);
  return {
    balance: balance,
    currencyCode: currencyCode,
    updateBalance: updateBalance
  };
};

var SummaryIsVisible = /*#__PURE__*/createContext(undefined);
var SummarySetIsVisible = /*#__PURE__*/createContext(undefined);
var SummaryData = /*#__PURE__*/createContext(undefined);
var SummarySetData = /*#__PURE__*/createContext(undefined);
var useSummaryState = function useSummaryState() {
  var context = useContext(SummaryIsVisible);
  if (context === undefined) {
    throw new Error("'useSummaryState' must be used within a SummaryProvider");
  }
  return context;
};
var useSummaryDispatch = function useSummaryDispatch() {
  var dispatch = useContext(SummarySetIsVisible);
  if (dispatch === undefined) {
    throw new Error("'useSummaryDispatch' must be used within a SummaryProvider");
  }
  return dispatch;
};
var show = function show() {
  var dispatch = useContext(SummarySetIsVisible);
  if (dispatch === undefined) {
    throw new Error("'show [Summary]' must be used within a SummaryProvider");
  }
  return function () {
    return dispatch(true);
  };
};
var hide = function hide() {
  var dispatch = useContext(SummarySetIsVisible);
  if (dispatch === undefined) {
    throw new Error("'hide [Summary]' must be used within a SummaryProvider");
  }
  return function () {
    return dispatch(false);
  };
};
var useSummaryData = function useSummaryData() {
  var context = useContext(SummaryData);
  if (context === undefined) {
    throw new Error("'useSummaryData' must be used within a SummaryProvider");
  }
  return context;
};
var useSummaryDataDispatch = function useSummaryDataDispatch() {
  var dispatch = useContext(SummarySetData);
  if (dispatch === undefined) {
    throw new Error("'useSummaryDataDispatch' must be used within a SummaryProvider");
  }
  return dispatch;
};
var useSummary = function useSummary() {
  return {
    isVisible: useSummaryState(),
    setIsVisible: useSummaryDispatch(),
    show: show(),
    hide: hide(),
    data: useSummaryData(),
    setData: useSummaryDataDispatch()
  };
};

var img = "data:image/svg+xml,%3csvg width='101' height='34' viewBox='0 0 101 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.1169 19.596L29.4381 19.5854L29.1348 21.4794L22.1756 28.1247L28.0175 28.114L27.677 30.1571L19.0738 30.1624L19.4356 28.0502L26.1075 21.6603H20.7817L21.1169 19.596ZM12.0136 16.3558C11.8327 16.1643 11.572 16.0153 11.2847 15.8983C10.9814 15.7812 10.6462 15.6961 10.3164 15.6376C9.90136 15.5631 9.49701 15.5312 9.2097 15.5205C8.94368 15.5099 8.77343 15.5099 8.77343 15.5099H2.42613L0 30.1624H2.26651L3.16035 24.7356L7.55504 24.7568C7.55504 24.7568 9.26823 24.826 10.4813 24.1822C11.6944 23.5385 12.0189 22.0753 12.0189 22.0753C12.0189 22.0753 12.1519 21.5326 12.2636 20.8729C12.386 20.144 12.5084 19.2714 12.5722 18.8086C12.5988 18.6064 12.6148 18.4787 12.6148 18.4787C12.6148 18.4787 12.6467 18.3297 12.6467 18.0956C12.652 17.7711 12.6042 17.2816 12.3488 16.8134C12.2583 16.6485 12.1519 16.4995 12.0136 16.3558ZM10.2685 18.9416C10.2685 18.9682 10.0663 20.144 9.80027 21.538C9.69919 22.07 9.28951 22.3573 8.82131 22.4584C8.04453 22.6233 7.20921 22.5914 7.20921 22.5914L3.5381 22.5808L4.34681 17.7126L7.67209 17.7232C7.67209 17.7232 7.89555 17.7179 8.20946 17.7232C8.56593 17.7285 9.03945 17.7445 9.42784 17.7977C9.76303 17.8402 10.0291 17.9094 10.1142 18.0158C10.2259 18.1542 10.2685 18.335 10.2844 18.4947C10.3057 18.7288 10.2685 18.9256 10.2685 18.9416ZM40.7227 15.5099H42.9041L40.462 30.1624L38.2753 30.1571L40.7227 15.5099ZM52.3639 19.596L54.4548 19.5907L55.1944 27.0287L58.4133 19.58L60.9937 19.5854L61.7545 27.0553L64.9681 19.5907H67.1388L62.5313 30.1518H59.9562L59.2113 22.7563L55.9605 30.1518L53.428 30.1624L52.3639 19.596Z' fill='%23BFC5D6'/%3e%3cpath d='M36.6952 19.6811C36.0833 19.4843 35.0245 19.4417 34.1254 19.4523C33.2582 19.463 32.8591 19.5055 32.5346 19.5747C32.5346 19.5747 30.9916 19.7982 30.1138 20.8835C29.2359 21.9689 28.9752 24.3418 28.9752 24.3418C28.9752 24.3418 28.4538 26.9648 28.6081 27.8427C28.7624 28.7153 29.0337 29.5293 30.0233 29.907C31.0129 30.2901 31.8536 30.2688 31.8536 30.2688C31.8536 30.2688 33.6199 30.4072 34.9501 30.0933C36.2802 29.7793 36.9825 28.8429 36.9825 28.8429C36.9825 28.8429 37.2964 28.4386 37.5198 27.9597C37.7433 27.4809 37.8125 27.1457 37.8231 27.1032L37.9614 26.5339L35.7002 26.5392C35.7002 26.5392 35.5779 28.0342 34.3542 28.1726C33.1358 28.3109 32.4814 28.2577 32.242 28.2471C32.0079 28.2364 30.699 28.2949 30.8054 27.1989C30.8054 27.183 30.8054 27.1617 30.8107 27.1298C30.8693 25.8848 31.0076 25.5602 31.0076 25.5602L38.1104 25.5389L38.4137 23.7832C38.7648 21.7933 38.5148 20.277 36.6952 19.6811ZM36.2216 23.5331L31.3534 23.5278L31.545 22.7563C31.545 22.7563 31.7152 22.1498 32.0504 21.8944C32.3909 21.639 32.8219 21.5912 33.2262 21.5539C33.6306 21.5167 34.7106 21.4369 35.5885 21.6178C35.8811 21.6763 36.1578 21.8412 36.2323 22.086C36.4025 22.6606 36.2216 23.5331 36.2216 23.5331Z' fill='%23BFC5D6'/%3e%3cpath d='M30.8214 27.151C30.8214 27.167 30.8161 27.183 30.8161 27.1989C30.8107 27.2841 30.8214 27.1457 30.8214 27.151Z' fill='%23BFC5D6'/%3e%3cpath d='M44.2183 27.1564C44.2183 27.1723 44.213 27.1883 44.213 27.2042C44.213 27.2894 44.2183 27.151 44.2183 27.1564Z' fill='%23BFC5D6'/%3e%3cpath d='M50.0974 19.6864C49.4855 19.4896 48.4268 19.447 47.5276 19.4577C46.6604 19.4683 46.2613 19.5109 45.9368 19.58C45.9368 19.58 44.3939 19.8035 43.516 20.8889C42.6381 21.9742 42.3774 24.3472 42.3774 24.3472C42.3774 24.3472 41.856 26.9701 42.0103 27.848C42.1646 28.7206 42.4359 29.5346 43.4255 29.9124C44.4151 30.2954 45.2558 30.2741 45.2558 30.2741C45.2558 30.2741 47.0222 30.4125 48.3523 30.0986C49.6824 29.7847 50.3847 28.8483 50.3847 28.8483C50.3847 28.8483 50.6986 28.4439 50.9221 27.9651C51.1455 27.4862 51.2147 27.151 51.2253 27.1085L51.3637 26.5392L49.1025 26.5445C49.1025 26.5445 48.9801 28.0396 47.7564 28.1779C46.538 28.3162 45.8836 28.263 45.6442 28.2577C45.4101 28.2471 44.1012 28.3003 44.2076 27.2096C44.2076 27.1936 44.2076 27.1723 44.213 27.1404C44.2715 25.8954 44.4098 25.5709 44.4098 25.5709L51.5126 25.5496L51.8159 23.7938C52.167 21.7987 51.917 20.277 50.0974 19.6864ZM49.6026 23.5331L44.7344 23.5278L44.9259 22.7563C44.9259 22.7563 45.0962 22.1498 45.4313 21.8944C45.7665 21.639 46.2028 21.5912 46.6072 21.5539C47.0115 21.5167 48.0916 21.4369 48.9694 21.6178C49.2621 21.6763 49.5387 21.8412 49.6132 22.086C49.7835 22.6553 49.6026 23.5331 49.6026 23.5331Z' fill='%23BFC5D6'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M69.6501 19.596L71.0493 27.3213L75.0024 19.5907L77.2264 19.612L71.5282 30.6519C71.5282 30.6519 70.496 32.6524 69.8576 33.1578C69.2191 33.6633 68.8254 33.8921 68.304 33.9453C67.7826 33.9985 67.5698 34.0357 67.0696 33.9453L66.5376 33.8495L66.8675 31.8756C66.8675 31.8756 67.7507 32.0405 68.2721 31.833C68.7988 31.6255 69.2191 30.7317 69.2191 30.7317L69.4851 30.2848L67.4261 19.5907L69.6501 19.596Z' fill='%23BFC5D6'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M78.0351 20.6441L80.3282 20.6494L80.4665 19.7609C80.4665 19.7609 80.7113 18.1542 81.2593 17.8456C81.4349 17.7445 81.7168 17.654 82.0414 17.5955C82.6426 17.4891 83.4034 17.4785 84.0259 17.4997C84.9783 17.5317 85.3401 17.5423 86.3084 17.654C87.2767 17.7658 87.032 18.7022 87.032 18.7022L86.8404 20.1014C86.8404 20.1014 86.7553 20.7293 86.5318 21.1176C86.335 21.4635 85.7923 21.6976 85.4784 21.7987C84.7229 22.0434 82.1372 22.7031 82.1372 22.7031L80.1047 23.2884C80.1047 23.2884 78.8544 23.6502 78.1575 24.4216C77.4552 25.1984 77.1785 26.0763 77.0827 26.5339C76.987 26.9914 76.4496 30.1571 76.4496 30.1571L87.4204 30.1624L87.7875 27.9704L79.1098 27.981L79.2641 27.0872C79.2641 27.0872 79.3652 26.1668 79.7376 25.8635C79.8547 25.7677 79.9132 25.64 80.6049 25.3953C81.0199 25.2463 82.4351 24.8686 82.4351 24.8686L85.7072 23.9747C85.7072 23.9747 87.4949 23.5172 88.1972 22.5382C88.8995 21.5646 89.1708 19.6971 89.1708 19.6971C89.1708 19.6971 89.3623 17.8828 89.2134 17.3135C89.0697 16.7442 88.5323 16.0632 87.8779 15.7706C87.2235 15.478 86.5425 15.3077 84.5686 15.3343C82.5947 15.3609 81.6158 15.4514 80.6155 15.8238C79.6153 16.1909 79.0353 16.8613 78.6682 17.8083C78.2692 18.7075 78.0351 20.6441 78.0351 20.6441ZM98.6891 24.7196L100.227 15.5046H97.5026L89.0218 24.6132L88.6387 26.9223H96.0555L95.5128 30.1571L97.7899 30.1624L98.3273 26.9223L100.429 26.9276L100.807 24.7196H98.6891ZM96.4226 24.7249L91.6288 24.7196L97.4654 18.5L96.4226 24.7249ZM16.8233 16.7176H23.809C23.809 16.7176 25.3732 15.4514 26.4852 14.6373C27.5972 13.8233 29.619 12.5411 29.619 12.5411L25.6712 10.6949C25.6712 10.6949 22.3353 12.7592 20.92 13.7329C19.5473 14.632 16.8233 16.7176 16.8233 16.7176ZM31.8376 11.2376L28.5974 9.05618C28.5974 9.05618 31.529 7.39087 35.4289 5.8373C39.3235 4.28373 41.4038 3.63463 41.4038 3.63463L42.0635 6.72582C42.0635 6.72582 38.3126 7.98144 36.1631 8.99765C33.9392 9.94469 31.8376 11.2376 31.8376 11.2376ZM44.4577 6.05012L43.8937 2.88445C43.8937 2.88445 47.8947 1.82036 51.5552 1.13934C55.221 0.458322 60.0786 0.133774 60.0786 0.133774L58.4718 5.02327C58.4718 5.02327 54.1995 4.43802 50.1878 4.98603C47.0647 5.35846 44.4577 6.05012 44.4577 6.05012ZM61.015 5.43827L63.7177 0.00608363C63.7177 0.00608363 69.6394 -0.110966 74.747 0.681781C79.8547 1.46921 84.526 2.68227 84.4249 2.73548L71.475 9.50841C71.475 9.50841 68.4476 7.59305 64.6914 6.41723C62.5632 5.78942 61.015 5.43827 61.015 5.43827ZM73.7947 10.9822L76.6411 13.1423H100.035C100.035 13.1423 99.9873 12.3868 99.3648 11.312C98.9764 10.6417 98.2688 9.92873 97.5292 9.18919C97.2579 8.92316 96.1832 8.08253 95.3744 7.55581C93.3101 6.21505 92.1556 5.69897 90.0114 4.72533L73.7947 10.9822Z' fill='%23BFC5D6'/%3e%3cpath d='M18.3396 19.5854C17.4617 19.5854 16.6317 19.9312 15.9241 20.3196L16.0465 19.5854H13.7214L11.8593 30.1039H14.1896L15.2218 24.278C15.4346 23.0969 16.3178 21.6337 18.0417 21.6337L19.2441 21.6284L19.6059 19.5854H18.3396Z' fill='%23BFC5D6'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='65' height='34' viewBox='0 0 65 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M11.5096 21.5048C11.5096 23.6771 13.2707 25.4381 15.4429 25.4381C17.6152 25.4381 19.3763 23.6771 19.3763 21.5048C19.3763 19.3326 17.6152 17.5715 15.4429 17.5715C13.2707 17.5715 11.5096 19.3326 11.5096 21.5048Z' fill='%23BFC5D6'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.36744 34H59.2536C62.2179 34 64.6211 31.5967 64.6211 28.6324V5.36757C64.6211 2.40302 62.2179 0 59.2536 0H5.36744C2.40308 0 0 2.40302 0 5.36757V28.6324C0 31.5967 2.40308 34 5.36744 34ZM19.7189 11.6852C21.8766 11.6852 23.6258 9.93624 23.6258 7.7784C23.6258 5.62077 21.8766 3.87157 19.7189 3.87157C17.5613 3.87157 15.8121 5.62077 15.8121 7.7784C15.8121 9.93624 17.5613 11.6852 19.7189 11.6852ZM26.6094 29.6354H30.9915V5.08513H26.6094V29.6354ZM34.74 29.6354H39.1221V13.3742H34.74V29.6354ZM52.1774 21.0297L58.7623 29.6354H53.0603L47.2527 21.2866V29.6354H42.8706V5.08513H47.2527V20.8012L53.0603 13.3742H58.2344L52.1774 21.0297ZM11.5096 14.1775C12.6809 13.5475 14.0199 13.1894 15.4429 13.1894C20.0354 13.1894 23.7584 16.9124 23.7584 21.5048C23.7584 26.0972 20.0354 29.8202 15.4429 29.8202C10.8505 29.8202 7.12751 26.0972 7.12751 21.5048V5.08513H11.5096V14.1775Z' fill='%23BFC5D6'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='81' height='34' viewBox='0 0 81 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M34.8124 29.6249H28.3047L32.375 4.45623H38.8826L34.8124 29.6249ZM58.4039 5.07153C57.1202 4.56228 55.0844 4 52.5669 4C46.1402 4 41.6146 7.42704 41.5868 12.3267C41.5335 15.9417 44.8271 17.9495 47.2904 19.1548C49.8082 20.3865 50.664 21.1904 50.664 22.2883C50.6384 23.9744 48.6295 24.7516 46.7558 24.7516C44.1576 24.7516 42.7655 24.3509 40.6498 23.4128L39.7929 23.0107L38.8822 28.6605C40.4085 29.3559 43.2206 29.9729 46.1402 30C52.9687 30 57.4143 26.626 57.4669 21.4046C57.4929 18.5395 55.7537 16.3441 52.0042 14.5502C49.7281 13.3986 48.3341 12.6221 48.3341 11.4438C48.3608 10.3726 49.5132 9.27544 52.0826 9.27544C54.1982 9.22171 55.7527 9.73024 56.9303 10.2391L57.5189 10.5064L58.4039 5.07153ZM67.0534 20.7085C67.5893 19.2626 69.6516 13.6665 69.6516 13.6665C69.6245 13.7203 70.1865 12.194 70.5078 11.2569L70.9626 13.4256C70.9626 13.4256 72.195 19.4502 72.4626 20.7085H67.0534ZM75.0865 4.45623H70.0526C68.5004 4.45623 67.321 4.91103 66.6513 6.54448L56.9847 29.6245H63.8132C63.8132 29.6245 64.9374 26.5181 65.179 25.8491H73.5345C73.7214 26.7328 74.311 29.6245 74.311 29.6245H80.3369L75.0865 4.45623ZM22.869 4.45623L16.4957 21.6189L15.7993 18.138C14.621 14.1217 10.9256 9.75801 6.80178 7.58826L12.6395 29.5983H19.5214L29.7505 4.45623H22.869Z' fill='%23BFC5D6'/%3e%3cpath d='M10.5776 4.45623H0.107117L0 4.96477C8.16761 7.05338 13.5769 12.0879 15.7993 18.1392L13.5232 6.57188C13.1484 4.96441 11.9968 4.50925 10.5776 4.45623Z' fill='%23BFC5D6'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='172' height='34' viewBox='0 0 172 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M24.2704 5.21249C24.0771 5.36458 23.8879 5.52124 23.7029 5.68249C20.5421 8.43249 18.5413 12.4812 18.5413 16.9996C18.5413 21.5183 20.5421 25.5671 23.7029 28.3171C23.8879 28.4783 24.0771 28.635 24.2704 28.7871C24.4638 28.635 24.6529 28.4783 24.8379 28.3171C27.9988 25.5671 29.9996 21.5183 29.9996 16.9996C29.9996 12.4812 27.9988 8.43249 24.8379 5.68249C24.6529 5.52124 24.4638 5.36458 24.2704 5.21249V5.21249ZM33.5408 2C30.4696 2 27.6146 2.92333 25.2371 4.50667C25.3588 4.60667 25.4817 4.70458 25.5996 4.80708C29.1334 7.88168 31.16 12.3254 31.16 16.9996C31.16 21.6742 29.1334 26.1179 25.6 29.1925C25.4825 29.2946 25.3588 29.3929 25.2371 29.4929C27.6146 31.0762 30.4696 31.9996 33.5408 31.9996C41.8252 31.9996 48.5408 25.2842 48.5408 17C48.5408 8.71543 41.8252 2 33.5408 2V2ZM22.9413 29.1925C23.0583 29.2946 23.1821 29.3929 23.3038 29.4929C20.9263 31.0762 18.0708 32 15 32C6.71544 32 0 25.2842 0 17C0 8.71583 6.71544 2 15 2C18.0708 2 20.9258 2.92333 23.3038 4.50667C23.1821 4.60667 23.0592 4.70458 22.9413 4.80667C19.4075 7.88168 17.3808 12.3254 17.3808 16.9996C17.3808 21.6742 19.4075 26.1183 22.9413 29.1925V29.1925ZM78.4989 17.0646C78.4989 15.3117 79.6464 13.8717 81.5246 13.8717C83.3193 13.8717 84.5296 15.2492 84.5296 17.0646C84.5296 18.8804 83.3193 20.2575 81.5246 20.2575C79.6464 20.2575 78.4989 18.8179 78.4989 17.0646ZM86.5752 17.0646V12.0771H84.4046V13.2875C83.7158 12.39 82.6727 11.8267 81.2533 11.8267C78.4568 11.8267 76.2655 14.0179 76.2655 17.0646C76.2655 20.1117 78.4568 22.3029 81.2533 22.3029C82.6727 22.3029 83.7158 21.7396 84.4046 20.8421V22.0525H86.5752V17.0646ZM159.869 17.0646C159.869 15.3117 161.017 13.8717 162.895 13.8717C164.69 13.8717 165.9 15.2492 165.9 17.0646C165.9 18.8804 164.69 20.2575 162.895 20.2575C161.017 20.2575 159.869 18.8179 159.869 17.0646V17.0646ZM170.373 21.5787V21.7358H170.518C170.551 21.7358 170.577 21.7292 170.597 21.7162C170.616 21.7033 170.626 21.6833 170.626 21.6567C170.626 21.6304 170.616 21.6112 170.597 21.5983C170.577 21.5854 170.551 21.5787 170.518 21.5787H170.373V21.5787ZM170.519 21.4687C170.595 21.4687 170.653 21.4854 170.694 21.5192C170.735 21.5529 170.755 21.5983 170.755 21.6567C170.755 21.705 170.739 21.745 170.706 21.7767C170.674 21.8083 170.627 21.8275 170.567 21.835L170.76 22.0567H170.609L170.431 21.8362H170.373V22.0567H170.248V21.4687H170.519V21.4687ZM170.482 22.2587C170.55 22.2587 170.614 22.2454 170.673 22.22C170.732 22.1937 170.783 22.1587 170.828 22.1142C170.873 22.0696 170.908 22.0175 170.933 21.9575C170.958 21.8975 170.971 21.8333 170.971 21.765C170.971 21.6971 170.958 21.6329 170.933 21.5729C170.908 21.5129 170.873 21.4604 170.828 21.4158C170.783 21.3712 170.732 21.3367 170.673 21.3112C170.614 21.2858 170.55 21.2733 170.482 21.2733C170.413 21.2733 170.348 21.2858 170.287 21.3112C170.227 21.3367 170.174 21.3712 170.13 21.4158C170.086 21.4604 170.051 21.5129 170.025 21.5729C170 21.6329 169.987 21.6971 169.987 21.765C169.987 21.8333 170 21.8975 170.025 21.9575C170.051 22.0175 170.086 22.0696 170.13 22.1142C170.174 22.1587 170.227 22.1937 170.287 22.22C170.348 22.2454 170.413 22.2587 170.482 22.2587ZM170.482 21.1321C170.571 21.1321 170.655 21.1487 170.733 21.1817C170.811 21.2146 170.879 21.26 170.938 21.3175C170.996 21.375 171.042 21.4421 171.076 21.5192C171.109 21.5962 171.126 21.6783 171.126 21.765C171.126 21.8521 171.109 21.9337 171.076 22.0104C171.042 22.0867 170.996 22.1537 170.938 22.2112C170.879 22.2687 170.811 22.3142 170.733 22.3479C170.655 22.3812 170.571 22.3983 170.482 22.3983C170.391 22.3983 170.306 22.3812 170.227 22.3479C170.148 22.3142 170.079 22.2687 170.021 22.2112C169.963 22.1537 169.918 22.0867 169.884 22.0104C169.85 21.9337 169.833 21.8521 169.833 21.765C169.833 21.6783 169.85 21.5962 169.884 21.5192C169.918 21.4421 169.963 21.375 170.021 21.3175C170.079 21.26 170.148 21.2146 170.227 21.1817C170.306 21.1487 170.391 21.1321 170.482 21.1321ZM167.946 17.0646V8.06999H165.775V13.2875C165.086 12.39 164.043 11.8267 162.624 11.8267C159.827 11.8267 157.636 14.0179 157.636 17.0646C157.636 20.1117 159.827 22.3029 162.624 22.3029C164.043 22.3029 165.086 21.7396 165.775 20.8421V22.0525H167.946V17.0646V17.0646ZM113.497 13.7675C114.895 13.7675 115.793 14.6437 116.022 16.1883H110.846C111.076 14.7483 111.953 13.7675 113.497 13.7675ZM113.539 11.8267C110.617 11.8267 108.572 13.955 108.572 17.0646C108.572 20.2371 110.701 22.3029 113.685 22.3029C115.187 22.3029 116.565 21.9271 117.775 20.9046L116.711 19.2979C115.876 19.9654 114.812 20.3412 113.81 20.3412C112.412 20.3412 111.138 19.6942 110.826 17.8996H118.234C118.255 17.6283 118.276 17.3571 118.276 17.0646C118.255 13.955 116.335 11.8267 113.539 11.8267ZM139.73 17.0646C139.73 15.3117 140.878 13.8717 142.756 13.8717C144.551 13.8717 145.761 15.2492 145.761 17.0646C145.761 18.8804 144.551 20.2575 142.756 20.2575C140.878 20.2575 139.73 18.8179 139.73 17.0646ZM147.806 17.0646V12.0771H145.636V13.2875C144.947 12.39 143.904 11.8267 142.485 11.8267C139.688 11.8267 137.497 14.0179 137.497 17.0646C137.497 20.1117 139.688 22.3029 142.485 22.3029C143.904 22.3029 144.947 21.7396 145.636 20.8421V22.0525H147.806V17.0646ZM127.479 17.0646C127.479 20.0908 129.587 22.3029 132.801 22.3029C134.304 22.3029 135.306 21.9692 136.391 21.1133L135.347 19.3604C134.533 19.945 133.678 20.2575 132.738 20.2575C131.006 20.2371 129.733 18.9846 129.733 17.0646C129.733 15.145 131.006 13.8925 132.738 13.8717C133.678 13.8717 134.533 14.1846 135.347 14.7692L136.391 13.0162C135.306 12.1604 134.304 11.8267 132.801 11.8267C129.587 11.8267 127.479 14.0387 127.479 17.0646ZM155.445 11.8267C154.192 11.8267 153.378 12.4108 152.815 13.2875V12.0771H150.666V22.0525H152.836V16.4596C152.836 14.8108 153.546 13.8925 154.965 13.8925C155.403 13.8925 155.862 13.955 156.321 14.1429L156.989 12.0979C156.509 11.91 155.883 11.8267 155.445 11.8267V11.8267ZM97.3021 12.87C96.2583 12.1812 94.8183 11.8267 93.2327 11.8267C90.7071 11.8267 89.0796 13.0371 89.0796 15.0196C89.0796 16.6475 90.2902 17.6492 92.523 17.9621L93.5455 18.1083C94.7352 18.275 95.2983 18.5883 95.2983 19.1517C95.2983 19.9237 94.5055 20.3621 93.0239 20.3621C91.5214 20.3621 90.4358 19.8821 89.7055 19.3187L88.683 21.0087C89.8727 21.8854 91.3752 22.3029 93.003 22.3029C95.883 22.3029 97.5527 20.9462 97.5527 19.0475C97.5527 17.2942 96.2377 16.3758 94.0671 16.0629L93.0446 15.9167C92.1055 15.7917 91.3543 15.6042 91.3543 14.9362C91.3543 14.2058 92.0639 13.7675 93.2533 13.7675C94.5264 13.7675 95.7577 14.2475 96.363 14.6229L97.3021 12.87ZM125.288 11.8267C124.036 11.8267 123.222 12.4108 122.659 13.2875V12.0771H120.509V22.0525H122.679V16.4596C122.679 14.8108 123.389 13.8925 124.808 13.8925C125.246 13.8925 125.706 13.955 126.165 14.1429L126.833 12.0979C126.353 11.91 125.726 11.8267 125.288 11.8267V11.8267ZM106.777 12.0771H103.229V9.05083H101.038V12.0771H99.0133V14.0596H101.038V18.6092C101.038 20.9258 101.935 22.3029 104.502 22.3029C105.441 22.3029 106.526 22.0108 107.215 21.5308L106.589 19.6733C105.942 20.0492 105.233 20.2371 104.669 20.2371C103.584 20.2371 103.229 19.5692 103.229 18.5675V14.0596H106.777V12.0771V12.0771ZM74.3455 22.0525V15.7917C74.3455 13.4333 72.843 11.8475 70.4221 11.8267C69.1492 11.8058 67.8342 12.2021 66.9158 13.6004C66.2277 12.4946 65.1421 11.8267 63.6189 11.8267C62.5542 11.8267 61.5108 12.1396 60.6971 13.3083V12.0771H58.5264V22.0525H60.718V16.5221C60.718 14.79 61.678 13.8717 63.1596 13.8717C64.5996 13.8717 65.3302 14.8108 65.3302 16.5012V22.0525H67.5214V16.5221C67.5214 14.79 68.523 13.8717 69.963 13.8717C71.4446 13.8717 72.1542 14.8108 72.1542 16.5012V22.0525H74.3455V22.0525ZM48.0727 26.2946V25.7125H47.9205L47.7455 26.1129L47.5708 25.7125H47.4189V26.2946H47.5258V25.8554L47.6902 26.2342H47.8014L47.9652 25.8546V26.2946H48.0727V26.2946ZM47.1096 26.2946V25.8117H47.3042V25.7133H46.8083V25.8117H47.0033V26.2946H47.1096Z' fill='%23BFC5D6'/%3e%3c/svg%3e";

var Logos = [{
  image: img,
  alt: "Przelewy24 logo"
}, {
  image: img$1,
  alt: "BLIK logo"
}, {
  image: img$2,
  alt: "VISA logo"
}, {
  image: img$3,
  alt: "MASTERCARD logo"
}];

var Button = /*#__PURE__*/_styled.button.attrs({
  type: "button"
}).withConfig({
  displayName: "indexstyled__Button",
  componentId: "sc-itn3ex-0"
})(["border:0;background-color:", ";color:", ";cursor:pointer;margin:0;outline:0;padding:0;transition:all 0.15s linear;:hover,:focus{background-color:", ";color:", ";}"], function (_ref) {
  var isActive = _ref.isActive,
    _ref$theme = _ref.theme,
    buttonBackground = _ref$theme.buttonBackground,
    buttonBackgroundIsActive = _ref$theme.buttonBackgroundIsActive;
  return isActive ? buttonBackgroundIsActive : buttonBackground;
}, function (_ref2) {
  var isActive = _ref2.isActive,
    _ref2$theme = _ref2.theme,
    buttonColorIsActive = _ref2$theme.buttonColorIsActive,
    buttonColor = _ref2$theme.buttonColor;
  return isActive ? buttonColorIsActive : buttonColor;
}, function (_ref3) {
  var isActive = _ref3.isActive,
    _ref3$theme = _ref3.theme,
    buttonBackgroundIsActiveHover = _ref3$theme.buttonBackgroundIsActiveHover,
    buttonBackgroundHover = _ref3$theme.buttonBackgroundHover;
  return isActive ? buttonBackgroundIsActiveHover : buttonBackgroundHover;
}, function (_ref4) {
  var isActive = _ref4.isActive,
    _ref4$theme = _ref4.theme,
    buttonColorIsActiveHover = _ref4$theme.buttonColorIsActiveHover,
    buttonColorHover = _ref4$theme.buttonColorHover;
  return isActive ? buttonColorIsActiveHover : buttonColorHover;
});
var Submit = /*#__PURE__*/_styled(Button).attrs({
  type: "submit"
}).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-itn3ex-1"
})(["background-color:", ";color:", ";cursor:", ";font-size:", ";font-weight:900;height:", ";padding:0;text-transform:uppercase;transition:all 0.15s linear;width:100%;:hover,:focus{background-color:", ";color:", ";}"], function (_ref5) {
  var isDisabled = _ref5.isDisabled,
    _ref5$theme = _ref5.theme,
    submitBackgroundIsDisabled = _ref5$theme.submitBackgroundIsDisabled,
    submitBackground = _ref5$theme.submitBackground;
  return isDisabled ? submitBackgroundIsDisabled : submitBackground;
}, function (_ref6) {
  var isDisabled = _ref6.isDisabled,
    _ref6$theme = _ref6.theme,
    submitColorIsDisabled = _ref6$theme.submitColorIsDisabled,
    submitColor = _ref6$theme.submitColor;
  return isDisabled ? submitColorIsDisabled : submitColor;
}, function (_ref7) {
  var isDisabled = _ref7.isDisabled;
  return isDisabled ? "not-allowed" : "pointer";
}, 18 / 16 + "em", 42 / 18 + "em", function (_ref8) {
  var isDisabled = _ref8.isDisabled,
    _ref8$theme = _ref8.theme,
    submitBackgroundIsDisabledHover = _ref8$theme.submitBackgroundIsDisabledHover,
    submitBackgroundHover = _ref8$theme.submitBackgroundHover;
  return isDisabled ? submitBackgroundIsDisabledHover : submitBackgroundHover;
}, function (_ref9) {
  var isDisabled = _ref9.isDisabled,
    _ref9$theme = _ref9.theme,
    submitColorIsDisabledHover = _ref9$theme.submitColorIsDisabledHover,
    submitColorHover = _ref9$theme.submitColorHover;
  return isDisabled ? submitColorIsDisabledHover : submitColorHover;
});
var Input = /*#__PURE__*/_styled.input.withConfig({
  displayName: "indexstyled__Input",
  componentId: "sc-itn3ex-2"
})(["background-color:", ";border-color:", ";border-style:solid;border-width:0;color:", ";height:", ";margin:0;padding:0 ", ";outline:0;width:100%;::placeholder{color:", ";font-weight:500;}:hover,:focus{background-color:", ";border-color:", ";color:", ";}"], function (_ref10) {
  var inputBackground = _ref10.theme.inputBackground;
  return inputBackground;
}, function (_ref11) {
  var inputBorder = _ref11.theme.inputBorder;
  return inputBorder;
}, function (_ref12) {
  var inputColor = _ref12.theme.inputColor;
  return inputColor;
}, 54 / 16 + "em", 18 / 16 + "em", function (_ref13) {
  var inputPlaceholder = _ref13.theme.inputPlaceholder;
  return inputPlaceholder;
}, function (_ref14) {
  var inputBackgroundHover = _ref14.theme.inputBackgroundHover;
  return inputBackgroundHover;
}, function (_ref15) {
  var inputBorderHover = _ref15.theme.inputBorderHover;
  return inputBorderHover;
}, function (_ref16) {
  var inputColorHover = _ref16.theme.inputColorHover;
  return inputColorHover;
});
var InputError = /*#__PURE__*/_styled(motion.span).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-itn3ex-3"
})(["color:", ";display:block;font-size:", ";line-height:1.5;"], function (_ref17) {
  var inputErrorColor = _ref17.theme.inputErrorColor;
  return inputErrorColor;
}, 12 / 16 + "em");
var Label = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__Label",
  componentId: "sc-itn3ex-4"
})(["+ ", "{padding-left:1.5em;}"], InputError);
var RadioButton = /*#__PURE__*/_styled(Input).attrs({
  type: "radio"
}).withConfig({
  displayName: "indexstyled__RadioButton",
  componentId: "sc-itn3ex-5"
})(["height:0;opacity:0;pointer-events:none;position:absolute;width:0;+ ", "{padding-left:1.5em;position:relative;::after,::before{content:\"\";cursor:pointer;left:0;position:absolute;top:0;}::after{background-color:", ";border-radius:50%;height:0.5em;transform:translate(0.375em,0.375em);transition:all 0.15s linear;width:0.5em;}::before{background-color:transparent;border:0.188em solid ", ";border-radius:50%;height:1.25em;width:1.25em;}}:checked + ", "{::after{background-color:", ";}::before{border-color:", ";}}"], Label, function (_ref18) {
  var _ref18$isValid = _ref18.isValid,
    isValid = _ref18$isValid === void 0 ? true : _ref18$isValid,
    _ref18$theme = _ref18.theme,
    radioInner = _ref18$theme.radioInner,
    radioInnerIsInvalid = _ref18$theme.radioInnerIsInvalid;
  return isValid ? radioInner : radioInnerIsInvalid;
}, function (_ref19) {
  var _ref19$isValid = _ref19.isValid,
    isValid = _ref19$isValid === void 0 ? true : _ref19$isValid,
    _ref19$theme = _ref19.theme,
    radioOuter = _ref19$theme.radioOuter,
    radioOuterIsInvalid = _ref19$theme.radioOuterIsInvalid;
  return isValid ? radioOuter : radioOuterIsInvalid;
}, Label, function (_ref20) {
  var radioInnerIsChecked = _ref20.theme.radioInnerIsChecked;
  return radioInnerIsChecked;
}, function (_ref21) {
  var radioOuterIsChecked = _ref21.theme.radioOuterIsChecked;
  return radioOuterIsChecked;
});
// Same as RadioButton but square
var Checkbox = /*#__PURE__*/_styled(RadioButton).attrs({
  type: "checkbox"
}).withConfig({
  displayName: "indexstyled__Checkbox",
  componentId: "sc-itn3ex-6"
})(["+ ", "{::after,::before{border-radius:0;}}"], Label);
var Form = /*#__PURE__*/_styled.form.withConfig({
  displayName: "indexstyled__Form",
  componentId: "sc-itn3ex-7"
})(["border:0;margin:0;padding:0;"]);
var InputText = /*#__PURE__*/_styled(Input).attrs({
  type: "text"
}).withConfig({
  displayName: "indexstyled__InputText",
  componentId: "sc-itn3ex-8"
})([""]);
var InputNumber = /*#__PURE__*/_styled(Input).attrs({
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]*"
}).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-itn3ex-9"
})(["::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;}-moz-appearance:textfield;box-shadow:0 0 0 20px inset ", ";"], function (_ref22) {
  var white = _ref22.theme.white;
  return white;
});

var colors = {
  grey1: "#EFF2F3",
  grey2: "#0000003D",
  grey3: "#e6e7eb",
  grey4: "#787d83",
  grey5: "#4B4B4D",
  grey6: "#BAC1D0",
  grey7: "#E6EAF0",
  grey8: "#EBEFF3",
  blue0: "#F4F7FC",
  blue1: "#013BE5",
  blue2: "#021BC2",
  blue3: "#0103A3",
  blue4: "#001A5B",
  blue5: "#0E62C4",
  blue6: "#2D375E",
  lightGreen1: "#f5f9f8",
  lightGreen2: "#e5eded",
  green1: "#004f51",
  green2: "#006659",
  green3: "#013638",
  green4: "#2ea04f",
  green5: "#098d09",
  green6: "#02B253",
  yellow1: "#ffe42d",
  orange1: "#F58634",
  red1: "#D32F2F",
  red2: "#D93338",
  red3: "#BB3437",
  red4: "#ED3333",
  red5: "#E4202C",
  white: "#ffffff",
  black: "#000000"
};
var breakpoints = {
  xl: "1024px"
};
var devices = {
  mobile: "(max-width: " + breakpoints.xl + ")"
};
var theme = /*#__PURE__*/_extends({
  buttonBackgroundIsActive: colors.blue5,
  buttonBackgroundIsActiveHover: colors.blue5,
  buttonBackgroundHover: colors.blue5,
  buttonBackground: colors.blue4,
  buttonColorIsActive: colors.white,
  buttonColorIsActiveHover: colors.white,
  buttonColorHover: colors.white,
  buttonColor: colors.white,
  buttonBorder: "transparent",
  submitBackgroundIsDisabled: colors.grey2,
  submitBackgroundIsDisabledHover: /*#__PURE__*/darken(0.05, colors.grey2),
  submitBackground: colors.red5,
  submitBackgroundHover: /*#__PURE__*/darken(0.05, colors.red5),
  submitColorIsDisabled: colors.white,
  submitColorIsDisabledHover: colors.white,
  submitColor: colors.white,
  submitColorHover: colors.white,
  inputBackgroundHover: colors.white,
  inputBackground: colors.white,
  inputColorHover: colors.blue4,
  inputColor: colors.blue4,
  inputBorderHover: colors.blue5,
  inputBorder: colors.blue4,
  inputPlaceholder: /*#__PURE__*/rgba(colors.blue4, 0.5),
  inputErrorColor: colors.red5,
  radioOuterHover: colors.green1,
  radioOuterIsInvalid: colors.red1,
  radioOuterIsInvalidHover: colors.red1,
  radioOuterIsChecked: colors.green1,
  radioOuter: colors.green1,
  radioInnerHover: colors.green1,
  radioInnerIsInvalid: "transparent",
  radioInnerIsInvalidHover: colors.red1,
  radioInnerIsChecked: colors.green1,
  radioInner: "transparent"
}, colors);

var SummaryWrap = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__SummaryWrap",
  componentId: "sc-1mbgi9e-0"
})(["align-items:center;bottom:0;display:flex;left:0;justify-content:center;pointer-events:none;position:fixed;right:0;top:0;z-index:1000;*,*::after,*::before{font-family:\"Oswald\",sans-serif;box-sizing:border-box;}::after{background-color:", ";bottom:0;content:\"\";left:0;opacity:0.8;position:absolute;right:0;top:0;z-index:-1;@media ", "{display:none;}}"], function (_ref) {
  var blue4 = _ref.theme.blue4;
  return blue4;
}, devices.mobile);
var SummaryHeader = /*#__PURE__*/_styled.header.withConfig({
  displayName: "indexstyled__SummaryHeader",
  componentId: "sc-1mbgi9e-1"
})(["align-items:center;background-color:", ";border-radius:", ";border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:1px solid ", ";color:", ";display:flex;flex-shrink:0;font-size:", ";height:", ";justify-content:center;text-transform:uppercase;@media ", "{background-color:transparent;border:0;font-size:", ";height:", ";justify-content:flex-start;padding:0 0 0 ", ";}"], function (_ref2) {
  var blue0 = _ref2.theme.blue0;
  return blue0;
}, 5 / 30 + "em", function (_ref3) {
  var grey6 = _ref3.theme.grey6;
  return grey6;
}, function (_ref4) {
  var blue4 = _ref4.theme.blue4;
  return blue4;
}, 30 / 16 + "em", 132 / 30 + "em", devices.mobile, 24 / 16 + "em", 64 / 24 + "em", 84 / 24 + "em");
var SummaryBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__SummaryBody",
  componentId: "sc-1mbgi9e-2"
})(["align-items:center;display:flex;flex-grow:1;justify-content:center;"]);
var SummaryFooter = /*#__PURE__*/_styled.footer.withConfig({
  displayName: "indexstyled__SummaryFooter",
  componentId: "sc-1mbgi9e-3"
})(["align-items:center;display:flex;flex-shrink:0;justify-content:center;padding:", " 0;"], 80 / 16 + "em");
var Summary = /*#__PURE__*/_styled(motion.aside).withConfig({
  displayName: "indexstyled__Summary",
  componentId: "sc-1mbgi9e-4"
})(["background-color:", ";border-radius:", ";display:flex;flex-direction:column;font-size:16px;height:calc(100vh - ", ");pointer-events:all;position:relative;width:", ";@media ", "{border-radius:0;height:100%;width:100%;}"], function (_ref5) {
  var white = _ref5.theme.white;
  return white;
}, 5 / 16 + "em", 240 / 16 + "em", 1200 / 16 + "em", devices.mobile);
var Close = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Close",
  componentId: "sc-1mbgi9e-5"
})(["background-color:", ";border-radius:50%;font-size:", ";height:", ";position:absolute;right:0;top:0;transform:translate(50%,-50%);width:", ";:hover,:focus{background-color:", ";}::after,::before{background-color:", ";content:\"\";height:", ";position:absolute;right:50%;top:50%;width:50%;}::after{transform:translate(50%,-50%) rotate(45deg);}::before{transform:translate(50%,-50%) rotate(135deg);}@media ", "{background-color:", ";border-radius:0;height:", ";left:0;right:auto;transform:none;width:", ";:hover,:focus{background-color:", ";}::after{background-color:transparent;border:", " solid ", ";border-top:0;border-right:0;height:", ";width:", ";}::before{display:none;}}"], function (_ref6) {
  var red5 = _ref6.theme.red5;
  return red5;
}, 16 / 16 + "em", 36 / 16 + "em", 36 / 16 + "em", function (_ref7) {
  var red5 = _ref7.theme.red5;
  return darken(0.1, red5);
}, function (_ref8) {
  var white = _ref8.theme.white;
  return white;
}, 2 / 16 + "em", devices.mobile, function (_ref9) {
  var blue0 = _ref9.theme.blue0;
  return blue0;
}, 64 / 16 + "em", 64 / 16 + "em", function (_ref10) {
  var blue0 = _ref10.theme.blue0;
  return darken(0.1, blue0);
}, 2 / 16 + "em", function (_ref11) {
  var blue4 = _ref11.theme.blue4;
  return blue4;
}, 16 / 16 + "em", 16 / 16 + "em");
var Row = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-1mbgi9e-6"
})(["align-items:stretch;display:flex;flex-wrap:nowrap;height:100%;margin:0 ", ";@media ", "{flex-wrap:wrap;margin:0 ", ";}"], "-" + 10 / 16 + "em", devices.mobile, "-" + 5 / 16 + "em");
var Column = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-1mbgi9e-7"
})(["flex:1;padding:0 ", ";@media ", "{padding:0 ", ";}"], 10 / 16 + "em", devices.mobile, 5 / 16 + "em");
var Column1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column1",
  componentId: "sc-1mbgi9e-8"
})(["align-items:center;display:flex;flex:1;justify-content:center;padding:0 ", ";@media ", "{padding:0 ", ";}"], 10 / 16 + "em", devices.mobile, 5 / 16 + "em");
var FooterLogos = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__FooterLogos",
  componentId: "sc-1mbgi9e-9"
})(["width:50%;@media ", "{width:auto;", "{flex:0 1 50%;max-width:50%;}}"], devices.mobile, Column1);
var FooterLogo = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__FooterLogo",
  componentId: "sc-1mbgi9e-10"
})(["@media ", "{margin:", " 0;max-height:", ";}"], devices.mobile, 20 / 16 + "em", 32 / 16 + "em");
var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-1mbgi9e-11"
})(["align-items:center;color:", ";display:flex;flex-direction:column;font-family:\"Muli\",sans-serif;font-size:", ";font-weight:500;justify-content:center;text-align:center;*{font-family:inherit;}"], function (_ref12) {
  var blue4 = _ref12.theme.blue4;
  return blue4;
}, 24 / 16 + "em");
var Heading = /*#__PURE__*/_styled.h4.withConfig({
  displayName: "indexstyled__Heading",
  componentId: "sc-1mbgi9e-12"
})(["display:flex;flex-wrap:nowrap;margin:0;@media ", "{align-items:center;flex-direction:column;}"], devices.mobile);
var Text = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Text",
  componentId: "sc-1mbgi9e-13"
})(["font-size:", ";margin:", " 0 0;"], 18 / 24 + "em", 28 / 24 + "em");
var SuccessIcon = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__SuccessIcon",
  componentId: "sc-1mbgi9e-14"
})(["background-color:", ";border-radius:50%;height:", ";margin:0 ", " 0 0;position:relative;width:", ";::after,::before{border-bottom:", " solid ", ";border-left:", " solid ", ";content:\"\";height:", ";position:absolute;right:50%;top:50%;transform:translate(50%,-70%) rotate(-45deg);width:", ";}@media ", "{margin:", ";}"], function (_ref13) {
  var green5 = _ref13.theme.green5;
  return green5;
}, 24 / 24 + "em", 20 / 24 + "em", 24 / 24 + "em", 2 / 24 + "em", function (_ref14) {
  var white = _ref14.theme.white;
  return white;
}, 2 / 24 + "em", function (_ref15) {
  var white = _ref15.theme.white;
  return white;
}, 6 / 24 + "em", 14 / 24 + "em", devices.mobile, 20 / 24 + "em");
var FailureIcon = /*#__PURE__*/_styled(SuccessIcon).withConfig({
  displayName: "indexstyled__FailureIcon",
  componentId: "sc-1mbgi9e-15"
})(["background-color:", ";::after,::before{background-color:", ";border:0;height:", ";transform:translate(50%,-50%) rotate(-45deg);width:", ";}::before{transform:translate(50%,-50%) rotate(45deg);}"], function (_ref16) {
  var red5 = _ref16.theme.red5;
  return red5;
}, function (_ref17) {
  var white = _ref17.theme.white;
  return white;
}, 2 / 24 + "em", 16 / 24 + "em");
var InfoIcon = /*#__PURE__*/_styled(FailureIcon).withConfig({
  displayName: "indexstyled__InfoIcon",
  componentId: "sc-1mbgi9e-16"
})(["background-color:", ";::after{background-color:transparent;color:", ";content:\"i\";font-size:", ";font-weight:normal;height:auto;transform:translate(50%,-50%);width:auto;}::before{display:none;}"], function (_ref18) {
  var blue5 = _ref18.theme.blue5;
  return blue5;
}, function (_ref19) {
  var white = _ref19.theme.white;
  return white;
}, 16 / 24 + "em");

var SUCCESS_CODE = "SCS";
var FAILURE_CODE = "FLD";
var IN_PRGS_CODE = "IPR";
var Summary$1 = function Summary$1() {
  var _IN_PRGS_CODE$transac, _SUCCESS_CODE$transac, _FAILURE_CODE$transac;
  var _useState = useState(false),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  var _queryString$parse = queryString.parse(window.location.search),
    transactionStatusCode = _queryString$parse.transactionStatusCode;
  var onClose = function onClose() {
    window.history.replaceState(null, "", window.location.origin);
    setIsVisible(false);
  };
  useEffect(function () {
    !!window.location.search && setIsVisible(true);
    return function () {
      setIsVisible(false);
    };
  }, [setIsVisible, window.location.search]);
  return React.createElement(AnimatePresence, null, isVisible ? React.createElement(SummaryWrap, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React.createElement(Summary, {
    initial: {
      y: -100
    },
    animate: {
      y: 0
    },
    exit: {
      y: -100,
      opacity: 0
    }
  }, React.createElement(Close, {
    onClick: onClose
  }), React.createElement(SummaryHeader, null, intl.get("account_deposit_depositHeading") || "" + (process.env.NODE_ENV !== "production" ? "Wpłata" : "account_deposit_depositHeading")), React.createElement(SummaryBody, null, React.createElement(Wrapper, null, transactionStatusCode && ((_IN_PRGS_CODE$transac = {}, _IN_PRGS_CODE$transac[IN_PRGS_CODE] = React.createElement(React.Fragment, null, React.createElement(Heading, null, React.createElement(InfoIcon, null), intl.get("account_deposit_inProgressHeading")), React.createElement(Text, null, intl.get("account_deposit_inProgressText"))), _IN_PRGS_CODE$transac)[transactionStatusCode] || (_SUCCESS_CODE$transac = {}, _SUCCESS_CODE$transac[SUCCESS_CODE] = React.createElement(React.Fragment, null, React.createElement(Heading, null, React.createElement(SuccessIcon, null), intl.get("account_deposit_successHeading")), React.createElement(Text, null, intl.get("account_deposit_successText"))), _SUCCESS_CODE$transac)[transactionStatusCode] || (_FAILURE_CODE$transac = {}, _FAILURE_CODE$transac[FAILURE_CODE] = React.createElement(React.Fragment, null, React.createElement(Heading, null, React.createElement(FailureIcon, null), intl.get("account_deposit_failureHeading")), React.createElement(Text, null, intl.get("account_deposit_failureText"))), _FAILURE_CODE$transac)[transactionStatusCode]))), React.createElement(SummaryFooter, null, React.createElement(FooterLogos, null, React.createElement(Row, null, React.createElement(Column, null, React.createElement(Row, null, Logos.map(function (_ref, key) {
    var image = _ref.image,
      alt = _ref.alt;
    return React.createElement(Column1, {
      key: key
    }, React.createElement(FooterLogo, {
      src: image,
      alt: alt
    }));
  })))))))) : null);
};

var getProviders = function getProviders(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", http2.get("/rest/payment/providers/active", session));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var getProviderBanks = function getProviderBanks(session) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(providerId) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", http2.get("/rest/payment/banks/" + providerId, session));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getProviderCards = function getProviderCards(session) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(providerId) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", http2.get("/rest/payment/creditCard/list/" + providerId, session));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var updateCreditCard = function updateCreditCard(session) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref4) {
      var activeCard, creditCardId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            activeCard = _ref4.activeCard, creditCardId = _ref4.creditCardId;
            return _context4.abrupt("return", http2.post("/rest/payment/creditCard/update", {
              activeCard: activeCard,
              creditCardId: creditCardId
            }, session));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var saveCreditCard = function saveCreditCard(session) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref6) {
      var card, providerId, transactionAmount, transactionCurrency, transactionId;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            card = _ref6.card, providerId = _ref6.providerId, transactionAmount = _ref6.transactionAmount, transactionCurrency = _ref6.transactionCurrency, transactionId = _ref6.transactionId;
            return _context5.abrupt("return", http2.post("/rest/payment/payment/verify", {
              card: card,
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency,
              transactionId: transactionId
            }, session));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var getCustomerBanksDetails = function getCustomerBanksDetails(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", http2.get("/rest/payment/customerBanksDetail", session));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
};
var getBanks = function getBanks(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", http2.get("/rest/payment/banks", session));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
};
var getAccountTypes = function getAccountTypes(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", http2.get("/rest/payment/bank/accountTypes", session));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
};
var initializePayment = function initializePayment(session) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref12) {
      var bank, callbackUrl, customer, providerId, transactionAmount, transactionCurrency;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            bank = _ref12.bank, callbackUrl = _ref12.callbackUrl, customer = _ref12.customer, providerId = _ref12.providerId, transactionAmount = _ref12.transactionAmount, transactionCurrency = _ref12.transactionCurrency;
            return _context10.abrupt("return", http2.post("/rest/payment/payment/initialize", _extends({}, bank && {
              bank: bank
            }, callbackUrl && {
              callbackUrl: callbackUrl
            }, customer && {
              customer: customer
            }, {
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }), session));
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x5) {
      return _ref13.apply(this, arguments);
    };
  }();
};
var processPayment = function processPayment(session) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref14) {
      var accountId, additionalData, bank, callbackUrl, card, providerId, security, transactionAmount, transactionCurrency, voucherCode;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            accountId = _ref14.accountId, additionalData = _ref14.additionalData, bank = _ref14.bank, callbackUrl = _ref14.callbackUrl, card = _ref14.card, providerId = _ref14.providerId, security = _ref14.security, transactionAmount = _ref14.transactionAmount, transactionCurrency = _ref14.transactionCurrency, voucherCode = _ref14.voucherCode;
            return _context11.abrupt("return", http2.post("/rest/payment/payment/process", _extends({}, accountId && {
              accountId: accountId
            }, additionalData && {
              additionalData: additionalData
            }, bank && {
              bank: bank
            }, callbackUrl && {
              callbackUrl: callbackUrl
            }, card && {
              card: card
            }, {
              providerId: providerId
            }, security && {
              security: security
            }, {
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }, voucherCode && {
              voucherCode: voucherCode
            }), session));
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x6) {
      return _ref15.apply(this, arguments);
    };
  }();
};
var startTransfer = function startTransfer(session) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(transactionId) {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", http2.get("/rest/payment/payment/start-transfer/" + transactionId, session));
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x7) {
      return _ref16.apply(this, arguments);
    };
  }();
};

var providersAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var providerId = _ref.providerId;
    return providerId;
  }
});
var fetchProviders = /*#__PURE__*/createAsyncThunk("Providers/FetchProviders", /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, _ref2) {
    var getState, rejectWithValue, _yield$getProviders, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
          _context.next = 3;
          return getProviders(getState().session)();
        case 3:
          _yield$getProviders = _context.sent;
          data = _yield$getProviders.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(providersAdapter.getInitialState()));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var providers = /*#__PURE__*/createSlice({
  name: "Providers",
  initialState: /*#__PURE__*/providersAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchProviders.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      providersAdapter.setAll(state, payload);
    });
  }
});
var providers$1 = providers.reducer;

var _providersAdapter$get = /*#__PURE__*/providersAdapter.getSelectors(function (_ref) {
    var providers = _ref.providers;
    return providers;
  }),
  selectAll = _providersAdapter$get.selectAll;
// Filter out inactive providers
var getActiveProviders = /*#__PURE__*/createSelector(selectAll, function (providers) {
  return providers.filter(function (_ref2) {
    var active = _ref2.active;
    return active;
  });
});
var sortProviders = /*#__PURE__*/createSelector(getActiveProviders, function (providers) {
  return sortBy(providers, function (_ref3) {
    var settings = _ref3.settings;
    return settings == null ? void 0 : settings.order;
  });
});
// Get only deposit providers
var getDepositProviders = /*#__PURE__*/createSelector(sortProviders, function (providers) {
  return providers.filter(function (_ref4) {
    var isDeposit = _ref4.isDeposit;
    return isDeposit;
  });
});
var getPayoutProviders = /*#__PURE__*/createSelector(sortProviders, function (providers) {
  return providers.filter(function (_ref5) {
    var _settings$visible;
    var isDeposit = _ref5.isDeposit,
      settings = _ref5.settings;
    return !isDeposit && ((_settings$visible = settings == null ? void 0 : settings.visible) != null ? _settings$visible : true);
  });
});
var getRestDepositProviders = /*#__PURE__*/createSelector(getDepositProviders, function (providers) {
  return providers.filter(function (_ref6) {
    var settings = _ref6.settings;
    return !(settings != null && settings.firstDeposit);
  });
});
// First-time deposit only
var getFirstDepositProvider = /*#__PURE__*/createSelector(getDepositProviders, function (providers) {
  return head(providers.filter(function (_ref7) {
    var settings = _ref7.settings;
    return settings == null ? void 0 : settings.firstDeposit;
  }));
});
var getDepositPredefinedAmounts = /*#__PURE__*/createSelector(getFirstDepositProvider, function (provider) {
  var _provider$settings;
  return provider == null || (_provider$settings = provider.settings) == null ? void 0 : _provider$settings.amounts;
});

// @ts-nocheck
var queryOptions = {
  refetchOnWindowFocus: false
};
var useProviders = function useProviders() {
  var dispatch = useDispatch();
  var depositProviders = useSelector(getDepositProviders);
  var payoutProviders = useSelector(getPayoutProviders);
  var firstDepositProvider = useSelector(getFirstDepositProvider);
  var restDepositProviders = useSelector(getRestDepositProviders);
  var predefinedAmounts = useSelector(getDepositPredefinedAmounts);
  var providersFetcher = useCallback(function () {
    return dispatch(fetchProviders());
  }, [dispatch]);
  useQuery("provider", providersFetcher, queryOptions);
  return {
    depositProviders: depositProviders,
    payoutProviders: payoutProviders,
    firstDepositProvider: firstDepositProvider,
    restDepositProviders: restDepositProviders,
    predefinedAmounts: predefinedAmounts
  };
};

var accountsAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var accountId = _ref.accountId;
    return accountId;
  }
});
var fetchAccounts = /*#__PURE__*/createAsyncThunk("Account/FetchAccounts", /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, _ref2) {
    var getState, rejectWithValue, _yield$getCustomerBan, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
          _context.next = 3;
          return getCustomerBanksDetails(getState().session)();
        case 3:
          _yield$getCustomerBan = _context.sent;
          data = _yield$getCustomerBan.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(accountsAdapter.getInitialState()));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var accounts = /*#__PURE__*/createSlice({
  name: "Accounts",
  initialState: /*#__PURE__*/accountsAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchAccounts.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      accountsAdapter.setAll(state, payload);
    });
  }
});
var accounts$1 = accounts.reducer;

var _accountsAdapter$getS = /*#__PURE__*/accountsAdapter.getSelectors(function (_ref) {
    var accounts = _ref.accounts;
    return accounts;
  }),
  selectAll$1 = _accountsAdapter$getS.selectAll;
var getAccountById = function getAccountById(_, id) {
  return Number(id);
};
var getAccountDetails = /*#__PURE__*/createSelector([selectAll$1, getAccountById], function (accounts, id) {
  return accounts.filter(function (_ref2) {
    var accountId = _ref2.accountId;
    return accountId === id;
  })[0];
});

// @ts-nocheck
var queryOptions$1 = {
  refetchOnWindowFocus: false
};
var useAccounts = function useAccounts() {
  var dispatch = useDispatch();
  var accounts = useSelector(selectAll$1);
  var accountsFetcher = useCallback(function () {
    return dispatch(fetchAccounts());
  }, [dispatch]);
  useQuery("accounts", accountsFetcher, queryOptions$1);
  return {
    accounts: accounts
  };
};

var NotificationIsOpen = /*#__PURE__*/createContext(undefined);
var NotificationData = /*#__PURE__*/createContext({});
var NotificationSetIsOpen = /*#__PURE__*/createContext(undefined);
var NotificationSetData = /*#__PURE__*/createContext(undefined);
var NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState({}),
    data = _useState2[0],
    setData = _useState2[1];
  return React.createElement(NotificationIsOpen.Provider, {
    value: isOpen
  }, React.createElement(NotificationSetIsOpen.Provider, {
    value: setIsOpen
  }, React.createElement(NotificationData.Provider, {
    value: data
  }, React.createElement(NotificationSetData.Provider, {
    value: setData
  }, children))));
};
var useNotificationState = function useNotificationState() {
  var context = useContext(NotificationIsOpen);
  if (context === undefined) {
    throw new Error("'useNotificationState' must be used within a NotificationProvider");
  }
  return context;
};
var useNotificationData = function useNotificationData() {
  var context = useContext(NotificationData);
  return context;
};
var useNotificationDispatch = function useNotificationDispatch() {
  var dispatch = useContext(NotificationSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'useNotificationDispatch' must be used within a NotificationProvider");
  }
  return dispatch;
};
var show$1 = function show() {
  var dispatch = useContext(NotificationSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'show [Notification]' must be used within a NotificationProvider");
  }
  return function () {
    return dispatch(true);
  };
};
var hide$1 = function hide() {
  var dispatch = useContext(NotificationSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'hide [Notification]' must be used within a NotificationProvider");
  }
  return function () {
    return dispatch(false);
  };
};
var useNotificationSetData = function useNotificationSetData() {
  var dispatch = useContext(NotificationSetData);
  if (dispatch === undefined) {
    throw new Error("'useNotificationSetData' must be used within a NotificationProvider");
  }
  return dispatch;
};
var useNotification = function useNotification() {
  return {
    isOpen: useNotificationState(),
    setIsOpen: useNotificationDispatch(),
    show: show$1(),
    hide: hide$1(),
    data: useNotificationData(),
    setData: useNotificationSetData()
  };
};

var MOUSEDOWN = "mousedown";
var TOUCHSTART = "touchstart";
var events = [MOUSEDOWN, TOUCHSTART];
function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    events.forEach(function (event) {
      document.addEventListener(event, listener);
    });
    return function () {
      events.forEach(function (event) {
        document.removeEventListener(event, listener);
      });
    };
  }, [ref, handler]);
}

var Notification = /*#__PURE__*/_styled(motion.aside).withConfig({
  displayName: "indexstyled__Notification",
  componentId: "sc-opr25u-0"
})(["font-size:16px;left:0;position:absolute;right:0;top:", ";z-index:10001;"], 24 / 16 + "em");
var NotificationInner = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__NotificationInner",
  componentId: "sc-opr25u-1"
})(["background-color:", ";border-radius:", ";color:", ";padding:", ";width:100%;"], function (_ref) {
  var success = _ref.success,
    _ref$theme = _ref.theme,
    red5 = _ref$theme.red5,
    green4 = _ref$theme.green4;
  return success ? green4 : red5;
}, 4 / 16 + "em", function (_ref2) {
  var white = _ref2.theme.white;
  return white;
}, 16 / 16 + "em");
var NotificationText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__NotificationText",
  componentId: "sc-opr25u-2"
})(["font-size:", ";font-family:\"Muli\",sans-serif;font-weight:500;margin:0;text-align:center;"], 15 / 16 + "em");
var Close$1 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Close",
  componentId: "sc-opr25u-3"
})(["background-color:transparent;height:1.75em;padding:0.5em;position:absolute;right:0;top:0;width:1.75em;:hover,:focus{background-color:transparent;}::after,::before{background-color:", ";content:\"\";height:0.875em;left:50%;position:absolute;top:50%;width:0.125em;}::after{transform:translate(-50%,-50%) rotate(45deg);}::before{transform:translate(-50%,-50%) rotate(-45deg);}"], function (_ref3) {
  var white = _ref3.theme.white;
  return white;
});

var Notification$1 = function Notification$1() {
  var _useNotification = useNotification(),
    isOpen = _useNotification.isOpen,
    hide = _useNotification.hide,
    _useNotification$data = _useNotification.data,
    success = _useNotification$data.success,
    responseCode = _useNotification$data.responseCode,
    setData = _useNotification.setData;
  var ref = useRef(null);
  var onClick = useCallback(function () {
    hide();
    setData({});
  }, [hide, setData]);
  useOnClickOutside(ref, onClick);
  return React.createElement(AnimatePresence, null, isOpen && React.createElement(Notification, {
    key: 'notification',
    ref: ref,
    initial: {
      y: -100,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: -100,
      opacity: 0
    }
  }, React.createElement(NotificationInner, {
    success: success
  }, React.createElement(Close$1, {
    onClick: onClick
  }), React.createElement(NotificationText, null, responseCode ? intl.get("account_withdrawal_response_" + responseCode) || "account_withdrawal_response_" + responseCode : intl.get("account_withdrawal_response_failed") || "account_withdrawal_response_failed"))));
};

var ConfirmationIsOpen = /*#__PURE__*/createContext(undefined);
var ConfirmationSetIsOpen = /*#__PURE__*/createContext(undefined);
var ConfirmationProvider = function ConfirmationProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  return React.createElement(ConfirmationIsOpen.Provider, {
    value: isOpen
  }, React.createElement(ConfirmationSetIsOpen.Provider, {
    value: setIsOpen
  }, children));
};
var useConfirmationState = function useConfirmationState() {
  var context = useContext(ConfirmationIsOpen);
  if (context === undefined) {
    throw new Error("'useConfirmationState' must be used within a ConfirmationProvider");
  }
  return context;
};
var show$2 = function show() {
  var dispatch = useContext(ConfirmationSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'show [Confirmation]' must be used within a ConfirmationProvider");
  }
  return function () {
    return dispatch(true);
  };
};
var hide$2 = function hide() {
  var dispatch = useContext(ConfirmationSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'hide [Confirmation]' must be used within a ConfirmationProvider");
  }
  return function () {
    return dispatch(false);
  };
};
var useConfirmation = function useConfirmation() {
  return {
    isOpen: useConfirmationState(),
    show: show$2(),
    hide: hide$2()
  };
};

var Confirmation = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__Confirmation",
  componentId: "sc-qyfs0t-0"
})(["align-items:center;display:flex;font-size:16px;height:100vh;justify-content:center;position:fixed;right:0;top:0;width:100vw;z-index:10;::after{background-color:", ";bottom:0;content:'';left:0;opacity:0.8;position:absolute;right:0;top:0;z-index:-1;}"], function (_ref) {
  var blue4 = _ref.theme.blue4;
  return blue4;
});
var Inner = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__Inner",
  componentId: "sc-qyfs0t-1"
})(["background-color:", ";border-radius:", ";font-size:", ";font-family:\"Mulish\",sans-serif;line-height:1.4;max-width:", ";padding:", ";text-align:center;width:100%;"], function (_ref2) {
  var white = _ref2.theme.white;
  return white;
}, 4 / 14 + "em", 14 / 16 + "em", 360 / 14 + "em", 16 / 14 + "em");
var Buttons = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Buttons",
  componentId: "sc-qyfs0t-2"
})(["display:flex;flex-wrap:nowrap;margin:0 ", ";padding:", " 0 0;"], "-" + 8 / 14 + "em", 16 / 14 + "em");
var Column$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-qyfs0t-3"
})(["display:flex;flex:1;padding:0 ", ";"], 8 / 14 + "em");
var Button$1 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Button",
  componentId: "sc-qyfs0t-4"
})(["align-items:center;border-radius:", ";display:flex;flex:1;font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;height:", ";justify-content:center;line-height:1;text-transform:uppercase;"], 25 / 15 + "em", 15 / 14 + "em", 50 / 15 + "em");

var Confirmation$1 = function Confirmation$1(_ref) {
  var children = _ref.children,
    onConfirm = _ref.onConfirm;
  var _useConfirmation = useConfirmation(),
    isOpen = _useConfirmation.isOpen,
    hide = _useConfirmation.hide;
  var ref = useRef(null);
  var _onCancel = useCallback(function () {
    hide();
  }, [hide]);
  var _onConfirm = useCallback(function () {
    onConfirm();
    hide();
  }, [onConfirm, hide]);
  useOnClickOutside(ref, _onCancel);
  return React.createElement(AnimatePresence, null, isOpen && React.createElement(Confirmation, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React.createElement(Inner, {
    ref: ref,
    initial: {
      y: -100,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: -100,
      opacity: 0
    }
  }, children, React.createElement(Buttons, null, React.createElement(Column$1, null, React.createElement(Button$1, {
    onClick: _onCancel
  }, intl.get('account_withdrawal_confirmationCancel') || 'Nie')), React.createElement(Column$1, null, React.createElement(Button$1, {
    onClick: _onConfirm
  }, intl.get('account_withdrawal_confirmationConfirm') || 'TAK'))))));
};

var initializeProviderPayment = function initializeProviderPayment(_ref) {
  var providerId = _ref.providerId,
    transactionAmount = _ref.transactionAmount,
    transactionCurrency = _ref.transactionCurrency;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, getState) {
      var _yield$initializePaym, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return initializePayment(getSession(getState()))({
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            });
          case 3:
            _yield$initializePaym = _context.sent;
            data = _yield$initializePaym.data;
            return _context.abrupt("return", data == null ? void 0 : data.data);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              success: false
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var processProviderPayment = function processProviderPayment(_ref3) {
  var bank = _ref3.bank,
    providerId = _ref3.providerId,
    security = _ref3.security,
    transactionAmount = _ref3.transactionAmount,
    transactionCurrency = _ref3.transactionCurrency;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var session, _yield$dispatch, success, responseCode, _yield$processPayment, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            session = getSession(getState());
            _context2.next = 4;
            return dispatch(initializeProviderPayment({
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }));
          case 4:
            _yield$dispatch = _context2.sent;
            success = _yield$dispatch.success;
            responseCode = _yield$dispatch.responseCode;
            if (success) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", {
              success: success,
              responseCode: responseCode
            });
          case 9:
            _context2.next = 11;
            return processPayment(session)({
              bank: bank,
              providerId: providerId,
              security: security,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            });
          case 11:
            _yield$processPayment = _context2.sent;
            data = _yield$processPayment.data;
            updateCustomerDataBalance(session)();
            return _context2.abrupt("return", data == null ? void 0 : data.data);
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {
              success: false
            });
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 17]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var cancelCustomerBonuses = function cancelCustomerBonuses(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", http2.get("/rest/public/offers/creditbonus/cancel/all", session));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};

var cancelCustomerBonuses$1 = function cancelCustomerBonuses$1() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_, getState) {
      var _yield$cancelCustomer, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return cancelCustomerBonuses(getSession(getState()))();
          case 2:
            _yield$cancelCustomer = _context3.sent;
            data = _yield$cancelCustomer.data;
            return _context3.abrupt("return", !!(data != null && data.data.active.length));
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var Pattern = function Pattern() {};
Pattern.transactionAmount = /^[0-9]+([,.]([0-9]{1,2})){0,1}$/;
var MIN_TRANSACTION_AMOUNT = 0.01;
var Register = {
  transactionAmount: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern.transactionAmount,
      message: "validateMsg_pattern"
    },
    validate: {
      min: function min(value) {
        return Number(value.replace(/,/g, ".")) >= MIN_TRANSACTION_AMOUNT || "validateMsg_transactionAmount_minAmountValue";
      }
    }
  },
  securityToken: {
    required: "validateMsg_required"
  },
  accountNumber: {
    required: "validateMsg_required"
  }
};
var providerId = 20;

var _templateObject, _templateObject2, _templateObject3;
var Display = /*#__PURE__*/_styled.button.attrs({
  type: "button"
}).withConfig({
  displayName: "indexstyled__Display",
  componentId: "sc-taxthe-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";cursor:pointer;display:flex;flex-wrap:nowrap;font-family:inherit;font-size:inherit;height:", ";margin:0;overflow:hidden;padding:0;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out;width:100%;:hover,:focus{background-color:", ";border:1px solid ", ";outline:none;}@media ", "{font-family:\"Open Sans\",sans-serif;background-color:", ";height:", ";border-radius:", ";border:0;color:", ";:hover,:focus{background-color:", ";border:0;}}"], function (_ref) {
  var blue0 = _ref.theme.blue0;
  return blue0;
}, function (_ref2) {
  var grey6 = _ref2.theme.grey6;
  return grey6;
}, 4 / 16 + "em", 64 / 16 + "em", function (_ref3) {
  var blue0 = _ref3.theme.blue0;
  return darken(0.01, blue0);
}, function (_ref4) {
  var grey6 = _ref4.theme.grey6;
  return darken(0.1, grey6);
}, devices.mobile, function (_ref5) {
  var grey7 = _ref5.theme.grey7;
  return grey7;
}, 41 / 16 + "em", 7 / 16 + "em", function (_ref6) {
  var blue6 = _ref6.theme.blue6;
  return blue6;
}, function (_ref7) {
  var grey7 = _ref7.theme.grey7;
  return darken(0.01, grey7);
});
var Inner$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Inner",
  componentId: "sc-taxthe-1"
})(["align-items:center;color:", ";display:flex;flex-direction:column;flex-grow:1;height:100%;justify-content:center;text-transform:uppercase;@media ", "{align-items:start;padding:1rem;}"], function (_ref8) {
  var blue4 = _ref8.theme.blue4;
  return blue4;
}, devices.mobile);
var Chevron = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__Chevron",
  componentId: "sc-taxthe-2"
})(["align-items:center;background-color:", ";border-left:1px solid ", ";display:flex;flex-basis:", ";flex-shrink:0;height:100%;justify-content:center;max-width:", ";position:relative;::after{border-bottom:2px solid ", ";border-right:2px solid ", ";content:\"\";height:", ";position:absolute;transform:rotate(45deg) scale(1,1);transition:transform 0.15s ease-in-out;width:", ";}@media ", "{background-color:", ";border-left:0;color:", ";opacity:0.4;font-size:", ";padding:", ";padding-right:", ";::after{width:0;height:0;border-style:solid;border-width:", " ", " 0 ", ";border-color:", " transparent transparent transparent;font-size:", ";transform:none;transition:none;}}"], function (_ref9) {
  var white = _ref9.theme.white;
  return white;
}, function (_ref10) {
  var grey6 = _ref10.theme.grey6;
  return grey6;
}, 50 / 16 + "em", 50 / 16 + "em", function (_ref11) {
  var blue4 = _ref11.theme.blue4;
  return blue4;
}, function (_ref12) {
  var blue4 = _ref12.theme.blue4;
  return blue4;
}, 12 / 16 + "em", 12 / 16 + "em", devices.mobile, function (_ref13) {
  var grey7 = _ref13.theme.grey7;
  return grey7;
}, function (_ref14) {
  var blue6 = _ref14.theme.blue6;
  return blue6;
}, 6 / 16 + "em", 16 / 16 + "em", 48 / 16 + "em", 10 / 16 + "em", 10 / 16 + "em", 10 / 16 + "em", function (_ref15) {
  var blue4 = _ref15.theme.blue4;
  return blue4;
}, 24 / 16 + "em");
var Label$1 = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__Label",
  componentId: "sc-taxthe-3"
})(["font-size:", ";"], 12 / 16 + "em");
var SelectedOption = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__SelectedOption",
  componentId: "sc-taxthe-4"
})(["font-size:", ";font-weight:500;@media ", "{font-size:", ";font-weight:600;}"], 18 / 16 + "em", devices.mobile, 12 / 16 + "em");
var List = /*#__PURE__*/_styled.ul.withConfig({
  displayName: "indexstyled__List",
  componentId: "sc-taxthe-5"
})(["border:1px solid ", ";border-top:0;border-radius:", ";border-top-left-radius:0;border-top-right-radius:0;left:0;list-style:none;margin:0;opacity:0;overflow:hidden;padding:0;pointer-events:none;position:absolute;right:0;top:100%;transform:translateY(", ");transition:opacity 0.15s ease-in-out,transform 0.15s ease-in-out;z-index:-1;"], function (_ref16) {
  var grey6 = _ref16.theme.grey6;
  return grey6;
}, 4 / 16 + "em", "-" + 48 / 16 + "em");
var Item = /*#__PURE__*/_styled.li.withConfig({
  displayName: "indexstyled__Item",
  componentId: "sc-taxthe-6"
})(["& + &{border-top:1px solid ", ";}"], function (_ref17) {
  var grey6 = _ref17.theme.grey6;
  return grey6;
});
var Option = /*#__PURE__*/_styled.button.attrs(function (_ref18) {
  var disabled = _ref18.disabled;
  return {
    type: "button",
    tabIndex: disabled ? -1 : 1
  };
}).withConfig({
  displayName: "indexstyled__Option",
  componentId: "sc-taxthe-7"
})(["align-items:center;background-color:", ";border:0;cursor:pointer;display:flex;font-size:", ";height:", ";justify-content:flex-start;margin:0;padding:0 0 0 ", ";width:100%;:hover,:focus{outline:none;}@media ", "{padding-left:", ";}"], function (_ref19) {
  var white = _ref19.theme.white;
  return white;
}, 14 / 16 + "em", 48 / 14 + "em", 32 / 14 + "em", devices.mobile, 12 / 16 + "em");
var Dropdown = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Dropdown",
  componentId: "sc-taxthe-8"
})(["color:", ";font-family:\"Oswald\",sans-serif;font-size:16px;position:relative;width:100%;z-index:1;", "{", "}", "{", "}", "{", "}@media ", "{margin-top:", ";}"], function (_ref20) {
  var blue4 = _ref20.theme.blue4;
  return blue4;
}, List, function (_ref21) {
  var isOpen = _ref21.isOpen;
  return isOpen && css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        opacity: 1;\n        pointer-events: all;\n        transform: translateY(0);\n      "])));
}, Display, function (_ref22) {
  var isOpen = _ref22.isOpen;
  return isOpen && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      "])));
}, Chevron, function (_ref23) {
  var isOpen = _ref23.isOpen;
  return isOpen && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        ::after {\n          transform: rotate(45deg) scale(-1, -1);\n        }\n        @media ", " {\n          ::after {\n            transform: rotate(0) scale(-1, -1);\n          }\n        }\n      "])), devices.mobile);
}, devices.mobile, 5 / 14 + "em");

var Option$1 = function Option$1(_ref) {
  var currentValue = _ref.currentValue,
    onSelect = _ref.onSelect,
    label = _ref.label,
    value = _ref.value,
    disabled = _ref.disabled;
  var isCurrent = useMemo(function () {
    return currentValue === value;
  }, [currentValue, value]);
  var onClick = useCallback(function () {
    onSelect(value);
  }, [onSelect, value]);
  return React.createElement(Option, {
    onClick: onClick,
    isCurrent: isCurrent,
    disabled: disabled
  }, label.replace(/(\d{2})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})/, "$1 $2 $3 $4 $5 $6 $7"));
};

var Dropdown$1 = function Dropdown$1(_ref) {
  var label = _ref.label,
    options = _ref.options,
    onSelect = _ref.onSelect;
  var _useState = useState(undefined),
    currentValue = _useState[0],
    setCurrentValue = _useState[1];
  var _useState2 = useState(false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var ref = useRef(null);
  var onClickOutside = function onClickOutside() {
    setIsOpen(false);
  };
  var _onSelect = function _onSelect(option) {
    onSelect(option);
    setCurrentValue(option);
  };
  var onClick = function onClick() {
    setIsOpen(!isOpen);
  };
  var currentLabel = useMemo(function () {
    var _options$filter$;
    return options == null || (_options$filter$ = options.filter(function (_ref2) {
      var value = _ref2.value;
      return value === currentValue;
    })[0]) == null ? void 0 : _options$filter$.label;
  }, [currentValue, options]);
  var formatCurrrentLabel = function formatCurrrentLabel(label) {
    if (label !== undefined) {
      label = label.replace(/(\d{2})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})\s?(\d{4})/, "$1 $2 $3 $4 $5 $6 $7");
    }
    return label;
  };
  useEffect(function () {
    var _options$, _options$2;
    onSelect(options == null || (_options$ = options[0]) == null ? void 0 : _options$.value);
    setCurrentValue(options == null || (_options$2 = options[0]) == null ? void 0 : _options$2.value);
  }, [options, setCurrentValue]);
  useOnClickOutside(ref, onClickOutside);
  return React.createElement(Dropdown, {
    ref: ref,
    onClick: onClick,
    isOpen: isOpen
  }, React.createElement(Display, null, React.createElement(Inner$1, null, React.createElement(Label$1, null, label), React.createElement(SelectedOption, null, formatCurrrentLabel(currentLabel))), React.createElement(Chevron, null)), !!options.length && React.createElement(List, null, options.map(function (option) {
    return React.createElement(Item, {
      key: option.value
    }, React.createElement(Option$1, Object.assign({
      disabled: !isOpen,
      onSelect: _onSelect
    }, option)));
  })));
};

var _templateObject$1, _templateObject2$1;
var Form$1 = /*#__PURE__*/_styled(Form).withConfig({
  displayName: "indexstyled__Form",
  componentId: "sc-18vtfm6-0"
})(["display:block;font-family:\"Oswald\",sans-serif;font-size:16px;@media ", "{font-family:\"Open Sans\",sans-serif;}"], devices.mobile);
var InputWrap = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrap",
  componentId: "sc-18vtfm6-1"
})(["align-items:center;display:flex;flex:1;flex-wrap:wrap;justify-content:center;flex-direction:column;"]);
var InputInner = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputInner",
  componentId: "sc-18vtfm6-2"
})(["position:relative;width:", ";"], 200 / 16 + "em");
var InputLabel = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__InputLabel",
  componentId: "sc-18vtfm6-3"
})(["color:", ";flex-basis:100%;font-family:inherit;font-size:", ";font-weight:500;line-height:", ";margin:", " 0 ", ";pointer-events:none;text-align:center;text-transform:uppercase;@media ", "{text-align:center;text-transform:none;font-size:", ";font-weight:600;color:", ";margin:", " 0 ", ";}"], function (_ref) {
  var blue4 = _ref.theme.blue4;
  return blue4;
}, 18 / 16 + "em", 22 / 18 + "em", 64 / 18 + "em", 18 / 18 + "em", devices.mobile, 14 / 16 + "em", function (_ref2) {
  var blue6 = _ref2.theme.blue6;
  return blue6;
}, 50 / 18 + "em", 25 / 18 + "em");
var InputLabel2 = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__InputLabel2",
  componentId: "sc-18vtfm6-4"
})(["display:none;@media ", "{display:block;text-align:center;color:", ";font-size:", ";font-weight:600;line-height:", ";margin-bottom:", ";opacity:0.6;text-transform:uppercase;}"], devices.mobile, function (_ref3) {
  var blue6 = _ref3.theme.blue6;
  return blue6;
}, 11 / 16 + "em", 13 / 11 + "em", 13 / 11 + "em");
var InputNumber$1 = /*#__PURE__*/_styled(InputNumber).attrs({
  type: 'number',
  inputMode: null,
  pattern: null
}).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-18vtfm6-5"
})(["border-radius:0;border-bottom-width:", ";font-family:inherit;font-size:", ";font-weight:500;height:", ";padding:0 0 0 ", ";text-align:center;", " @media ", "{border-radius:", ";border-width:", ";font-size:", ";font-weight:700;height:", ";box-shadow:0px 4px 13px ", ";color:", ";border-color:", ";padding-left:0;padding-right:", ";", "}"], 2 / 30 + "em", 30 / 16 + "em", 64 / 30 + "em", 2 / 30 + "em", function (_ref4) {
  var hasValue = _ref4.hasValue,
    blue5 = _ref4.theme.blue5;
  return hasValue && css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "])), blue5);
}, devices.mobile, 7 / 35 + "em", 1 / 35 + "em", 35 / 16 + "em", 59 / 35 + "em", /*#__PURE__*/rgba(68, 85, 106, 0.08), function (_ref5) {
  var blue6 = _ref5.theme.blue6;
  return blue6;
}, function (_ref6) {
  var grey8 = _ref6.theme.grey8;
  return grey8;
}, 20 / 35 + "em", function (_ref7) {
  var hasValue = _ref7.hasValue,
    grey8 = _ref7.theme.grey8;
  return hasValue && css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n        border-color: ", ";\n    "])), grey8);
});
var InputSuffix = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__InputSuffix",
  componentId: "sc-18vtfm6-6"
})(["display:none;@media ", "{display:block;color:", ";font-family:inherit;font-size:", ";font-weight:700;left:50%;pointer-events:none;position:absolute;top:0;transform:", ";}"], devices.mobile, function (_ref8) {
  var blue6 = _ref8.theme.blue6;
  return blue6;
}, 35 / 16 + "em", function (_ref9) {
  var position = _ref9.position;
  return "translateY(0%) translateY(" + (5 / 35 + "em") + ") translateX(" + position + "px)";
});
var InputError$1 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-18vtfm6-7"
})(["position:absolute;top:100%;margin:", " 0;@media ", "{position:static;}"], 2 / 12 + "em", devices.mobile);
var Submit$1 = /*#__PURE__*/_styled(Submit).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-18vtfm6-8"
})(["border-radius:", ";display:block;font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;height:", ";letter-spacing:0.16px;margin:", " auto ", ";text-transform:capitalize;width:", ";@media ", "{width:100%;margin:", " auto ", " auto;border-radius:", ";box-shadow:0px 4px 12px ", ",0px 14px 24px ", ";}}"], 25 / 15 + "em", 15 / 16 + "em", 50 / 15 + "em", 64 / 15 + "em", 56 / 15 + "em", 200 / 15 + "em", devices.mobile, 25 / 15 + "em", 32 / 15 + "em", 8 / 15 + "em", /*#__PURE__*/rgba(20, 28, 78, 0.21), /*#__PURE__*/rgba(2, 178, 83, 0.19));
var Footnote = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Footnote",
  componentId: "sc-18vtfm6-9"
})(["color:", ";font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;letter-spacing:0.12px;line-height:", ";margin:0 0 ", ";text-align:center;*{font-family:inherit;}a{color:", ";}@media ", "{font-family:\"Open Sans\",sans-serif;font-size:", ";color:", ";opacity:0.7;margin-bottom:0;br{display:none;}}"], function (_ref10) {
  var blue4 = _ref10.theme.blue4;
  return blue4;
}, 12 / 16 + "em", 15 / 12 + "em", 156 / 12 + "em", function (_ref11) {
  var red5 = _ref11.theme.red5;
  return red5;
}, devices.mobile, 9 / 16 + "em", function (_ref12) {
  var blue6 = _ref12.theme.blue6;
  return blue6;
});
var Balance = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Balance",
  componentId: "sc-18vtfm6-10"
})(["align-items:center;color:", ";display:flex;height:100%;justify-content:flex-end;@media ", "{flex-direction:column;justify-content:space-between;padding:", " 0 0 0;}"], function (_ref13) {
  var blue4 = _ref13.theme.blue4;
  return blue4;
}, devices.mobile, 28 / 16 + "em");
var BalanceLabel = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__BalanceLabel",
  componentId: "sc-18vtfm6-11"
})(["font-family:\"Mulish\",sans-serif;font-weight:600;font-size:", ";@media ", "{font-family:\"Open Sans\",sans-serif;font-size:", ";color:", ";opacity:0.7;}"], 14 / 16 + "em", devices.mobile, 12 / 16 + "em", function (_ref14) {
  var blue6 = _ref14.theme.blue6;
  return blue6;
});
var BalanceValue = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__BalanceValue",
  componentId: "sc-18vtfm6-12"
})(["font-size:", ";font-weight:500;margin:0 0 0 ", ";white-space:nowrap;@media ", "{font-size:", ";color:", ";font-weight:bold;margin:0;}"], 20 / 16 + "em", 38 / 20 + "em", devices.mobile, 23 / 16 + "em", function (_ref15) {
  var blue6 = _ref15.theme.blue6;
  return blue6;
});
var Container = /*#__PURE__*/_styled.section.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-18vtfm6-13"
})(["padding:0 ", ";width:100%;@media ", "{padding:0 ", ";width:100%;}"], 10 / 16 + "em", devices.mobile, 16 / 16 + "em");
var Row$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-18vtfm6-14"
})(["align-items:stretch;display:flex;flex-wrap:nowrap;height:100%;margin:0 ", ";@media ", "{flex-wrap:wrap;margin:0 ", ";}"], "-" + 10 / 16 + "em", devices.mobile, "-" + 5 / 16 + "em");
var Column$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-18vtfm6-15"
})(["flex:1;padding:0 ", ";@media ", "{padding:0 ", ";}"], 10 / 16 + "em", devices.mobile, 5 / 16 + "em");
var Wrapper$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-18vtfm6-16"
})(["border-bottom:1px solid ", ";padding:0 0 ", ";@media ", "{padding:0;border-bottom:0;", "{background-color:", ";padding:", " ", " ", " ", ";box-shadow:0px 4px 13px rgba(68,85,106,0.08);border-radius:", ";flex-wrap:wrap;}", "{flex-basis:100%;}}"], function (_ref16) {
  var grey6 = _ref16.theme.grey6;
  return grey6;
}, 36 / 16 + "em", devices.mobile, Row$1, function (_ref17) {
  var white = _ref17.theme.white;
  return white;
}, 10 / 16 + "em", 8 / 16 + "em", 28 / 16 + "em", 8 / 16 + "em", 10 / 16 + "em", Column$2);
var DropdownLabel = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__DropdownLabel",
  componentId: "sc-18vtfm6-17"
})(["color:", ";font-family:\"Oswald\",sans-serif;text-transform:uppercase;@media ", "{color:", ";opacity:0.5;font-size:", ";}"], function (_ref18) {
  var blue4 = _ref18.theme.blue4;
  return blue4;
}, devices.mobile, function (_ref19) {
  var blue6 = _ref19.theme.blue6;
  return blue6;
}, 10 / 16 + "em");
var Success = /*#__PURE__*/_styled.section.withConfig({
  displayName: "indexstyled__Success",
  componentId: "sc-18vtfm6-18"
})(["align-items:center;color:", ";display:flex;flex-direction:column;font-family:\"Mulish\",sans-serif;font-size:24px;font-weight:600;height:100%;justify-content:center;text-align:center;*{font-family:inherit;}@media ", "{font-family:\"Open Sans\",sans-serif;}"], function (_ref20) {
  var blue4 = _ref20.theme.blue4;
  return blue4;
}, devices.mobile);
var MissingAccount = /*#__PURE__*/_styled.section.withConfig({
  displayName: "indexstyled__MissingAccount",
  componentId: "sc-18vtfm6-19"
})(["color:", ";font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;*{color:inherit;font-family:inherit;}> span{display:block;margin:", " 0;max-width:", ";}h2{font-size:", ";font-weight:600;margin:0 0 ", ";}p{margin:0;}strong{font-weight:600;}a{color:", ";}ul{list-style:none;margin:0;padding:0;}li{margin-bottom:", ";::before{display:inline-block;content:\"\u2022\";margin-right:", ";}}@media ", "{font-family:\"Open Sans\",sans-serif;}"], function (_ref21) {
  var blue4 = _ref21.theme.blue4;
  return blue4;
}, 13 / 16 + "em", 28 / 13 + "em", 672 / 13 + "em", 15 / 13 + "em", 13 / 13 + "em", function (_ref22) {
  var red5 = _ref22.theme.red5;
  return red5;
}, 13 / 13 + "em", 10 / 13 + "em", devices.mobile);
var MissingHeading = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__MissingHeading",
  componentId: "sc-18vtfm6-20"
})(["background-color:", ";border-radius:", ";color:", ";padding:", ";width:100%;"], function (_ref23) {
  var success = _ref23.success,
    _ref23$theme = _ref23.theme,
    red5 = _ref23$theme.red5,
    green4 = _ref23$theme.green4;
  return success ? green4 : red5;
}, 4 / 13 + "em", function (_ref24) {
  var white = _ref24.theme.white;
  return white;
}, 16 / 15 + "em");
var MissingHeadingText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__MissingHeadingText",
  componentId: "sc-18vtfm6-21"
})(["font-size:", ";font-family:\"Mulish\",sans-serif;font-weight:600;margin:0;text-align:center;a{color:inherit;}@media ", "{font-family:\"Open Sans\",sans-serif;}"], 15 / 13 + "em", devices.mobile);
var SuccessHeading = /*#__PURE__*/_styled.h4.withConfig({
  displayName: "indexstyled__SuccessHeading",
  componentId: "sc-18vtfm6-22"
})(["display:flex;flex-wrap:nowrap;margin:0;"]);
var SuccessText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__SuccessText",
  componentId: "sc-18vtfm6-23"
})(["font-size:", ";margin:", " 0 0;"], 18 / 24 + "em", 28 / 24 + "em");
var SuccessIcon$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__SuccessIcon",
  componentId: "sc-18vtfm6-24"
})(["background-color:", ";border-radius:50%;height:", ";margin:0 ", " 0 0;position:relative;width:", ";::after{border-bottom:", " solid ", ";border-left:", " solid ", ";content:\"\";height:", ";position:absolute;right:50%;top:50%;transform:translate(50%,-70%) rotate(-45deg);width:", ";}"], function (_ref25) {
  var green5 = _ref25.theme.green5;
  return green5;
}, 24 / 24 + "em", 20 / 24 + "em", 24 / 24 + "em", 2 / 24 + "em", function (_ref26) {
  var white = _ref26.theme.white;
  return white;
}, 2 / 24 + "em", function (_ref27) {
  var white = _ref27.theme.white;
  return white;
}, 6 / 24 + "em", 14 / 24 + "em");

var EXTRA_SPACE = 4; //px
var useInputSuffix = function useInputSuffix(_ref) {
  var value = _ref.value,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? "14px" : _ref$fontSize,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? "Source Sans Pro" : _ref$fontFamily;
  var _useState = useState(undefined),
    position = _useState[0],
    setPosition = _useState[1];
  var canvasRef = useRef(document.createElement("canvas"));
  var _useState2 = useState(undefined),
    context = _useState2[0],
    setContext = _useState2[1];
  // Get context from canvas element
  useEffect(function () {
    setContext(canvasRef.current.getContext("2d"));
  }, [canvasRef.current, setContext]);
  // Set context's font
  useEffect(function () {
    if (!context) return;
    context.font = fontSize + " \"" + fontFamily + "\"";
  }, [context]);
  // Set actual suffix position
  useEffect(function () {
    if (!context) return;
    var _context$measureText = context.measureText(value),
      width = _context$measureText.width;
    setPosition(width ? Math.ceil(width) + EXTRA_SPACE : undefined);
  }, [value, context]);
  return position;
};

var AMOUNT = "transactionAmount";
var ACTIVE_BONUS = 47;
var Withdraw = function Withdraw(_ref) {
  var _errors$AMOUNT, _errors$AMOUNT2, _errors$AMOUNT3;
  var currencies = _ref.currencies,
    shouldWithdrawButtonBeDisabled = _ref.shouldWithdrawButtonBeDisabled;
  var _useState = useState(undefined),
    accountId = _useState[0],
    setAccountId = _useState[1];
  var _useState2 = useState(false),
    isSuccess = _useState2[0],
    setIsSuccess = _useState2[1];
  var dispatch = useDispatch();
  var _useForm = useForm(),
    register = _useForm.register,
    watch = _useForm.watch,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.errors;
  var transactionAmount = watch(AMOUNT);
  var _useBalance = useBalance(),
    balance = _useBalance.balance,
    currencyCode = _useBalance.currencyCode,
    updateBalance = _useBalance.updateBalance;
  var _useAccounts = useAccounts(),
    accounts = _useAccounts.accounts;
  var position = useInputSuffix({
    value: String(transactionAmount)
  });
  useEffect(function () {
    updateBalance();
  }, []);
  var _useNotification = useNotification(),
    showNotification = _useNotification.show,
    populateNotification = _useNotification.setData;
  var _useConfirmation = useConfirmation(),
    showConfirmation = _useConfirmation.show;
  var RegisterAmount = useMemo(function () {
    return _extends({}, Register[AMOUNT], {
      validate: {
        max: function max(value) {
          return Number(value.replace(/,/g, ".")) <= balance || "validateMsg_transactionAmount_greaterThanBalance";
        },
        notEqualZero: function notEqualZero(value) {
          return Number(value.replace(/,/g, ".")) !== 0 || "validateMsg_transactionAmount_minAmountValue";
        }
      }
    });
  }, [balance]);
  var options = useMemo(function () {
    return accounts.map(function (_ref2) {
      var value = _ref2.accountId,
        label = _ref2.accountNumber;
      return {
        label: label,
        value: value
      };
    });
  }, [accounts]);
  var account = useSelector(function (state) {
    return getAccountDetails(state, accountId);
  });
  var transactionCurrency = String(currencies);
  var processPayment = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$dispatch, success, responseCode;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return dispatch(processProviderPayment({
            bank: account,
            providerId: providerId,
            transactionAmount: transactionAmount.replace(/,/g, "."),
            transactionCurrency: transactionCurrency
          }));
        case 2:
          _yield$dispatch = _context.sent;
          success = _yield$dispatch.success;
          responseCode = _yield$dispatch.responseCode;
          return _context.abrupt("return", {
            success: success,
            responseCode: responseCode
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [account, transactionAmount, transactionCurrency]);
  var onSubmit = handleSubmit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _app$service$Auth$cus;
    var _yield$processPayment, success, responseCode;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return processPayment();
        case 2:
          _yield$processPayment = _context2.sent;
          success = _yield$processPayment.success;
          responseCode = _yield$processPayment.responseCode;
          if (!(responseCode === ACTIVE_BONUS)) {
            _context2.next = 8;
            break;
          }
          showConfirmation();
          return _context2.abrupt("return");
        case 8:
          if (success) {
            _context2.next = 12;
            break;
          }
          populateNotification({
            success: success,
            responseCode: responseCode
          });
          showNotification();
          return _context2.abrupt("return");
        case 12:
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'withdrawal',
            'withdrawal_amount': transactionAmount,
            'currency': 'PLN',
            'user_id': (_app$service$Auth$cus = app.service.Auth.customerData.userId) != null ? _app$service$Auth$cus : ''
          });
          setIsSuccess(true);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var cancelBonusesAndSubmit = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return dispatch(cancelCustomerBonuses$1());
        case 2:
          onSubmit();
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [onSubmit]);
  if (!accounts.length) {
    return React.createElement(MissingAccount, null, React.createElement(MissingHeading, null, React.createElement(MissingHeadingText, null, intl.getHTML("account_withdrawal_missingAccountError"))), intl.getHTML("account_withdrawal_missingAccount"));
  }
  return isSuccess ? React.createElement(Success, null, React.createElement(SuccessHeading, null, React.createElement(SuccessIcon$1, null), intl.get("account_withdrawal_successHeading") || "" + (process.env.NODE_ENV !== "production" ? "Dziękujemy" : "account_withdrawal_successHeading")), React.createElement(SuccessText, null, intl.get("account_withdrawal_successText") || "" + (process.env.NODE_ENV !== "production" ? "Twoja wypłata została zlecona." : "account_withdrawal_successText"))) : React.createElement(Form$1, {
    onSubmit: onSubmit,
    noValidate: true
  }, React.createElement(Confirmation$1, {
    onConfirm: cancelBonusesAndSubmit
  }, intl.getHTML("account_withdrawal_activeBonusWarning")), React.createElement(Container, null, React.createElement(Wrapper$1, null, React.createElement(Row$1, null, React.createElement(Column$2, null, React.createElement(DropdownLabel, null, intl.get("account_withdrawal_bankAccountsLabel") || "" + (process.env.NODE_ENV !== "production" ? "Twój numer konta:" : "account_withdrawal_bankAccountsLabel")), React.createElement(Dropdown$1, {
    options: options,
    onSelect: setAccountId
  })), React.createElement(Column$2, null, React.createElement(Balance, null, React.createElement(BalanceLabel, null, intl.get("account_withdrawal_balance") || "" + (process.env.NODE_ENV !== "production" ? "Dostępne środki do wypłaty:" : "account_withdrawal_balance")), React.createElement(BalanceValue, null, Number(balance).toFixed(2).replace(".", ","), " ", currencyCode))))), React.createElement(Row$1, null, React.createElement(Column$2, null, React.createElement(InputWrap, null, React.createElement(InputLabel, {
    htmlFor: "_" + AMOUNT
  }, intl.get("account_withdrawal_amountInputLabel") || "" + (process.env.NODE_ENV !== "production" ? "Wpisz kwotę swojej wypłaty" : "account_withdrawal_amountInputLabel")), React.createElement(InputLabel2, null, intl.get("account_deposit_amountInputLabel")), React.createElement(InputInner, null, React.createElement(InputNumber$1, {
    ref: register(RegisterAmount),
    name: AMOUNT,
    id: "_" + AMOUNT,
    hasValue: !!transactionAmount
  }), !!position && React.createElement(InputSuffix, {
    position: position
  }, intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix")), ((_errors$AMOUNT = errors[AMOUNT]) == null ? void 0 : _errors$AMOUNT.message) && React.createElement(InputError$1, null, intl.get((_errors$AMOUNT2 = errors[AMOUNT]) == null ? void 0 : _errors$AMOUNT2.message) || ((_errors$AMOUNT3 = errors[AMOUNT]) == null ? void 0 : _errors$AMOUNT3.message)))))), React.createElement(Row$1, null, React.createElement(Column$2, null, React.createElement(Submit$1, {
    disabled: shouldWithdrawButtonBeDisabled,
    isDisabled: shouldWithdrawButtonBeDisabled
  }, intl.get("account_withdrawal_makeWithdrawal") || "" + (process.env.NODE_ENV !== "production" ? "Wypłać" : "account_withdrawal_makeWithdrawal")))), React.createElement(Row$1, null, React.createElement(Column$2, null, React.createElement(Footnote, null, intl.getHTML("account_withdrawal_footnote"))))));
};

var _excluded = ["providerId"];
var _mapping;
var mapping = (_mapping = {}, _mapping[providerId] = Withdraw, _mapping);
var Withdraw$1 = function Withdraw(_ref) {
  var _mapping$providerId;
  var providerId = _ref.providerId,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ((_mapping$providerId = mapping[providerId]) == null ? void 0 : _mapping$providerId.call(mapping, rest)) || null;
};

var img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 28 46'%3e %3cpath fill='%23FEFEFE' d='M14.07 18.23c3.0112.0014 5.9349 1.0132 8.3028 2.8735 2.3679 1.8602 4.043 4.4612 4.7572 7.3865v.09c.1267.3178.188.6579.18 1 .0036.2259-.0233.4513-.08.67-.1349.4866-.4113.9222-.7941 1.2515-.3827.3294-.8546.5377-1.3559.5985h-.24c-.6868.0006-1.3473-.2645-1.8431-.7398s-.7885-1.124-.8169-1.8102c-.49-3.87-4.95-6.21-8.09-6.21-2.234 0-4.37673.8868-5.95738 2.4656C6.55198 27.3843 5.66265 29.526 5.66 31.76v.8c.14287 1.2276.54654 2.4105 1.18397 3.4694.63742 1.0588 1.49385 1.9691 2.51188 2.6699 1.01805.7008 2.17415 1.1758 3.39075 1.3933 1.2166.2174 2.4657.1722 3.6634-.1326 5.44-1.31 4.79-7.18 7.94-7.18.3362-.012.6715.0423.9868.16.3152.1177.6041.2963.8502.5257.2461.2294.4446.5051.5841.8112.1395.3062.2173.6369.2289.9731-.0351.4254-.1434.8415-.32 1.23-1.1178 2.9351-3.2281 5.386-5.9646 6.9272s-5.9264 2.0754-9.0157 1.5098c-3.08939-.5656-5.8831-2.1952-7.8961-4.606C1.7906 37.9003.685433 34.8607.68 31.72.65 25.47 0 12.79 0 6.42c.0026129-.31745.12988-.62116.35436-.84564C.57884 5.34988.882549 5.22262 1.2 5.22h.49c.67 0 .67.55.71 1.2l1 17.14c.14-.19.28-.37.44-.56L3.12 3.51c-.00265-.16582.02772-.33052.08935-.4845.06163-.15397.15328-.29414.26962-.41234.11634-.1182.25504-.21206.40801-.27613.15298-.06407.31717-.09705.48302-.09703.33777-.00268.6629.12826.90454.36428.24164.23602.38019.55799.38546.89572l.7 17.15.34-.23V1.27c-.00005-.16933.03377-.336963.09946-.493035s.16193-.297431.28306-.415762c.12112-.118332.26469-.211245.42225-.2732751C7.66234.0258978 7.83071-.00399656 8 .00000345c.3316.00783521.64697.14508955.87869.38241655.23173.237327.3614.555892.36131.88758v17.87c1.5292-.5991 3.1576-.9045 4.8-.9l.03-.01z'/%3e%3c/svg%3e";

var SpinnerIsOpen = /*#__PURE__*/createContext(undefined);
var SpinnerSetIsOpen = /*#__PURE__*/createContext(undefined);
var SpinnerProvider = function SpinnerProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  return React.createElement(SpinnerIsOpen.Provider, {
    value: isOpen
  }, React.createElement(SpinnerSetIsOpen.Provider, {
    value: setIsOpen
  }, children));
};
var useSpinnerState = function useSpinnerState() {
  var context = useContext(SpinnerIsOpen);
  if (context === undefined) {
    throw new Error("'useSpinnerState' must be used within a SpinnerProvider");
  }
  return context;
};
var useSpinnerDispatch = function useSpinnerDispatch() {
  var dispatch = useContext(SpinnerSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'useNotificationDispatch' must be used within a NotificationProvider");
  }
  return dispatch;
};
var show$3 = function show() {
  var dispatch = useContext(SpinnerSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'show' must be used within a NotificationProvider");
  }
  return function () {
    return dispatch(true);
  };
};
var hide$3 = function hide() {
  var dispatch = useContext(SpinnerSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'hide' must be used within a NotificationProvider");
  }
  return function () {
    return dispatch(false);
  };
};
var useSpinner = function useSpinner() {
  return {
    isOpen: useSpinnerState(),
    setIsOpen: useSpinnerDispatch(),
    show: show$3(),
    hide: hide$3()
  };
};

var _templateObject$2;
// import { devices } from "../../components/global/"
var rotate = /*#__PURE__*/keyframes(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  from {\n    transform: translate(50%, -50%) rotate(0deg);\n  }\n\n  to {\n    transform: translate(50%, -50%) rotate(360deg);\n  }\n"])));
var Spinner = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Spinner",
  componentId: "sc-3r5uj1-0"
})(["animation:", " 1s linear infinite;border:", " solid ", ";border-radius:50%;border-right-color:", ";height:", ";position:absolute;right:50%;top:50%;transform:translate(50%,-50%);width:", ";"], rotate, 8 / 16 + "em", function (_ref) {
  var white = _ref.theme.white;
  return white;
}, function (_ref2) {
  var white = _ref2.theme.white;
  return rgba(white, 0.5);
}, 140 / 16 + "em", 140 / 16 + "em");
var Overlay = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__Overlay",
  componentId: "sc-3r5uj1-1"
})(["background-color:", ";bottom:0;left:0;position:fixed;right:0;top:0;z-index:10000;"], function (_ref3) {
  var grey5 = _ref3.theme.grey5;
  return rgba(grey5, 0.6);
});
var Logo = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__Logo",
  componentId: "sc-3r5uj1-2"
})(["display:block;height:", ";position:absolute;right:50%;top:50%;transform:translate(50%,-50%);"], 64 / 16 + "em");
var Info = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Info",
  componentId: "sc-3r5uj1-3"
})(["color:", ";font-size:", ";margin:0;position:absolute;right:50%;top:50%;transform:translate(50%,-50%) ", ";"], function (_ref4) {
  var white = _ref4.theme.white;
  return white;
}, 20 / 16 + "em", "translateY(" + 80 / 16 + "em)");

var Spinner$1 = function Spinner$1() {
  var _useSpinner = useSpinner(),
    isOpen = _useSpinner.isOpen;
  return React.createElement(AnimatePresence, null, isOpen && React.createElement(Overlay, {
    key: 'spinner',
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React.createElement(Logo, {
    src: img$4
  }), React.createElement(Spinner, null), React.createElement(Info, null, intl.get("account_withdrawal_loading"))));
};

var Wrapper$2 = /*#__PURE__*/_styled.main.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-3f16tk-0"
})(["font-size:16px;height:100%;position:relative;*,*::after,*::before{box-sizing:border-box;}"]);

var Index = function Index(_ref) {
  var shouldWithdrawButtonBeDisabled = _ref.shouldWithdrawButtonBeDisabled;
  var _useProviders = useProviders(),
    payoutProviders = _useProviders.payoutProviders;
  return React.createElement(ConfirmationProvider, null, React.createElement(NotificationProvider, null, React.createElement(SpinnerProvider, null, React.createElement(Wrapper$2, null, React.createElement(Spinner$1, null), React.createElement(Notification$1, null), !!payoutProviders.length ? payoutProviders.map(function (provider) {
    return React.createElement(Withdraw$1, Object.assign({}, provider, {
      key: provider.providerId,
      shouldWithdrawButtonBeDisabled: shouldWithdrawButtonBeDisabled
    }));
  }) : null))));
};

var Container$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-xbc6ui-0"
})(["justify-content:space-evenly;align-items:center;display:flex;height:100%;"]);
var Logo$1 = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__Logo",
  componentId: "sc-xbc6ui-1"
})(["height:30px;filter:", ";@media ", "{height:22px;}"], function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? 'brightness(0) saturate(100%) invert(30%) sepia(84%) saturate(1409%) hue-rotate(196deg) brightness(88%) contrast(93%)' : 'none';
}, devices.mobile);
var Label$2 = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__Label",
  componentId: "sc-xbc6ui-2"
})(["font-family:\"Oswald\",sans-serif;font-weight:500;font-size:16px;text-transform:uppercase;line-height:0;@media ", "{font-family:\"Open Sans\",sans-serif;font-weight:700;font-size:12px;}"], devices.mobile);

var Header = /*#__PURE__*/_styled.header.withConfig({
  displayName: "indexstyled__Header",
  componentId: "sc-a3iyiz-0"
})(["gap:35px;justify-content:center;display:flex;@media ", "{gap:10px;margin:0 10px;}"], devices.mobile);
var Tab = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Tab",
  componentId: "sc-a3iyiz-1"
})(["height:5.55rem;width:24.25rem;margin:35px 0;border:", ";border-radius:5px;padding:0.5rem;background-color:#e6eaf0;color:", ";@media ", "{margin:0;margin-bottom:15px;border-radius:7px;height:3.25rem;width:14.25rem;}:hover,:focus{background-color:#e6eaf0;color:", ";}", "{filter:", ";}"], function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? "2px solid #1b64c4" : "none";
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? "#1b64c4" : "#7a87aa";
}, devices.mobile, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? "#1b64c4" : "#7a87aa";
}, Logo$1, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? 'brightness(0) saturate(100%) invert(30%) sepia(84%) saturate(1409%) hue-rotate(196deg) brightness(88%) contrast(93%)' : 'none';
});
var TabsItem = /*#__PURE__*/_styled.section.withConfig({
  displayName: "indexstyled__TabsItem",
  componentId: "sc-a3iyiz-2"
})([""]);

/**
 * Sets first child as open by default
 */
var Header$1 = function Header$1(_ref) {
  var children = _ref.children;
  var isSingleChild = Children.count(children) === 1;
  // Decorate children with isInitOpen prop
  var _children = Children.toArray(children).map(function (child, index) {
    return cloneElement(child, {
      isInitOpen: !index,
      isSingleChild: isSingleChild
    });
  });
  return React.createElement(Header, null, _children);
};

var TabState = /*#__PURE__*/createContext(undefined);
var TabDispatch = /*#__PURE__*/createContext(undefined);
var Tabs = function Tabs(_ref) {
  var initialIndex = _ref.initialIndex,
    children = _ref.children;
  var _useState = useState(initialIndex),
    state = _useState[0],
    setState = _useState[1];
  return React.createElement(TabState.Provider, {
    value: state
  }, React.createElement(TabDispatch.Provider, {
    value: setState
  }, children));
};
var useTabState = function useTabState() {
  return useContext(TabState);
};
var useTabDispatch = function useTabDispatch() {
  var context = useContext(TabDispatch);
  if (context === undefined) {
    throw new Error("useTabDispatch must be used within Tabs");
  }
  return context;
};

var Item$1 = function Item(_ref) {
  var children = _ref.children,
    index = _ref.index;
  var isActive = index === useTabState();
  return isActive ? React.createElement(TabsItem, null, children) : null;
};

var Tab$1 = function Tab$1(_ref) {
  var children = _ref.children,
    index = _ref.index,
    isInitOpen = _ref.isInitOpen,
    isSingleChild = _ref.isSingleChild;
  var setTab = useTabDispatch();
  var tabState = useTabState();
  var isActive = index === tabState;
  var onClick = useCallback(function () {
    setTab(index);
  }, [index, setTab]);
  // Set current tab on init
  useEffect(function () {
    !!isInitOpen && !tabState && setTab(index);
  }, [isInitOpen, setTab, index]);
  if (isSingleChild) return null;
  return React.createElement(Tab, {
    isActive: isActive,
    onClick: onClick
  }, children);
};

var Tabs$1 = {};
Tabs$1.Header = Header$1;
Tabs$1.Tab = Tab$1;
Tabs$1.Item = Item$1;
Tabs$1.Wrapper = Tabs;

var initializeProviderPayment$1 = function initializeProviderPayment(_ref) {
  var callbackUrl = _ref.callbackUrl,
    customer = _ref.customer,
    providerId = _ref.providerId,
    transactionAmount = _ref.transactionAmount,
    transactionCurrency = _ref.transactionCurrency;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, getState) {
      var _yield$initializePaym, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initializePayment(getSession(getState()))({
              callbackUrl: callbackUrl,
              customer: customer,
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            });
          case 2:
            _yield$initializePaym = _context.sent;
            data = _yield$initializePaym.data;
            return _context.abrupt("return", data == null ? void 0 : data.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var processProviderPayment$1 = function processProviderPayment(_ref3) {
  var accountId = _ref3.accountId,
    additionalData = _ref3.additionalData,
    callbackUrl = _ref3.callbackUrl,
    card = _ref3.card,
    providerId = _ref3.providerId,
    transactionAmount = _ref3.transactionAmount,
    transactionCurrency = _ref3.transactionCurrency,
    voucherCode = _ref3.voucherCode;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_, getState) {
      var _data$data, _data$data2, _data$data3;
      var _yield$processPayment, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return processPayment(getSession(getState()))({
              accountId: accountId,
              additionalData: additionalData,
              callbackUrl: callbackUrl,
              card: card,
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency,
              voucherCode: voucherCode
            });
          case 2:
            _yield$processPayment = _context2.sent;
            data = _yield$processPayment.data;
            !!(data != null && (_data$data = data.data) != null && _data$data.success) && !!(data != null && (_data$data2 = data.data) != null && _data$data2.externalRequestUrl) && window.location.assign(data == null || (_data$data3 = data.data) == null ? void 0 : _data$data3.externalRequestUrl);
            // !!data?.data?.success && await startTransfer(data?.data?.transactionId)
            return _context2.abrupt("return", data == null ? void 0 : data.data);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var providerId$1 = 231;

var PaymentAction = /*#__PURE__*/createContext(undefined);

var initialState$2 = {
  transactionAmount: '',
  transactionCurrency: ''
};
var transaction = /*#__PURE__*/createSlice({
  name: "Transaction",
  initialState: initialState$2,
  reducers: {
    setTransactionAmount: function setTransactionAmount(state, _ref) {
      var payload = _ref.payload;
      state.transactionAmount = payload.replace(/,/g, ".");
    },
    setTransactionCurrency: function setTransactionCurrency(state, _ref2) {
      var payload = _ref2.payload;
      state.transactionCurrency = payload;
    }
  }
});
var _transaction$actions = transaction.actions,
  setTransactionAmount = _transaction$actions.setTransactionAmount,
  setTransactionCurrency = _transaction$actions.setTransactionCurrency;
var transaction$1 = transaction.reducer;

var getTransaction = function getTransaction(_ref) {
  var transaction = _ref.transaction;
  return transaction;
};
var getTransactionAmount = /*#__PURE__*/createSelector(getTransaction, function (_ref2) {
  var transactionAmount = _ref2.transactionAmount;
  return transactionAmount;
});
var getTransactionCurrency = /*#__PURE__*/createSelector(getTransaction, function (_ref3) {
  var transactionCurrency = _ref3.transactionCurrency;
  return transactionCurrency;
});
var getIsTransactionAmountValid = /*#__PURE__*/createSelector(getTransaction, function (_ref4) {
  var transactionAmount = _ref4.transactionAmount;
  return Number(transactionAmount) > 0;
});

var useTransaction = function useTransaction() {
  var dispatch = useDispatch();
  var transactionAmount = useSelector(getTransactionAmount);
  var isTransactionAmountValid = useSelector(getIsTransactionAmountValid);
  var transactionCurrency = useSelector(getTransactionCurrency);
  var updateTransactionAmount = useCallback(function (amount) {
    dispatch(setTransactionAmount(amount));
  }, [dispatch]);
  var updateTransactionCurrency = useCallback(function (currency) {
    dispatch(setTransactionCurrency(currency));
  }, [dispatch]);
  return {
    transactionAmount: transactionAmount,
    isTransactionAmountValid: isTransactionAmountValid,
    transactionCurrency: transactionCurrency,
    updateTransactionAmount: updateTransactionAmount,
    updateTransactionCurrency: updateTransactionCurrency
  };
};

var banksAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var bankId = _ref.bankId;
    return bankId;
  }
});
var fetchBanks = /*#__PURE__*/createAsyncThunk("Banks/FetchBanks", /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(providerId, _ref2) {
    var getState, rejectWithValue, _yield$getProviderBan, data, _yield$getBanks, _data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
          if (!providerId) {
            _context.next = 9;
            break;
          }
          _context.next = 4;
          return getProviderBanks(getState().session)(providerId);
        case 4:
          _yield$getProviderBan = _context.sent;
          data = _yield$getProviderBan.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(banksAdapter.getInitialState()));
        case 9:
          _context.next = 11;
          return getBanks(getState().session)();
        case 11:
          _yield$getBanks = _context.sent;
          _data = _yield$getBanks.data;
          return _context.abrupt("return", (_data == null ? void 0 : _data.data) || rejectWithValue(banksAdapter.getInitialState()));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var banks = /*#__PURE__*/createSlice({
  name: "Banks",
  initialState: /*#__PURE__*/banksAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchBanks.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      banksAdapter.setAll(state, payload);
    });
  }
});
var banks$1 = banks.reducer;

var _banksAdapter$getSele = /*#__PURE__*/banksAdapter.getSelectors(function (_ref) {
    var banks = _ref.banks;
    return banks;
  }),
  selectAll$2 = _banksAdapter$getSele.selectAll;

var Container$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-1sy2iip-0"
})(["overflow:hidden;padding:1.25em;"]);
var Row$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-1sy2iip-1"
})(["display:flex;flex-wrap:wrap;margin:-1em;padding:1em;"]);
var BankItem = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__BankItem",
  componentId: "sc-1sy2iip-2"
})(["flex-basis:16.666%;padding:.25em;width:16.666%;"]);
var Bank = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Bank",
  componentId: "sc-1sy2iip-3"
})(["align-items:center;background-color:transparent;box-shadow:", ";display:flex;height:2.5em;justify-content:center;padding:0.125em;position:relative;width:100%;::after{border:", ";bottom:0;content:\"\";left:0;opacity:0;position:absolute;right:0;top:0;transition:opacity 0.15s linear;}:hover,:focus{background-color:transparent;::after{opacity:1;}}"], function (_ref) {
  var black = _ref.theme.black;
  return "0 .188em .375em 0 " + rgba(black, 0.08);
}, function (_ref2) {
  var green2 = _ref2.theme.green2;
  return "0.125em solid  " + green2;
});
var BankImage = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__BankImage",
  componentId: "sc-1sy2iip-4"
})(["max-height:100%;max-width:100%;object-fit:contain;"]);
var Subheading = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Subheading",
  componentId: "sc-1sy2iip-5"
})(["color:", ";font-size:", ";font-weight:600;margin:0 auto ", ";text-align:center;"], function (_ref3) {
  var green1 = _ref3.theme.green1;
  return green1;
}, 12 / 16 + "em", "" + 20 / 12);
var Footnote$1 = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Footnote",
  componentId: "sc-1sy2iip-6"
})(["color:", ";font-size:", ";margin:", " auto 0;20px"], function (_ref4) {
  var lightGreen3 = _ref4.theme.lightGreen3;
  return lightGreen3;
}, 10 / 16 + "em", 20 / 10 + "em");

var BankItem$1 = function BankItem$1(_ref) {
  var bankId = _ref.bankId,
    bankName = _ref.bankName;
  var processPayment = useContext(PaymentAction);
  var onClick = useCallback(function () {
    !!processPayment && processPayment(bankId);
  }, [bankId, processPayment]);
  return React.createElement(BankItem, null, React.createElement(Bank, {
    onClick: onClick
  }, React.createElement(BankImage, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payment/banks/bank-" + bankId + ".png",
    alt: bankName
  })));
};

// @ts-nocheck
var queryOptions$2 = {
  refetchOnWindowFocus: false
};
var Banks = function Banks(_ref) {
  var providerId = _ref.providerId;
  var _useBanks = useBanks(providerId),
    banks = _useBanks.banks;
  return React.createElement(Container$2, null, React.createElement(Subheading, null, intl.get("payment_bankListTitle")), React.createElement(Row$2, null, !!banks && banks.map(function (_ref2) {
    var bankId = _ref2.bankId,
      bankName = _ref2.bankName;
    return React.createElement(BankItem$1, {
      key: bankId,
      bankId: bankId,
      bankName: bankName
    });
  })), React.createElement(Footnote$1, null, intl.getHTML("payment_bankListAdministrationData")));
};
var useBanks = function useBanks(providerId) {
  var dispatch = useDispatch();
  var banks = useSelector(selectAll$2);
  var banksFetcher = useCallback(function () {
    return dispatch(fetchBanks(providerId));
  }, [dispatch, providerId]);
  useQuery("banks", banksFetcher, queryOptions$2);
  return {
    banks: banks
  };
};

var Deposit = function Deposit(_ref) {
  var currencies = _ref.currencies;
  var dispatch = useDispatch();
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount;
  var transactionCurrency = String(currencies);
  var processPayment = function processPayment(accountId) {
    return dispatch(processProviderPayment$1({
      accountId: accountId,
      providerId: providerId$1,
      callbackUrl: "http://localhost:1234",
      transactionAmount: transactionAmount,
      transactionCurrency: transactionCurrency
    }));
  };
  return React.createElement(PaymentAction.Provider, {
    value: processPayment
  }, React.createElement(Banks, {
    providerId: providerId$1
  }));
};

var providerId$2 = 233;

var Pattern$1 = function Pattern() {};
Pattern$1.blik = /[0-9]{6}/;
var Register$1 = {
  voucherCode: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$1.blik,
      message: "validateMsg_pattern"
    },
    minLength: {
      value: 6,
      message: "validateMsg_minLength"
    },
    maxLength: 6
  },
  saveBlik: {},
  acceptBlikRules: {
    required: "validateMsg_required"
  }
};

var Header$2 = /*#__PURE__*/_styled.header.withConfig({
  displayName: "indexstyled__Header",
  componentId: "sc-x6mmzq-0"
})(["align-items:center;color:", ";display:flex;font-size:", ";font-weight:600;justify-content:flex-start;"], function (_ref) {
  var green1 = _ref.theme.green1;
  return green1;
}, 12 / 16 + "em");
var HeaderImage = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__HeaderImage",
  componentId: "sc-x6mmzq-1"
})(["display:block;height:", ";margin:0 ", " 0 0;"], 42 / 12 + "em", 16 / 12 + "em");
var InputWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrapper",
  componentId: "sc-x6mmzq-2"
})(["margin:1.25em 0;"]);
var CheckboxLabel = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__CheckboxLabel",
  componentId: "sc-x6mmzq-3"
})(["font-size:.625em;line-height:1.25em;"]);
var Form$2 = /*#__PURE__*/_styled(Form).withConfig({
  displayName: "indexstyled__Form",
  componentId: "sc-x6mmzq-4"
})(["margin:0 auto;max-width:21em;padding:1.25em 0;width:100%;"]);
var InputNumber$2 = /*#__PURE__*/_styled(InputNumber).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-x6mmzq-5"
})(["font-size:.875em;"]);
var InputError$2 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-x6mmzq-6"
})(["font-size:.625em;margin-top:.25em;"]);
var Label$3 = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__Label",
  componentId: "sc-x6mmzq-7"
})(["background-color:", ";border-bottom:", ";color:", ";font-size:", ";margin:", " auto ", ";padding:", " ", " 0;", "{background-color:transparent;height:2em;padding:0;}"], function (_ref2) {
  var inputBackground = _ref2.theme.inputBackground;
  return inputBackground;
}, function (_ref3) {
  var green3 = _ref3.theme.green3;
  return "1px solid " + rgba(green3, 0.3);
}, function (_ref4) {
  var green2 = _ref4.theme.green2;
  return green2;
}, 10 / 16 + "em", 16 / 10 + "em", 20 / 10 + "em", 10 / 10 + "em", 12 / 10 + "em", InputNumber$2);
var Link = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Link",
  componentId: "sc-x6mmzq-8"
})(["background-color:transparent;color:", ";display:block;font-size:", ";font-weight:700;margin:", " auto 0;padding:0;text-transform:uppercase;:hover,:focus{background-color:transparent;}"], function (_ref5) {
  var green1 = _ref5.theme.green1;
  return green1;
}, 12 / 16 + "em", 20 / 12 + "em");

var Blik = function Blik(_ref) {
  var _errors$voucherCode, _errors$voucherCode2, _errors$voucherCode3, _errors$acceptBlikRul, _errors$acceptBlikRul2, _errors$acceptBlikRul3;
  var processPayment = _ref.processPayment,
    isSavedBlik = _ref.isSavedBlik;
  var _useForm = useForm(),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.errors;
  var _useState = useState(),
    isFormHidden = _useState[0],
    setIsFormHidden = _useState[1];
  var onSubmit = handleSubmit(function (_ref2) {
    var voucherCode = _ref2.voucherCode,
      saveBlik = _ref2.saveBlik,
      acceptBlikRules = _ref2.acceptBlikRules;
    processPayment({
      voucherCode: voucherCode,
      additionalData: JSON.stringify({
        saveBlikAlias: String(saveBlik),
        regulationAccept: String(acceptBlikRules)
      })
    });
  });
  // isSavedBlik comes from API, thus usage of useEffect
  // as it might change during render
  useEffect(function () {
    setIsFormHidden(isSavedBlik);
  }, [setIsFormHidden, isSavedBlik]);
  return React.createElement(Form$2, {
    onSubmit: onSubmit
  }, React.createElement(Header$2, null, React.createElement(HeaderImage, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/blik.png",
    alt: 'BLIK logo'
  }), intl.get("payment_blikHeader") || "payment_blikHeader"), !isFormHidden && React.createElement(React.Fragment, null, React.createElement(Label$3, null, intl.get("payment_depositBlik") || "payment_depositBlik", React.createElement(InputNumber$2, {
    ref: register(Register$1.voucherCode),
    name: 'voucherCode'
  }), ((_errors$voucherCode = errors["voucherCode"]) == null ? void 0 : _errors$voucherCode.message) && React.createElement(InputError$2, null, intl.get((_errors$voucherCode2 = errors["voucherCode"]) == null ? void 0 : _errors$voucherCode2.message) || ((_errors$voucherCode3 = errors["voucherCode"]) == null ? void 0 : _errors$voucherCode3.message))), React.createElement(Checkbox, {
    id: 'saveBlik',
    name: 'saveBlik',
    ref: register(Register$1.saveBlik)
  }), React.createElement(CheckboxLabel, {
    htmlFor: 'saveBlik'
  }, intl.get("payment_paymentBlik_saveBlik") || "payment_paymentBlik_saveBlik")), React.createElement(InputWrapper, null, React.createElement(Checkbox, {
    id: 'acceptBlikRules',
    name: 'acceptBlikRules',
    ref: register(Register$1.acceptBlikRules),
    isValid: !!!errors.acceptBlikRules
  }), React.createElement(CheckboxLabel, {
    htmlFor: 'acceptBlikRules'
  }, intl.get("payment_paymentBlik_acceptBlikRules") || "payment_paymentBlik_acceptBlikRules"), ((_errors$acceptBlikRul = errors["acceptBlikRules"]) == null ? void 0 : _errors$acceptBlikRul.message) && React.createElement(InputError$2, null, intl.get((_errors$acceptBlikRul2 = errors["acceptBlikRules"]) == null ? void 0 : _errors$acceptBlikRul2.message) || ((_errors$acceptBlikRul3 = errors["acceptBlikRules"]) == null ? void 0 : _errors$acceptBlikRul3.message))), React.createElement(Submit, null, intl.get("payment_depositBlikAccept") || "payment_depositBlikAccept"), isSavedBlik && isFormHidden && React.createElement(Link, {
    onClick: function onClick() {
      return setIsFormHidden(false);
    }
  }, intl.get("payment_paymentBlik_changeBlikButton") || "payment_paymentBlik_changeBlikButton"), !isFormHidden && React.createElement(Link, {
    onClick: function onClick() {
      return processPayment({});
    }
  }, intl.get("payment_paymentBlik_useSavedBlikButton") || "payment_paymentBlik_useSavedBlikButton"));
};

var Deposit$1 = function Deposit(_ref) {
  var currencies = _ref.currencies;
  var dispatch = useDispatch();
  var _useState = useState(),
    hash = _useState[0],
    setHash = _useState[1];
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount;
  var transactionCurrency = String(currencies);
  var processPayment = function processPayment(_ref2) {
    var voucherCode = _ref2.voucherCode,
      additionalData = _ref2.additionalData;
    return dispatch(processProviderPayment$1({
      additionalData: additionalData,
      callbackUrl: "http://localhost:1234",
      providerId: providerId$2,
      transactionAmount: transactionAmount,
      transactionCurrency: transactionCurrency,
      voucherCode: voucherCode
    }));
  };
  useEffect(function () {
    var initPayment = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$dispatch, additionalResponseText;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(initializeProviderPayment$1({
                callbackUrl: "http://localhost:1234",
                customer: {
                  email: "rafal.bednarz@sb-betting.com"
                },
                providerId: providerId$2,
                transactionAmount: transactionAmount,
                transactionCurrency: transactionCurrency
              }));
            case 2:
              _yield$dispatch = _context.sent;
              additionalResponseText = _yield$dispatch.additionalResponseText;
              setHash(additionalResponseText);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function initPayment() {
        return _ref3.apply(this, arguments);
      };
    }();
    initPayment();
  }, [dispatch, setHash]);
  return React.createElement(Blik, {
    processPayment: processPayment,
    isSavedBlik: !!hash
  });
};

var providerId$3 = 232;

var Deposit$2 = function Deposit(_ref) {
  var currencies = _ref.currencies;
  var dispatch = useDispatch();
  var transactionCurrency = String(currencies);
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount;
  var processPayment = function processPayment(accountId) {
    return dispatch(processProviderPayment$1({
      accountId: accountId,
      providerId: providerId$3,
      callbackUrl: "http://localhost:1234",
      transactionAmount: transactionAmount,
      transactionCurrency: transactionCurrency
    }));
  };
  return React.createElement(PaymentAction.Provider, {
    value: processPayment
  }, React.createElement(Banks, {
    providerId: providerId$3
  }));
};

var providerId$4 = 274;

var initialState$3 = [];
var fetchCards = /*#__PURE__*/createAsyncThunk("Cards/FetchCards", /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(providerId, _ref) {
    var getState, rejectWithValue, _yield$getProviderCar, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.next = 3;
          return getProviderCards(getState().session)(providerId);
        case 3:
          _yield$getProviderCar = _context.sent;
          data = _yield$getProviderCar.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(initialState$3));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var cards = /*#__PURE__*/createSlice({
  name: "Cards",
  initialState: initialState$3,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchCards.fulfilled, function (_, _ref3) {
      var payload = _ref3.payload;
      return payload;
    });
  }
});
var cards$1 = cards.reducer;
var removeCard = function removeCard(_ref4) {
  var defaultCard = _ref4.defaultCard,
    creditCardId = _ref4.creditCardId;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_, getState) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", updateCreditCard(getSession(getState()))({
              activeCard: defaultCard,
              creditCardId: creditCardId
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var saveCard = function saveCard(_ref6) {
  var fullCardHolderName = _ref6.cardHolder,
    providerId = _ref6.providerId,
    transactionAmount = _ref6.transactionAmount,
    transactionCurrency = _ref6.transactionCurrency,
    transactionId = _ref6.transactionId;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_, getState) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", saveCreditCard(getSession(getState()))({
              card: {
                fullCardHolderName: fullCardHolderName,
                defaultCard: true
              },
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency,
              transactionId: transactionId
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var getCards = function getCards(_ref) {
  var cards = _ref.cards;
  return cards;
};
var getCardsList = /*#__PURE__*/createSelector(getCards, function (cards) {
  return cards;
});

var _templateObject$3;
var Heading$1 = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Heading",
  componentId: "sc-qs5enx-0"
})(["align-items:center;border-bottom:", ";color:", ";display:flex;font-size:", ";font-weight:600;justify-content:space-between;margin:0 auto;padding:0 0 ", ";max-width:", ";"], function (_ref) {
  var grey1 = _ref.theme.grey1;
  return "1px solid " + grey1;
}, function (_ref2) {
  var green3 = _ref2.theme.green3;
  return green3;
}, 14 / 16 + "em", 12 / 14 + "em", 336 / 14 + "em");
var HeadingBig = /*#__PURE__*/_styled(Heading$1).withConfig({
  displayName: "indexstyled__HeadingBig",
  componentId: "sc-qs5enx-1"
})(["padding:", " 0;", " &:first-child{padding-top:0;}"], 20 / 14 + "em", function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen && css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n      border: 0;\n    "])));
});
var Hidden = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Hidden",
  componentId: "sc-qs5enx-2"
})(["display:", ";padding:0 calc(50% - 21em / 2);p,label,input,button{display:none;}a{color:", ";display:block;font-size:", ";font-weight:700;margin-top:", ";text-align:center;text-decoration:none;text-transform:uppercase;}"], function (_ref4) {
  var isVisible = _ref4.isVisible;
  return isVisible ? "block" : "none";
}, function (_ref5) {
  var green1 = _ref5.theme.green1;
  return green1;
}, 12 / 16 + "em", 20 / 12 + "em");
var Card = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Card",
  componentId: "sc-qs5enx-3"
})(["color:", ";"], function (_ref6) {
  var isCurrent = _ref6.isCurrent,
    _ref6$theme = _ref6.theme,
    green3 = _ref6$theme.green3,
    green1 = _ref6$theme.green1;
  return isCurrent ? green3 : rgba(green1, 0.6);
});
var CardBar = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__CardBar",
  componentId: "sc-qs5enx-4"
})(["align-items:center;border-bottom:", ";display:flex;flex-wrap:nowrap;justify-content:space-between;margin:0 auto;max-width:21em;padding:0.75em 0;"], function (_ref7) {
  var isOpen = _ref7.isOpen,
    grey1 = _ref7.theme.grey1;
  return "1px solid " + (isOpen ? "transparent" : grey1);
});
var CardDetails = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__CardDetails",
  componentId: "sc-qs5enx-5"
})(["color:", ";overflow-y:scroll;padding:0 calc(50% - 21em / 2);scrollbar-width:0;::after{border-bottom:", ";content:\"\";display:block;margin:0 auto;}::-webkit-scrollbar{display:none;}"], function (_ref8) {
  var green2 = _ref8.theme.green2;
  return green2;
}, function (_ref9) {
  var grey1 = _ref9.theme.grey1;
  return "1px solid " + grey1;
});
var SubmitWrapper = /*#__PURE__*/_styled(CardDetails).withConfig({
  displayName: "indexstyled__SubmitWrapper",
  componentId: "sc-qs5enx-6"
})([""]);
var Label$4 = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__Label",
  componentId: "sc-qs5enx-7"
})(["align-items:center;display:flex;flex-wrap:wrap;font-size:", ";justify-content:flex-start;position:relative;& + &{margin-top:", ";}"], 12 / 16 + "em", 10 / 12 + "em");
var LabelText = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__LabelText",
  componentId: "sc-qs5enx-8"
})(["position:absolute;right:100%;width:7.5em;"]);
var CardLabel = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__CardLabel",
  componentId: "sc-qs5enx-9"
})(["align-items:center;display:flex;flex-wrap:wrap;"]);
var CardLogo = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__CardLogo",
  componentId: "sc-qs5enx-10"
})(["border:1px solid ", ";display:block;height:1.25em;margin:0 0.625em 0 0;width:2em;"], function (_ref10) {
  var lightGreen2 = _ref10.theme.lightGreen2;
  return lightGreen2;
});
var RadioButton$1 = /*#__PURE__*/_styled(RadioButton).withConfig({
  displayName: "indexstyled__RadioButton",
  componentId: "sc-qs5enx-11"
})(["+ ", "{padding-left:1.875em;::after,::before{top:50%;}::after{transform:translateY(-50%) translateX(0.375rem);}::before{border-color:currentColor;transform:translateY(-50%);}}"], CardLabel);
var CardLabelData = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__CardLabelData",
  componentId: "sc-qs5enx-12"
})(["display:flex;flex-wrap:wrap;font-size:", ";"], 14 / 16 + "em");
var CardLabelDataItem = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__CardLabelDataItem",
  componentId: "sc-qs5enx-13"
})([":nth-child(1){flex-basis:100%;}:nth-child(2){::after{content:\", \";white-space:pre;}::before{content:\"\u2022 \u2022 \u2022 \";}}"]);
var InputText$1 = /*#__PURE__*/_styled(InputText).withConfig({
  displayName: "indexstyled__InputText",
  componentId: "sc-qs5enx-14"
})(["color:", ";font-size:", ";height:100%;border-bottom-width:1px;"], function (_ref11) {
  var green2 = _ref11.theme.green2;
  return green2;
}, 14 / 16 + "em");
var InputIcon = /*#__PURE__*/_styled.img.withConfig({
  displayName: "indexstyled__InputIcon",
  componentId: "sc-qs5enx-15"
})(["border-bottom:", ";display:block;object-fit:contain;height:100%;"], function (_ref12) {
  var green3 = _ref12.theme.green3;
  return "1px solid " + rgba(green3, 0.3);
});
var InputError$3 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-qs5enx-16"
})(["font-size:", ";margin-top:", ";& + &{::before{content:\"/\";margin:auto ", ";}}"], 10 / 16 + "em", 4 / 10 + "em", 10 / 10 + "em");
var InputWrap$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrap",
  componentId: "sc-qs5enx-17"
})(["height:2em;"]);
var InputWrapShort = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrapShort",
  componentId: "sc-qs5enx-18"
})(["height:2em;& + &{::before{content:\"/\";margin:auto 0.625em;}}", "{max-width:3.5em;}"], InputText$1);
var Input$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Input",
  componentId: "sc-qs5enx-19"
})(["display:flex;justify-content:flex-start;width:100%;", "{align-items:center;display:flex;width:100%;}"], InputWrap$1);
var ButtonsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__ButtonsWrapper",
  componentId: "sc-qs5enx-20"
})(["display:flex;justify-content:flex-start;margin:1.25em auto;"]);
var Button$2 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Button",
  componentId: "sc-qs5enx-21"
})(["background-color:transparent;color:", ";font-size:", ";font-weight:700;text-transform:uppercase;:hover,:focus{background-color:transparent;}"], function (_ref13) {
  var green1 = _ref13.theme.green1;
  return green1;
}, 14 / 16 + "em");
var CardToggle = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__CardToggle",
  componentId: "sc-qs5enx-22"
})(["background-color:", ";height:1.375em;position:relative;width:1.375em;::after,::before{background-color:", ";content:\"\";height:0.875em;position:absolute;right:50%;top:50%;width:0.125em;}::after{opacity:", ";transform:", ";transition:transform 0.15s linear,opacity 0.15s linear;}::before{transform:translate(50%,-50%) rotate(90deg);}:hover,:focus{background-color:", ";}"], function (_ref14) {
  var green2 = _ref14.theme.green2;
  return green2;
}, function (_ref15) {
  var white = _ref15.theme.white;
  return white;
}, function (_ref16) {
  var isOpen = _ref16.isOpen;
  return isOpen ? "0" : "1";
}, function (_ref17) {
  var isOpen = _ref17.isOpen;
  return "translate(50%, -50%) rotate(" + (isOpen ? "-90deg" : "0deg") + ")";
}, function (_ref18) {
  var green2 = _ref18.theme.green2;
  return green2;
});
var CardToggleText = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__CardToggleText",
  componentId: "sc-qs5enx-23"
})(["font-size:", ";position:absolute;right:100%;top:50%;transform:translateY(-50%) translateX(", ");"], 12 / 16 + "em", "-" + 8 / 12 + "em");
var Submit$2 = /*#__PURE__*/_styled(Submit).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-qs5enx-24"
})([""]);
var CheckboxLabel$1 = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__CheckboxLabel",
  componentId: "sc-qs5enx-25"
})(["font-size:.75em ", ";line-height:", ";margin:", " 0;"], 12 / 16 + "em", 20 / 12 + "em", 20 / 12 + "em");

var variants = {
  open: {
    height: "auto",
    overflow: "auto"
  },
  collapsed: {
    height: 0,
    overflow: "hidden"
  }
};
var transition = {
  type: "spring",
  damping: 100
};
var CardItem = function CardItem(_ref) {
  var creditCardId = _ref.creditCardId,
    defaultCard = _ref.defaultCard,
    fullCardHolderName = _ref.fullCardHolderName,
    last4Digits = _ref.last4Digits,
    expirationDate = _ref.expirationDate,
    currentCreditCardId = _ref.currentCreditCardId,
    setCreditCardId = _ref.setCreditCardId,
    setIsAddNewOpen = _ref.setIsAddNewOpen;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useConfirmation = useConfirmation(),
    showConfirmation = _useConfirmation.show;
  var dispatch = useDispatch();
  var onChange = useCallback(function () {
    // Set current card as selected
    setCreditCardId(creditCardId);
    // Hide NewCard component
    setIsAddNewOpen(false);
  }, [creditCardId, setCreditCardId, setIsAddNewOpen]);
  var onRemove = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          showConfirmation();
          dispatch(removeCard({
            defaultCard: defaultCard,
            creditCardId: creditCardId
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [defaultCard, creditCardId, dispatch]);
  var isChecked = useMemo(function () {
    return creditCardId === currentCreditCardId;
  }, [creditCardId, currentCreditCardId]);
  useEffect(function () {
    !!defaultCard && setCreditCardId(creditCardId);
  }, [defaultCard, creditCardId]);
  return React.createElement(Card, {
    isCurrent: isChecked
  }, React.createElement(CardBar, {
    isOpen: isOpen
  }, React.createElement(RadioButton$1, {
    type: 'radio',
    checked: isChecked,
    onChange: onChange,
    id: String(creditCardId)
  }), React.createElement(CardLabel, {
    htmlFor: String(creditCardId)
  }, React.createElement(CardLogo, null), React.createElement(CardLabelData, null, React.createElement(CardLabelDataItem, null, fullCardHolderName), React.createElement(CardLabelDataItem, null, last4Digits), React.createElement(CardLabelDataItem, null, expirationDate))), React.createElement(CardToggle, {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    isOpen: isOpen
  }, React.createElement(CardToggleText, null, intl.get(isOpen ? "paymentCardsForm_toggleHideCard" : "paymentCardsForm_toggleShowCard")))), React.createElement(CardDetails, {
    animate: isOpen ? "open" : "collapsed",
    initial: isOpen,
    variants: variants,
    transition: transition
  }, React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_cardOwner")), React.createElement(Input$1, null, React.createElement(InputWrap$1, null, React.createElement(InputIcon, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/owner.png",
    alt: intl.get("paymentCardsForm_cardOwner") + " icon"
  }), React.createElement(InputText$1, {
    readOnly: true,
    value: fullCardHolderName
  })))), React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_cardNumber")), React.createElement(Input$1, null, React.createElement(InputWrap$1, null, React.createElement(InputIcon, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/card.png",
    alt: intl.get("paymentCardsForm_cardNumber") + " icon"
  }), React.createElement(InputText$1, {
    readOnly: true,
    value: "\u2022 \u2022 \u2022 " + last4Digits
  })))), React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_expirationDate")), React.createElement(Input$1, null, expirationDate && expirationDate.split("/").map(function (expDatePart, key) {
    return React.createElement(InputWrapShort, {
      key: key
    }, React.createElement(InputText$1, {
      readOnly: true,
      value: expDatePart
    }));
  }))), React.createElement(ButtonsWrapper, null, React.createElement(Button$2, {
    onClick: onRemove
  }, intl.get("paymentCardsForm_removeCard")))));
};

var Pattern$2 = function Pattern() {};
Pattern$2.cardNumber = /[0-9]{16}/;
Pattern$2.cardCVV = /[0-9]{3}/;
Pattern$2.expMonth = /^0[1-9]|1[012]$/;
Pattern$2.expYear = /^([2-9][0-9])|([1-9]\d{3}\d*)$/;
var Register$2 = {
  cardHolder: {
    required: "validateMsg_required"
  },
  cardNumber: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$2.cardNumber,
      message: "validateMsg_pattern"
    },
    minLength: {
      value: 16,
      message: "validateMsg_minLength"
    },
    maxLength: 16
  },
  cardCVV: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$2.cardCVV,
      message: "validateMsg_pattern"
    },
    minLength: {
      value: 3,
      message: "validateMsg_minLength"
    },
    maxLength: 3
  },
  expMonth: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$2.expMonth,
      message: "validateMsg_pattern"
    },
    minLength: {
      value: 2,
      message: "validateMsg_minLength"
    },
    maxLength: 2
  },
  expYear: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$2.expYear,
      message: "validateMsg_pattern"
    },
    minLength: {
      value: 2,
      message: "validateMsg_minLength"
    },
    maxLength: 2
  },
  acceptRules: {
    required: "validateMsg_required"
  }
};

var _excluded$1 = ["saveCard", "cardHolder", "acceptRules"];
var NewCardForm = function NewCardForm(_ref) {
  var _errors$cardHolder, _errors$cardHolder2, _errors$cardHolder3, _errors$cardNumber, _errors$cardNumber2, _errors$cardNumber3, _errors$expMonth, _errors$expMonth2, _errors$expMonth3, _errors$expYear, _errors$expYear2, _errors$expYear3, _errors$cardCVV, _errors$cardCVV2, _errors$cardCVV3, _errors$paymentCardsF, _errors$paymentCardsF2, _errors$paymentCardsF3;
  var providerId = _ref.providerId,
    instance = _ref.instance,
    transactionId = _ref.transactionId,
    setIsAuth = _ref.setIsAuth;
  var _useForm = useForm(),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.errors;
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount,
    transactionCurrency = _useTransaction.transactionCurrency;
  var dispatch = useDispatch();
  var onSubmit = handleSubmit(function (_ref2) {
    var _instance$current;
    var shouldSaveCard = _ref2.saveCard,
      cardHolder = _ref2.cardHolder,
      acceptRules = _ref2.acceptRules,
      restFields = _objectWithoutPropertiesLoose(_ref2, _excluded$1);
    var P24Form = instance == null || (_instance$current = instance.current) == null ? void 0 : _instance$current.querySelector("#przelewy24RPCCardForm");
    acceptRules && !!shouldSaveCard && !!transactionId && dispatch(saveCard({
      cardHolder: cardHolder,
      providerId: providerId,
      transactionAmount: transactionAmount,
      transactionCurrency: transactionCurrency,
      transactionId: transactionId
    }));
    Object.keys(_extends({
      cardHolder: cardHolder
    }, restFields)).map(function (key) {
      instance.current.querySelector("#P24_" + key).value = _extends({
        cardHolder: cardHolder
      }, restFields)[key];
    });
    P24Form == null || P24Form.submit();
    setIsAuth(true);
  });
  return React.createElement(Form, {
    onSubmit: onSubmit
  }, React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_cardOwner")), React.createElement(Input$1, null, React.createElement(InputWrap$1, null, React.createElement(InputIcon, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/owner.png",
    alt: intl.get("paymentCardsForm_cardOwner") + " icon"
  }), React.createElement(InputText$1, {
    ref: register(Register$2.cardHolder),
    placeholder: intl.get("paymentCardsForm_name"),
    name: 'cardHolder'
  }))), ((_errors$cardHolder = errors["cardHolder"]) == null ? void 0 : _errors$cardHolder.message) && React.createElement(InputError$3, null, intl.get((_errors$cardHolder2 = errors["cardHolder"]) == null ? void 0 : _errors$cardHolder2.message) || ((_errors$cardHolder3 = errors["cardHolder"]) == null ? void 0 : _errors$cardHolder3.message))), React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_cardNumber")), React.createElement(Input$1, null, React.createElement(InputWrap$1, null, React.createElement(InputIcon, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/card.png",
    alt: intl.get("paymentCardsForm_cardNumber") + " icon"
  }), React.createElement(InputText$1, {
    ref: register(Register$2.cardNumber),
    placeholder: intl.get("paymentCardsForm_enterNumber"),
    name: 'cardNumber'
  }))), ((_errors$cardNumber = errors["cardNumber"]) == null ? void 0 : _errors$cardNumber.message) && React.createElement(InputError$3, null, intl.get((_errors$cardNumber2 = errors["cardNumber"]) == null ? void 0 : _errors$cardNumber2.message) || ((_errors$cardNumber3 = errors["cardNumber"]) == null ? void 0 : _errors$cardNumber3.message))), React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_expirationDate")), React.createElement(Input$1, null, React.createElement(InputWrapShort, null, React.createElement(InputText$1, {
    ref: register(Register$2.expMonth),
    placeholder: intl.get("paymentCardsForm_expMonth"),
    name: 'expMonth'
  })), React.createElement(InputWrapShort, null, React.createElement(InputText$1, {
    ref: register(Register$2.expYear),
    placeholder: intl.get("paymentCardsForm_expYear"),
    name: 'expYear'
  }))), ((_errors$expMonth = errors["expMonth"]) == null ? void 0 : _errors$expMonth.message) && React.createElement(InputError$3, null, intl.get((_errors$expMonth2 = errors["expMonth"]) == null ? void 0 : _errors$expMonth2.message) || ((_errors$expMonth3 = errors["expMonth"]) == null ? void 0 : _errors$expMonth3.message)), ((_errors$expYear = errors["expYear"]) == null ? void 0 : _errors$expYear.message) && React.createElement(InputError$3, null, intl.get((_errors$expYear2 = errors["expYear"]) == null ? void 0 : _errors$expYear2.message) || ((_errors$expYear3 = errors["expYear"]) == null ? void 0 : _errors$expYear3.message))), React.createElement(Label$4, null, React.createElement(LabelText, null, intl.get("paymentCardsForm_cvvNumer")), React.createElement(Input$1, null, React.createElement(InputWrap$1, null, React.createElement(InputIcon, {
    src: (process.env.NODE_ENV !== "production" ? "https://test.betfan.pl" : window.location.origin) + "/images/payments/code.png",
    alt: intl.get("paymentCardsForm_cvvNumer") + " icon"
  }), React.createElement(InputText$1, {
    ref: register(Register$2.cardCVV),
    placeholder: intl.get("paymentCardsForm_cardCVV"),
    name: 'cardCVV'
  }))), ((_errors$cardCVV = errors["cardCVV"]) == null ? void 0 : _errors$cardCVV.message) && React.createElement(InputError$3, null, intl.get((_errors$cardCVV2 = errors["cardCVV"]) == null ? void 0 : _errors$cardCVV2.message) || ((_errors$cardCVV3 = errors["cardCVV"]) == null ? void 0 : _errors$cardCVV3.message))), React.createElement(Checkbox, {
    id: 'saveCard',
    name: 'saveCard',
    ref: register
  }), React.createElement(CheckboxLabel$1, {
    htmlFor: 'saveCard'
  }, intl.get("paymentCardsForm_saveCard")), React.createElement(Checkbox, {
    id: 'acceptCardRules',
    name: 'acceptRules',
    ref: register(Register$2.acceptRules)
  }), React.createElement(CheckboxLabel$1, {
    htmlFor: 'acceptCardRules'
  }, intl.getHTML("paymentCardsForm_acceptSingleTransfer"), ((_errors$paymentCardsF = errors["paymentCardsForm_acceptSingleTransfer"]) == null ? void 0 : _errors$paymentCardsF.message) && React.createElement(InputError$3, null, intl.get((_errors$paymentCardsF2 = errors["paymentCardsForm_acceptSingleTransfer"]) == null ? void 0 : _errors$paymentCardsF2.message) || ((_errors$paymentCardsF3 = errors["paymentCardsForm_acceptSingleTransfer"]) == null ? void 0 : _errors$paymentCardsF3.message))), React.createElement(Submit$2, null, intl.get("paymentCardsForm_deposit")));
};

// 9010100052000004
var variants$1 = {
  open: {
    height: "auto",
    overflow: "auto"
  },
  collapsed: {
    height: 0,
    overflow: "hidden"
  }
};
var transition$1 = {
  type: "spring",
  damping: 100
};
// P24 callbacks
// Currently not working
window["successCallback"] = function () {
  console.log("asd");
};
window["failureCallback"] = function () {
  console.log("dsa");
};
var NewCard = function NewCard(_ref) {
  var providerId = _ref.providerId,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    setCreditCardId = _ref.setCreditCardId,
    signature = _ref.signature,
    remoteTransactionId = _ref.remoteTransactionId,
    transactionId = _ref.transactionId,
    isPredefinedCard = _ref.isPredefinedCard;
  // Show (originally hidden) P24Form when auth is required
  var _useState = useState(false),
    isAuth = _useState[0],
    setIsAuth = _useState[1];
  var instance = useRef(null);
  var onClick = useCallback(function () {
    setCreditCardId(undefined);
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen, setCreditCardId]);
  // P24 setup
  useEffect(function () {
    var _instance$current, _instance$current2;
    var script = document.createElement("script");
    var div = document.createElement("div");
    div.id = "P24FormContainer";
    div.dataset.sign = signature;
    div.dataset.successcallback = "successCallback";
    div.dataset.failurecallback = "failureCallback";
    div.dataset.dictionary = "{\n      \"cardHolderLabel\": \"" + "Właściciel karty" + "\",\n      \"cardNumberLabel\": \"" + "Numer karty" + "\",\n      \"expDateLabel\": \"" + "Data ważności" + "\",\n      \"cvvLabel\": \"" + "CCV/CCV2" + "\",\n      \"payButtonCaption\": \"" + "Zapłać" + "\",\n      \"threeDSAuthMessage\": \"Wymagana dodaktowa autoryzacja!\"\n    }";
    script.src = "https://sandbox.przelewy24.pl/inchtml/ajaxPayment/ajax.js?token=" + remoteTransactionId;
    script.async = true;
    // script.type = "text/javascript"
    !!signature && (instance == null || (_instance$current = instance.current) == null ? void 0 : _instance$current.appendChild(div));
    !!remoteTransactionId && (instance == null || (_instance$current2 = instance.current) == null ? void 0 : _instance$current2.appendChild(script));
    // Warning! This runs P24 script
    script.onload = function () {
      return dispatchEvent(new Event("load"));
    };
    return function () {
      var _instance$current3, _instance$current4;
      !!signature && (instance == null || (_instance$current3 = instance.current) == null ? void 0 : _instance$current3.removeChild(div));
      !!remoteTransactionId && (instance == null || (_instance$current4 = instance.current) == null ? void 0 : _instance$current4.removeChild(script));
    };
  }, [signature, remoteTransactionId]);
  return React.createElement(React.Fragment, null, !!isPredefinedCard ? React.createElement(React.Fragment, null, React.createElement(HeadingBig, {
    isOpen: isOpen
  }, intl.get("paymentCardsForm_newCard"), React.createElement(CardToggle, {
    onClick: onClick,
    isOpen: isOpen
  }, React.createElement(CardToggleText, null, intl.get(isOpen ? "paymentCardsForm_toggleHideCard" : "paymentCardsForm_toggleShowCard")))), React.createElement(CardDetails, {
    animate: isOpen ? "open" : "collapsed",
    initial: isOpen,
    variants: variants$1,
    transition: transition$1
  }, React.createElement(NewCardForm, {
    providerId: providerId,
    instance: instance,
    transactionId: transactionId,
    setIsAuth: setIsAuth
  }))) : React.createElement(React.Fragment, null, React.createElement(HeadingBig, null, intl.get("payment_cardsTitle")), React.createElement(CardDetails, null, React.createElement(NewCardForm, {
    providerId: providerId,
    instance: instance,
    transactionId: transactionId,
    setIsAuth: setIsAuth
  }))), React.createElement(Hidden, {
    isVisible: isAuth,
    ref: instance
  }));
};

var Submit$3 = function Submit(_ref) {
  var _errors$acceptRules, _errors$acceptRules2, _errors$acceptRules3;
  var providerId = _ref.providerId,
    creditCardId = _ref.currentCreditCardId,
    isAddNewOpen = _ref.isAddNewOpen,
    setIsAddNewOpen = _ref.setIsAddNewOpen,
    isPredefinedCard = _ref.isPredefinedCard;
  var dispatch = useDispatch();
  var _useForm = useForm({
      defaultValues: {
        acceptRules: true
      }
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.errors;
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount,
    transactionCurrency = _useTransaction.transactionCurrency;
  var _useState = useState(undefined),
    setTransactionId = _useState[1];
  var onSubmit = handleSubmit(function () {
    !!creditCardId ? processPayment(creditCardId) : setIsAddNewOpen(true);
  });
  var processPayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(creditCardId) {
      var _yield$dispatch, transactionId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(processProviderPayment$1({
              callbackUrl: "",
              card: {
                creditCardId: creditCardId
              },
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }));
          case 2:
            _yield$dispatch = _context.sent;
            transactionId = _yield$dispatch.transactionId;
            setTransactionId(transactionId);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function processPayment(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!!!isPredefinedCard) return null;
  if (isAddNewOpen) return null;
  return React.createElement(SubmitWrapper, null, React.createElement(Form, {
    onSubmit: onSubmit
  }, React.createElement(Checkbox, {
    id: 'acceptCardRulesBottom',
    ref: register(Register$2.acceptRules),
    name: 'acceptRules'
  }), React.createElement(CheckboxLabel$1, {
    htmlFor: 'acceptCardRulesBottom'
  }, intl.getHTML("paymentCardsForm_acceptSingleTransfer"), ((_errors$acceptRules = errors["acceptRules"]) == null ? void 0 : _errors$acceptRules.message) && React.createElement(InputError$3, null, intl.get((_errors$acceptRules2 = errors["acceptRules"]) == null ? void 0 : _errors$acceptRules2.message) || ((_errors$acceptRules3 = errors["acceptRules"]) == null ? void 0 : _errors$acceptRules3.message))), React.createElement(Submit$2, null, intl.get("paymentCardsForm_deposit"))));
};

// @ts-nocheck
var queryOptions$3 = {
  refetchOnWindowFocus: false
};
var Cards = function Cards(_ref) {
  var providerId = _ref.providerId,
    currentCreditCardId = _ref.currentCreditCardId,
    setCreditCardId = _ref.setCreditCardId,
    setIsAddNewOpen = _ref.setIsAddNewOpen,
    setIsPredefinedCard = _ref.setIsPredefinedCard;
  var dispatch = useDispatch();
  var cards = useSelector(getCardsList);
  var cardsFetcher = useCallback(function (key) {
    return dispatch(fetchCards(key));
  }, [dispatch]);
  useEffect(function () {
    setIsPredefinedCard(!!cards.length);
  }, [cards, setIsPredefinedCard]);
  useQuery(String(providerId), cardsFetcher, queryOptions$3);
  return !!cards.length && React.createElement(React.Fragment, null, React.createElement(Heading$1, null, intl.get("paymentCardsForm_savedCardsTitle")), cards.map(function (card) {
    return React.createElement(CardItem, Object.assign({}, card, {
      key: card.creditCardId,
      currentCreditCardId: currentCreditCardId,
      setCreditCardId: setCreditCardId,
      setIsAddNewOpen: setIsAddNewOpen
    }));
  }));
};

var Deposit$3 = function Deposit(_ref) {
  var currencies = _ref.currencies;
  var dispatch = useDispatch();
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount;
  var transactionCurrency = String(currencies);
  // toggle NewCard when one of the saved cards is selected
  var _useState = useState(undefined),
    creditCardId = _useState[0],
    setCreditCardId = _useState[1];
  var _useState2 = useState(false),
    isAddNewOpen = _useState2[0],
    setIsAddNewOpen = _useState2[1];
  // P24 <script> init
  var _useState3 = useState(""),
    signature = _useState3[0],
    setSignature = _useState3[1];
  // P24 <div> config
  var _useState4 = useState(""),
    remoteTransactionId = _useState4[0],
    setRemoteTransactionId = _useState4[1];
  // P24 saveCard
  var _useState5 = useState(undefined),
    transactionId = _useState5[0],
    setTransactionId = _useState5[1];
  var _useState6 = useState(),
    isPredefinedCard = _useState6[0],
    setIsPredefinedCard = _useState6[1];
  useEffect(function () {
    var processPayment = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$dispatch, signature, remoteTransactionId, transactionId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(processProviderPayment$1({
                callbackUrl: "http://localhost:1234",
                providerId: providerId$4,
                transactionAmount: transactionAmount,
                transactionCurrency: transactionCurrency
              }));
            case 2:
              _yield$dispatch = _context.sent;
              signature = _yield$dispatch.signature;
              remoteTransactionId = _yield$dispatch.remoteTransactionId;
              transactionId = _yield$dispatch.transactionId;
              setSignature(signature);
              setRemoteTransactionId(remoteTransactionId);
              setTransactionId(transactionId);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function processPayment() {
        return _ref2.apply(this, arguments);
      };
    }();
    processPayment();
  }, [dispatch]);
  return React.createElement(React.Fragment, null, React.createElement(Cards, {
    providerId: providerId$4,
    currentCreditCardId: creditCardId,
    setCreditCardId: setCreditCardId,
    setIsAddNewOpen: setIsAddNewOpen,
    setIsPredefinedCard: setIsPredefinedCard
  }), React.createElement(NewCard, {
    providerId: providerId$4,
    isOpen: isAddNewOpen,
    setIsOpen: setIsAddNewOpen,
    setCreditCardId: setCreditCardId,
    signature: signature,
    remoteTransactionId: remoteTransactionId,
    transactionId: transactionId,
    isPredefinedCard: isPredefinedCard
  }), React.createElement(Submit$3, {
    providerId: providerId$4,
    currentCreditCardId: creditCardId,
    isAddNewOpen: isAddNewOpen,
    setIsAddNewOpen: setIsAddNewOpen,
    isPredefinedCard: isPredefinedCard
  }));
};

var providerId$5 = 171;

var img$5 = "data:image/png;base64,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";

var _excluded$2 = ["success"];
var initializeProviderPayment$2 = function initializeProviderPayment(_ref) {
  var providerId = _ref.providerId,
    transactionAmount = _ref.transactionAmount,
    transactionCurrency = _ref.transactionCurrency;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, getState) {
      var _yield$initializePaym, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initializePayment(getSession(getState()))({
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            });
          case 2:
            _yield$initializePaym = _context.sent;
            data = _yield$initializePaym.data;
            return _context.abrupt("return", data == null ? void 0 : data.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var processProviderPayment$2 = function processProviderPayment(_ref3) {
  var callbackUrl = _ref3.callbackUrl,
    providerId = _ref3.providerId,
    transactionAmount = _ref3.transactionAmount,
    transactionCurrency = _ref3.transactionCurrency,
    accountId = _ref3.accountId;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var _data$data;
      var session, _yield$dispatch, success, response, _yield$processPayment, data, _data$data2, _startTransferRespons, startTransferResponse, _data$data3, _data$data4;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            session = getSession(getState());
            _context2.next = 3;
            return dispatch(initializeProviderPayment$2({
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }));
          case 3:
            _yield$dispatch = _context2.sent;
            success = _yield$dispatch.success;
            response = _objectWithoutPropertiesLoose(_yield$dispatch, _excluded$2);
            if (success) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", _extends({
              success: success
            }, response));
          case 8:
            _context2.next = 10;
            return processPayment(session)(_extends({
              callbackUrl: callbackUrl,
              providerId: providerId,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency
            }, accountId && {
              accountId: accountId
            }));
          case 10:
            _yield$processPayment = _context2.sent;
            data = _yield$processPayment.data;
            if (!(data != null && (_data$data = data.data) != null && _data$data.success)) {
              _context2.next = 17;
              break;
            }
            _context2.next = 15;
            return startTransfer(session)(data == null || (_data$data2 = data.data) == null ? void 0 : _data$data2.transactionId);
          case 15:
            startTransferResponse = _context2.sent;
            if (JSON.parse(startTransferResponse == null || (_startTransferRespons = startTransferResponse.data) == null ? void 0 : _startTransferRespons.data)) {
              !!(data != null && (_data$data3 = data.data) != null && _data$data3.externalRequestUrl) && window.location.assign(data == null || (_data$data4 = data.data) == null ? void 0 : _data$data4.externalRequestUrl);
            }
          case 17:
            return _context2.abrupt("return", data == null ? void 0 : data.data);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var usePayByLink = function usePayByLink(_ref) {
  var callbackUrl = _ref.callbackUrl,
    providerId = _ref.providerId,
    transactionCurrency = _ref.transactionCurrency;
  return function (transactionAmount, accountId) {
    return processProviderPayment$2({
      callbackUrl: callbackUrl,
      providerId: providerId,
      transactionAmount: transactionAmount,
      transactionCurrency: transactionCurrency,
      accountId: accountId
    });
  };
};

var Pattern$3 = function Pattern() {};
Pattern$3.transactionAmount = /^[0-9]+([,.]([0-9]{1,2})){0,1}$/;
var MIN_TRANSACTION_AMOUNT$1 = 1;
var Register$3 = {
  transactionAmount: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$3.transactionAmount,
      message: "validateMsg_pattern"
    },
    validate: {
      min: function min(value) {
        return Number(value.replace(/,/g, ".")) >= MIN_TRANSACTION_AMOUNT$1 || "validateMsg_transactionAmount_minAmountValue";
      },
      max: function max(maxAmount) {
        return function (value) {
          return Number(value.replace(/,/g, ".")) <= maxAmount || "validateMsg_transactionAmount_maxAmountValue";
        };
      }
    }
  }
};

var _templateObject$4, _templateObject2$2;
var Form$3 = /*#__PURE__*/_styled(Form).withConfig({
  displayName: "indexstyled__Form",
  componentId: "sc-mzqi31-0"
})(["font-family:\"Oswald\",sans-serif;@media ", "{font-family:\"Open Sans\",sans-serif;}"], devices.mobile);
var Container$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-mzqi31-1"
})(["padding:0 ", ";width:", ";margin:0 auto;@media ", "{padding:0 ", ";width:100%;}"], 10 / 16 + "em", 580 / 16 + "em", devices.mobile, 8 / 16 + "em");
var Row$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-mzqi31-2"
})(["align-items:stretch;display:flex;flex-wrap:nowrap;height:100%;margin:0 ", ";@media ", "{flex-wrap:wrap;margin:0 ", ";}"], "-" + 10 / 16 + "em", devices.mobile, "-" + 5 / 16 + "em");
var Column$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-mzqi31-3"
})(["flex:1;padding:0 ", ";@media ", "{padding:0 ", ";}"], 10 / 16 + "em", devices.mobile, 5 / 16 + "em");
var ErrorMessage = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__ErrorMessage",
  componentId: "sc-mzqi31-4"
})(["align-items:center;background-color:", ";border-radius:", ";color:", ";display:flex;font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;justify-content:center;margin:0 0 ", ";padding:", ";a{color:inherit;}"], function (_ref) {
  var red5 = _ref.theme.red5;
  return red5;
}, 4 / 15 + "em", function (_ref2) {
  var white = _ref2.theme.white;
  return white;
}, 15 / 16 + "em", 16 / 15 + "em", 13 / 15 + "em");
var Column1$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column1",
  componentId: "sc-mzqi31-5"
})(["align-items:center;display:flex;flex:1;justify-content:center;padding:0 ", ";@media ", "{padding:0 ", ";}"], 10 / 16 + "em", devices.mobile, 5 / 16 + "em");
var AmountButton = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__AmountButton",
  componentId: "sc-mzqi31-6"
})(["border-radius:", ";font-family:inherit;font-size:", ";font-weight:500;height:", ";text-transform:uppercase;width:100%;@media ", "{border-radius:", ";font-size:", ";color:", ";background-color:", ";font-weight:600;height:", ";}"], 4 / 20 + "em", 20 / 16 + "em", 46 / 20 + "em", devices.mobile, 7 / 12 + "em", 12 / 16 + "em", function (_ref3) {
  var blue6 = _ref3.theme.blue6;
  return blue6;
}, function (_ref4) {
  var grey7 = _ref4.theme.grey7;
  return grey7;
}, 36 / 12 + "em");
var InputWrap$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrap",
  componentId: "sc-mzqi31-7"
})(["align-items:center;display:flex;flex-direction:column;margin:0 0 ", ";@media ", "{margin:", " 0 ", " 0;}"], 24 / 16 + "em", devices.mobile, 24 / 16 + "em", 50 / 16 + "em");
var InputInner$1 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputInner",
  componentId: "sc-mzqi31-8"
})(["position:relative;width:", ";@media ", "{width:", ";}"], 204 / 16 + "em", devices.mobile, 180 / 16 + "em");
var InputLabel$1 = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__InputLabel",
  componentId: "sc-mzqi31-9"
})(["color:", ";font-size:", ";font-weight:500;line-height:", ";margin-bottom:", ";pointer-events:none;text-transform:uppercase;@media ", "{text-align:center;color:", ";font-size:", ";font-weight:600;line-height:", ";margin-bottom:", ";opacity:0.6;}"], function (_ref5) {
  var blue4 = _ref5.theme.blue4;
  return blue4;
}, 18 / 16 + "em", 22 / 18 + "em", 22 / 18 + "em", devices.mobile, function (_ref6) {
  var blue6 = _ref6.theme.blue6;
  return blue6;
}, 11 / 16 + "em", 15 / 11 + "em", 15 / 11 + "em");
var InputNumber$3 = /*#__PURE__*/_styled(InputNumber).attrs({
  type: 'number',
  inputMode: null,
  pattern: null
}).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-mzqi31-10"
})(["border-radius:0;border-bottom-width:", ";font-family:inherit;font-size:", ";font-weight:500;height:", ";padding:0 0 0 ", ";text-align:center;", " @media ", "{border-radius:", ";border-width:", ";font-size:", ";font-weight:700;height:", ";box-shadow:0px 4px 13px ", ";color:", ";border-color:", ";padding-right:", ";padding-left:0;", "}"], 2 / 30 + "em", 30 / 16 + "em", 64 / 30 + "em", 2 / 30 + "em", function (_ref7) {
  var hasValue = _ref7.hasValue,
    blue5 = _ref7.theme.blue5;
  return hasValue && css(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "])), blue5);
}, devices.mobile, 7 / 35 + "em", 1 / 35 + "em", 35 / 16 + "em", 59 / 35 + "em", /*#__PURE__*/rgba(68, 85, 106, 0.08), function (_ref8) {
  var blue6 = _ref8.theme.blue6;
  return blue6;
}, function (_ref9) {
  var grey8 = _ref9.theme.grey8;
  return grey8;
}, 20 / 35 + "em", function (_ref10) {
  var hasValue = _ref10.hasValue,
    grey8 = _ref10.theme.grey8;
  return hasValue && css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n        border-color: ", ";\n    "])), grey8);
});
var InputSuffix$1 = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__InputSuffix",
  componentId: "sc-mzqi31-11"
})(["display:none;@media ", "{display:block;color:", ";font-family:inherit;font-size:", ";font-weight:700;left:50%;pointer-events:none;position:absolute;top:0;transform:", ";}"], devices.mobile, function (_ref11) {
  var blue6 = _ref11.theme.blue6;
  return blue6;
}, 35 / 16 + "em", function (_ref12) {
  var position = _ref12.position;
  return "translateY(0%) translateY(" + (5 / 35 + "em") + ") translateX(" + position + "px)";
});
var InputError$4 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-mzqi31-12"
})(["position:absolute;top:100%;"]);
var AmountBox = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__AmountBox",
  componentId: "sc-mzqi31-13"
})(["@media ", "{background-color:", ";padding:", ";box-shadow:0px 4px 13px rgba(68,85,106,0.08);border-radius:", ";}"], devices.mobile, function (_ref13) {
  var white = _ref13.theme.white;
  return white;
}, 15 / 16 + "em", 10 / 16 + "em");
var Submit$4 = /*#__PURE__*/_styled(Submit).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-mzqi31-14"
})(["border-radius:", ";display:block;font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;height:", ";letter-spacing:0.16px;margin:", " auto ", ";text-transform:capitalize;width:", ";@media ", "{width:100%;margin:", " auto ", ";background-color:", ";border-radius:", ";box-shadow:0px 4px 12px ", ",0px 14px 24px ", ";}"], 25 / 15 + "em", 15 / 16 + "em", 50 / 15 + "em", 64 / 15 + "em", 56 / 15 + "em", 200 / 15 + "em", devices.mobile, 20 / 15 + "em", 32 / 15 + "em", function (_ref14) {
  var green6 = _ref14.theme.green6;
  return green6;
}, 8 / 15 + "em", /*#__PURE__*/rgba(20, 28, 78, 0.21), /*#__PURE__*/rgba(2, 178, 83, 0.19));
var Footnote$2 = /*#__PURE__*/_styled.p.withConfig({
  displayName: "indexstyled__Footnote",
  componentId: "sc-mzqi31-15"
})(["color:", ";font-family:\"Mulish\",sans-serif;font-size:", ";font-weight:600;letter-spacing:0.12px;line-height:", ";margin:0 0 ", ";text-align:center;*{font-family:inherit;}a{color:", ";}@media ", "{font-family:\"Open Sans\",sans-serif;color:", ";opacity:0.7;font-size:", ";br{display:none;}}color:", ";font-size:", ";font-weight:600;letter-spacing:0.12px;line-height:", ";margin:0 0 ", ";text-align:center;opacity:0.7;*{font-family:inherit;}a{color:", ";}@media ", "{color:", ";font-size:", ";br{display:none;}}"], function (_ref15) {
  var blue4 = _ref15.theme.blue4;
  return blue4;
}, 12 / 16 + "em", 15 / 12 + "em", 156 / 12 + "em", function (_ref16) {
  var red5 = _ref16.theme.red5;
  return red5;
}, devices.mobile, function (_ref17) {
  var blue6 = _ref17.theme.blue6;
  return blue6;
}, 9 / 16 + "em", function (_ref18) {
  var blue6 = _ref18.theme.blue6;
  return blue6;
}, 12 / 16 + "em", 15 / 12 + "em", 156 / 12 + "em", function (_ref19) {
  var red5 = _ref19.theme.red5;
  return red5;
}, devices.mobile, function (_ref20) {
  var blue6 = _ref20.theme.blue6;
  return blue6;
}, 9 / 16 + "em");

var AmountButton$1 = function AmountButton$1(_ref) {
  var amount = _ref.amount,
    currentAmount = _ref.currentAmount,
    setAmount = _ref.setAmount;
  var onClick = useCallback(function () {
    setAmount(amount);
  }, [setAmount, amount]);
  var isActive = useMemo(function () {
    return amount === currentAmount;
  }, [amount, currentAmount]);
  return React.createElement(AmountButton, {
    isActive: isActive,
    onClick: onClick
  }, amount, " ", intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix"));
};

var DATE_FORMAT = "yyyy-MM-dd HH:mm";
var RESPONSE_LIMIT = 46;
var RESPONSE_CODES = [50, 53];
var Error$1 = function Error(_ref) {
  var _ref$success = _ref.success,
    success = _ref$success === void 0 ? true : _ref$success,
    responseCode = _ref.responseCode,
    additionalResponseText = _ref.additionalResponseText;
  var date = useMemo(function () {
    return new Date(Number(additionalResponseText));
  }, [additionalResponseText]);
  var getErrorMessage = function getErrorMessage(responseCode, additionalResponseText) {
    if (responseCode != undefined && RESPONSE_CODES.includes(responseCode)) {
      return "account_deposit_responseCode_" + responseCode + "_" + additionalResponseText;
    } else {
      return "account_deposit_responseCode_" + responseCode;
    }
  };
  if (success) return null;
  var errorMessage = getErrorMessage(responseCode, additionalResponseText);
  return React.createElement(Row$3, null, React.createElement(Column$3, null, React.createElement(ErrorMessage, null, intl.getHTML(errorMessage), responseCode === RESPONSE_LIMIT && isValid(date) && format(date, DATE_FORMAT))));
};

var _excluded$3 = ["externalRequestForm"];
var AMOUNT$1 = "transactionAmount";
var Form$4 = function Form(_ref) {
  var _defaultValues, _errors$AMOUNT, _errors$AMOUNT2, _errors$AMOUNT3;
  var processPayment = _ref.processPayment,
    amounts = _ref.amounts,
    _ref$maxAmount = _ref.maxAmount,
    maxAmount = _ref$maxAmount === void 0 ? 55000 : _ref$maxAmount,
    accountId = _ref.accountId;
  var _useState = useState(undefined),
    externalRequestForm = _useState[0],
    setExternalRequestForm = _useState[1];
  var _useState2 = useState(undefined),
    response = _useState2[0],
    setResponse = _useState2[1];
  var instance = useRef(null);
  var dispatch = useDispatch();
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount,
    updateTransactionAmount = _useTransaction.updateTransactionAmount;
  var RegisterAmount = useMemo(function () {
    return _extends({}, Register$3[AMOUNT$1], {
      validate: {
        max: Register$3[AMOUNT$1].validate.max(maxAmount),
        min: Register$3[AMOUNT$1].validate.min
      }
    });
  }, [maxAmount]);
  var _useForm = useForm({
      defaultValues: (_defaultValues = {}, _defaultValues[AMOUNT$1] = transactionAmount, _defaultValues)
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.errors,
    setValue = _useForm.setValue,
    watch = _useForm.watch,
    triggerValidation = _useForm.trigger;
  var setAmount = function setAmount(amount) {
    setValue(AMOUNT$1, amount);
    triggerValidation(AMOUNT$1);
  };
  var currentAmount = watch(AMOUNT$1);
  var position = useInputSuffix({
    value: String(currentAmount)
  });
  var onSubmit = handleSubmit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$dispatch, externalRequestForm, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (transactionAmount) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          updateTransactionAmount(transactionAmount);
          // Actual API call. MIGHT come back with external form
          _context.next = 5;
          return dispatch(processPayment(transactionAmount, accountId));
        case 5:
          _yield$dispatch = _context.sent;
          externalRequestForm = _yield$dispatch.externalRequestForm;
          response = _objectWithoutPropertiesLoose(_yield$dispatch, _excluded$3);
          setResponse(response);
          setExternalRequestForm(externalRequestForm);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  // Submit external form if applicable
  useEffect(function () {
    var _instance$current;
    var externalRequestForm = instance == null || (_instance$current = instance.current) == null ? void 0 : _instance$current.querySelector("form");
    externalRequestForm == null || externalRequestForm.submit();
  }, [instance.current]);
  // Share amount between other payment options
  useEffect(function () {
    // setValue(AMOUNT, currentAmount || undefined)
    currentAmount && updateTransactionAmount(currentAmount);
  }, [currentAmount]);
  return React.createElement(React.Fragment, null, React.createElement(Form$3, {
    onSubmit: onSubmit,
    noValidate: true,
    autoComplete: 'off'
  }, React.createElement(Container$3, null, React.createElement(Error$1, Object.assign({}, response)), React.createElement(AmountBox, null, React.createElement(Row$3, null, React.createElement(Column$3, null, React.createElement(InputWrap$2, null, React.createElement(InputLabel$1, {
    htmlFor: AMOUNT$1
  }, intl.get("account_deposit_amountInputLabel")), React.createElement(InputInner$1, null, React.createElement(InputNumber$3, {
    ref: register(RegisterAmount),
    name: AMOUNT$1,
    id: AMOUNT$1,
    hasValue: !!currentAmount
  }), !!position && React.createElement(InputSuffix$1, {
    position: position
  }, intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix")), ((_errors$AMOUNT = errors[AMOUNT$1]) == null ? void 0 : _errors$AMOUNT.message) && React.createElement(InputError$4, null, intl.get((_errors$AMOUNT2 = errors[AMOUNT$1]) == null ? void 0 : _errors$AMOUNT2.message) || ((_errors$AMOUNT3 = errors[AMOUNT$1]) == null ? void 0 : _errors$AMOUNT3.message)))))), !!amounts && !!amounts.length && React.createElement(Row$3, null, React.createElement(Column$3, null, React.createElement(Row$3, null, amounts.map(function (amount) {
    return React.createElement(Column1$1, {
      key: amount
    }, React.createElement(AmountButton$1, {
      amount: amount,
      currentAmount: currentAmount,
      setAmount: setAmount
    }));
  }))))), React.createElement(Row$3, null, React.createElement(Column$3, null, React.createElement(Submit$4, null, intl.get("account_deposit_makeDeposit")))), React.createElement(Row$3, null, React.createElement(Column$3, null, React.createElement(Footnote$2, null, intl.getHTML("account_deposit_footnote")))))), externalRequestForm && React.createElement("div", {
    ref: instance,
    dangerouslySetInnerHTML: {
      __html: externalRequestForm
    }
  }));
};

var Wrapper$3 = Tabs$1.Wrapper,
  Header$3 = Tabs$1.Header,
  Tab$2 = Tabs$1.Tab,
  Item$2 = Tabs$1.Item;
var P24_DEFAULT_TAB_INDEX = 1;
var P24_BLIK_TAB_INDEX = 2;
var P24_BLIK_ACCOUNT_ID = 154;
var Deposit$4 = function Deposit(_ref) {
  var currencies = _ref.currencies,
    settings = _ref.settings,
    limits = _ref.limits;
  var transactionCurrency = String(currencies);
  var amounts = settings.amounts;
  var _ref2 = limits || {},
    maxTotalAmountOnAttempts = _ref2.maxTotalAmountOnAttempts;
  var payByLink = usePayByLink({
    callbackUrl: "" + window.location.origin + (window.location.pathname.includes("/mobile-platform") ? "/mobile-platform" : ""),
    providerId: providerId$5,
    transactionCurrency: transactionCurrency
  });
  return React.createElement(Wrapper$3, {
    initialIndex: P24_BLIK_TAB_INDEX
  }, React.createElement(Header$3, null, React.createElement(Tab$2, {
    index: P24_DEFAULT_TAB_INDEX
  }, React.createElement(Container$1, null, React.createElement(Logo$1, {
    src: Logos[0].image,
    alt: Logos[0].alt
  }), React.createElement(Label$2, null, "Przelewy24"))), React.createElement(Tab$2, {
    index: P24_BLIK_TAB_INDEX
  }, React.createElement(Container$1, null, React.createElement(Logo$1, {
    src: Logos[1].image,
    alt: Logos[1].alt
  }), React.createElement(Label$2, null, "Kod Blik")))), React.createElement(Item$2, {
    index: P24_DEFAULT_TAB_INDEX
  }, React.createElement(Form$4, {
    processPayment: payByLink,
    amounts: amounts,
    maxAmount: maxTotalAmountOnAttempts
  })), React.createElement(Item$2, {
    index: P24_BLIK_TAB_INDEX
  }, React.createElement(Form$4, {
    processPayment: payByLink,
    amounts: amounts,
    maxAmount: maxTotalAmountOnAttempts,
    accountId: P24_BLIK_ACCOUNT_ID
  })));
};

var providerId$6 = 99;

var img$6 = "data:image/png;base64,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";

var Deposit$5 = function Deposit(_ref) {
  var currencies = _ref.currencies,
    settings = _ref.settings;
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount;
  var transactionCurrency = String(currencies);
  var amounts = settings.amounts;
  var payByLink = usePayByLink({
    callbackUrl: "" + window.location.origin + (window.location.pathname.includes("/mobile-platform") ? "/mobile-platform" : "") + "/?error=false&transactionAmount=" + Number(transactionAmount).toFixed(2) + "&transactionCurrency=" + transactionCurrency + "&transactionStatus=Success&providerId=" + providerId$6 + "&transactionStatusCode=SCS_" + window.location.origin + "/?error=false&transactionAmount=" + Number(transactionAmount).toFixed(2) + "&transactionCurrency=" + transactionCurrency + "&transactionStatus=Failed&providerId=" + providerId$6 + "&transactionStatusCode=FLD",
    providerId: providerId$6,
    transactionCurrency: transactionCurrency
  });
  return React.createElement(Form$4, {
    processPayment: payByLink,
    amounts: amounts
  });
};

var providerId$7 = 89;

var img$7 = "data:image/png;base64,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";

var Deposit$6 = function Deposit(_ref) {
  var currencies = _ref.currencies,
    settings = _ref.settings;
  var transactionCurrency = String(currencies);
  var amounts = settings.amounts;
  var payByLink = usePayByLink({
    callbackUrl: "" + window.location.origin + (window.location.pathname.includes("/mobile-platform") ? "/mobile-platform" : ""),
    providerId: providerId$7,
    transactionCurrency: transactionCurrency
  });
  return React.createElement(React.Fragment, null, React.createElement(Form$4, {
    processPayment: payByLink,
    amounts: amounts
  }));
};

var LOADING = "loading";
var IDLE = "idle";
var READY = "ready";
var ERROR = "error";
var LOAD = "load";
var useScript = function useScript(src) {
  var _useState = useState(src ? LOADING : IDLE),
    status = _useState[0],
    setStatus = _useState[1];
  useEffect(function () {
    if (!src) {
      setStatus(IDLE);
      return;
    }
    var script = document.querySelector("script[src=\"" + src + "\"]");
    if (!script) {
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.status = LOADING;
      document.body.appendChild(script);
      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        if (!script) return;
        script.dataset.status = (event == null ? void 0 : event.type) === LOAD ? READY : ERROR;
      };
      script.addEventListener(LOAD, setAttributeFromEvent);
      script.addEventListener(ERROR, setAttributeFromEvent);
    } else {
      script.dataset.status && setStatus(script.dataset.status);
    }
    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus((event == null ? void 0 : event.type) === LOAD ? READY : ERROR);
    };
    script.addEventListener(LOAD, setStateFromEvent);
    script.addEventListener(ERROR, setStateFromEvent);
    return function () {
      if (script) {
        script.removeEventListener(LOAD, setStateFromEvent);
        script.removeEventListener(ERROR, setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};

var useTimeout = function useTimeout(fn, ms) {
  if (ms === void 0) {
    ms = 0;
  }
  var ready = useRef(false);
  var timeout = useRef();
  var callback = useRef(fn);
  var isReady = useCallback(function () {
    return ready.current;
  }, []);
  var set = useCallback(function () {
    ready.current = false;
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);
  var clear = useCallback(function () {
    ready.current = null;
    timeout.current && clearTimeout(timeout.current);
  }, []);
  useEffect(function () {
    callback.current = fn;
  }, [fn]);
  useEffect(function () {
    set();
    return clear;
  }, [ms]);
  return [isReady, clear, set];
};

var useDebounce = function useDebounce(fn, ms, deps) {
  if (ms === void 0) {
    ms = 0;
  }
  if (deps === void 0) {
    deps = [];
  }
  var _useTimeout = useTimeout(fn, ms),
    isReady = _useTimeout[0],
    cancel = _useTimeout[1],
    reset = _useTimeout[2];
  useEffect(reset, deps);
  return [isReady, cancel];
};

var img$8 = "data:image/png;base64,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";

var providerId$8 = 287;
var Pattern$4 = function Pattern() {};
Pattern$4.transactionAmount = /^[0-9]+([,.]([0-9]{1,2})){0,1}$/;
var MIN_TRANSACTION_AMOUNT$2 = 1;
var SCRIPT_TEST = "https://ssl.dotpay.pl/test_payment/frame/plugin.js";
var Register$4 = {
  transactionAmount: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$4.transactionAmount,
      message: "validateMsg_pattern"
    },
    validate: {
      min: function min(value) {
        return Number(value.replace(/,/g, ".")) >= MIN_TRANSACTION_AMOUNT$2 || "validateMsg_transactionAmount_minAmountValue";
      }
    }
  },
  regulationAccept: {
    required: "validateMsg_required"
  }
};

var _templateObject$5;
var Container$4 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-14b6ylu-0"
})(["padding:2em 0.188em 0;@media ", "{padding-top:1.25em;}"], devices.mobile);
var Wrapper$4 = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-14b6ylu-1"
})([""]);
var Row$4 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-14b6ylu-2"
})(["align-items:stretch;display:flex;flex-wrap:nowrap;margin:0 -0.188em;@media ", "{flex-wrap:wrap;}"], devices.mobile);
var Column1$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column1",
  componentId: "sc-14b6ylu-3"
})(["flex:1;padding:0 0.188em;"]);
var AmountButton$2 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__AmountButton",
  componentId: "sc-14b6ylu-4"
})(["background-color:", ";border-radius:0.125em;color:", ";font-size:1em;font-weight:600;height:", ";width:100%;@media ", "{height:2.625em;}"], function (_ref) {
  var isActive = _ref.isActive,
    _ref$theme = _ref.theme,
    grey1 = _ref$theme.grey1,
    red1 = _ref$theme.red1;
  return isActive ? red1 : grey1;
}, function (_ref2) {
  var isActive = _ref2.isActive,
    _ref2$theme = _ref2.theme,
    white = _ref2$theme.white,
    black = _ref2$theme.black;
  return isActive ? white : black;
}, 42 / 16 + "em", devices.mobile);
var InputWrap$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrap",
  componentId: "sc-14b6ylu-5"
})(["margin:1em 0 -0.25em;position:relative;"]);
var Column$4 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-14b6ylu-6"
})(["flex:1;padding:0 0.188em;@media ", "{flex-basis:100%;& + &{& > ", "{margin-top:0;}}}"], devices.mobile, InputWrap$3);
var InputInner$2 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputInner",
  componentId: "sc-14b6ylu-7"
})(["overflow:hidden;padding:0.25em 0;position:relative;"]);
var InputLabel$2 = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__InputLabel",
  componentId: "sc-14b6ylu-8"
})(["font-size:", ";font-weight:400;left:", ";line-height:", ";pointer-events:none;position:absolute;top:0;transform:translateY(50%) translateY(", ");transition:all 0.15s linear;::before{background-color:", ";bottom:0;content:\"\";left:", ";position:absolute;right:", ";top:0;z-index:-1;}"], 14 / 16 + "em", 18 / 14 + "em", 20 / 14 + "em", 4 / 14 + "em", function (_ref3) {
  var white = _ref3.theme.white;
  return white;
}, "-" + 3 / 14 + "em", "-" + 3 / 14 + "em");
var InputSuffix$2 = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__InputSuffix",
  componentId: "sc-14b6ylu-9"
})(["font-size:", ";left:", ";line-height:", ";pointer-events:none;position:absolute;top:0;transform:", ";"], 14 / 16 + "em", 18 / 14 + "em", 20 / 14 + "em", function (_ref4) {
  var position = _ref4.position;
  return "translateY(50%) translateY(" + (5 / 14 + "em") + ") translateX(" + position + "px)";
});
var InputNumber$4 = /*#__PURE__*/_styled(InputNumber).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-14b6ylu-10"
})(["border-radius:0.188em;border-width:1px;font-size:", ";height:", ";padding:0 0 0 ", ";:focus{border-color:", ";box-shadow:", ";color:", ";+ ", "{color:", ";font-size:", ";transform:translateY(-50%) translateY(", ");}}", ""], 14 / 16 + "em", 42 / 14 + "em", 18 / 14 + "em", function (_ref5) {
  var red1 = _ref5.theme.red1;
  return red1;
}, function (_ref6) {
  var red1 = _ref6.theme.red1;
  return "inset 0 0 0 1px " + red1;
}, function (_ref7) {
  var black = _ref7.theme.black;
  return black;
}, InputLabel$2, function (_ref8) {
  var red1 = _ref8.theme.red1;
  return red1;
}, 10 / 16 + "em", 4 / 10 + "em", function (_ref9) {
  var hasValue = _ref9.hasValue;
  return hasValue && css(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n      box-shadow: ", ";\n      color: ", ";\n\n      + ", " {\n        color: ", ";\n        font-size: ", ";\n        transform: translateY(-50%) translateY(", ");\n      }\n    "])), function (_ref10) {
    var red1 = _ref10.theme.red1;
    return red1;
  }, function (_ref11) {
    var red1 = _ref11.theme.red1;
    return "inset 0 0 0 1px " + red1;
  }, function (_ref12) {
    var black = _ref12.theme.black;
    return black;
  }, InputLabel$2, function (_ref13) {
    var red1 = _ref13.theme.red1;
    return red1;
  }, 10 / 16 + "em", 4 / 10 + "em");
});
var InputError$5 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-14b6ylu-11"
})(["padding:0 0 0.25em;"]);
var Submit$5 = /*#__PURE__*/_styled(Submit).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-14b6ylu-12"
})(["border-radius:0.188em;font-size:1em;font-weight:400;margin:", " 0;height:", ";width:100%;:disabled{background-color:", ";color:", ";:hover,:focus{background-color:", ";color:", ";}}"], 16 / 16 + "em", 42 / 16 + "em", function (_ref14) {
  var grey1 = _ref14.theme.grey1;
  return grey1;
}, function (_ref15) {
  var black = _ref15.theme.black;
  return black;
}, function (_ref16) {
  var grey1 = _ref16.theme.grey1;
  return grey1;
}, function (_ref17) {
  var black = _ref17.theme.black;
  return black;
});
var Button$3 = /*#__PURE__*/_styled(Submit$5).withConfig({
  displayName: "indexstyled__Button",
  componentId: "sc-14b6ylu-13"
})([""]);
var CheckboxLabel$2 = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__CheckboxLabel",
  componentId: "sc-14b6ylu-14"
})(["font-size:15px;font-weight:400;margin:0;"]);
var Checkbox$1 = /*#__PURE__*/_styled(Checkbox).withConfig({
  displayName: "indexstyled__Checkbox",
  componentId: "sc-14b6ylu-15"
})(["+ ", "{padding-left:", ";::before{border-radius:", ";border-width:", ";height:", ";width:", ";}::after{transform:translate(", ",", ");}}"], CheckboxLabel$2, 32 / 15 + "em", 2 / 15 + "em", 3 / 15 + "em", 20 / 15 + "em", 20 / 15 + "em", 6 / 15 + "em", 6 / 15 + "em");
var MountingDiv = /*#__PURE__*/_styled.div.attrs({
  id: "dotpay_payment_frame"
}).withConfig({
  displayName: "indexstyled__MountingDiv",
  componentId: "sc-14b6ylu-16"
})(["font-size:16px;height:", ";position:relative;width:100%;@media ", "{height:", ";}"], 336 / 16 + "em", devices.mobile, 384 / 16 + "em");

var AmountButton$3 = function AmountButton(_ref) {
  var amount = _ref.amount,
    currentAmount = _ref.currentAmount,
    setAmount = _ref.setAmount;
  var onClick = useCallback(function () {
    setAmount(amount);
  }, [setAmount, amount]);
  var isActive = useMemo(function () {
    return amount === currentAmount;
  }, [amount, currentAmount]);
  return React.createElement(AmountButton$2, {
    isActive: isActive,
    onClick: onClick
  }, amount, " ", intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix"));
};

var _excluded$4 = ["credit_card_id"],
  _excluded2 = ["credit_card_id"];
var AMOUNT$2 = "transactionAmount";
var ACCEPT = "regulationAccept";
var variants$2 = {
  open: {
    opacity: 1,
    pointerEvents: "all",
    height: "auto"
  },
  collapsed: {
    opacity: 0,
    pointerEvents: "none",
    height: 0
  }
};
var Deposit$7 = function Deposit(_ref) {
  var _defaultValues, _errors$AMOUNT, _errors$AMOUNT2, _errors$AMOUNT3, _errors$ACCEPT, _errors$ACCEPT2, _errors$ACCEPT3;
  var currencies = _ref.currencies,
    settings = _ref.settings;
  var _useState = useState(false),
    isIframeReady = _useState[0],
    setIsIframeReady = _useState[1];
  var _useState2 = useState(false),
    isFormSubmitted = _useState2[0],
    setIsFormSubmitted = _useState2[1];
  var _useState3 = useState(undefined),
    confirmURL = _useState3[0],
    setConfirmURL = _useState3[1];
  var _useState4 = useState({}),
    paymentData = _useState4[0],
    setPaymentData = _useState4[1];
  var amounts = settings.amounts;
  var dispatch = useDispatch();
  var _useSummary = useSummary(),
    isSummaryVisible = _useSummary.isVisible,
    showSummary = _useSummary.show,
    hideSummary = _useSummary.hide,
    setSummaryData = _useSummary.setData;
  var transactionCurrency = String(currencies);
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount,
    isTransactionAmountValid = _useTransaction.isTransactionAmountValid,
    updateTransactionAmount = _useTransaction.updateTransactionAmount;
  var scriptStatus = useScript(process.env.NODE_ENV !== "production" ? SCRIPT_TEST : process.env.DOTPAY_CARDS);
  var _useForm = useForm({
      defaultValues: (_defaultValues = {}, _defaultValues[AMOUNT$2] = transactionAmount, _defaultValues)
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    watch = _useForm.watch,
    errors = _useForm.errors,
    setValue = _useForm.setValue,
    triggerValidation = _useForm.trigger;
  var currentAmount = watch(AMOUNT$2);
  var position = useInputSuffix({
    value: String(currentAmount)
  });
  var setAmount = function setAmount(amount) {
    setValue(AMOUNT$2, amount);
    triggerValidation(AMOUNT$2);
  };
  var onSubmit = handleSubmit(function () {
    var credit_card_id = paymentData.credit_card_id,
      rest = _objectWithoutPropertiesLoose(paymentData, _excluded$4);
    // When there's card saved, DotpayPaymentFrame.payment will
    // proceed with the payment just like submit() would do
    if (!!credit_card_id) {
      DotpayPaymentFrame.payment(_extends({
        credit_card_id: credit_card_id
      }, rest));
      return;
    }
    DotpayPaymentFrame.submit();
  });
  var getData = usePayByLink({
    callbackUrl: "" + window.location.origin + (window.location.pathname.includes("/mobile-platform") ? "/mobile-platform" : ""),
    providerId: providerId$8,
    transactionCurrency: transactionCurrency
  });
  var onClick = useCallback(function () {
    if (!confirmURL) return;
    window.location.href = confirmURL;
  }, [confirmURL]);
  // Handle post-submit
  useEffect(function () {
    if (!isFormSubmitted) return;
    setIsIframeReady(false);
    setSummaryData({
      success: true,
      transactionAmount: Number(transactionAmount),
      transactionCurrency: transactionCurrency
    });
    showSummary();
    setIsFormSubmitted(false);
  }, [isFormSubmitted, transactionAmount, transactionCurrency]);
  // Handle post-response
  useEffect(function () {
    isSummaryVisible && confirmURL && hideSummary();
  }, [confirmURL, isSummaryVisible]);
  useEffect(function () {
    var getUserData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$dispatch, externalRequestForm, _JSON$parse, credit_card_id, rest;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(getData(transactionAmount));
            case 2:
              _yield$dispatch = _context.sent;
              externalRequestForm = _yield$dispatch.externalRequestForm;
              _JSON$parse = JSON.parse(externalRequestForm), credit_card_id = _JSON$parse.credit_card_id, rest = _objectWithoutPropertiesLoose(_JSON$parse, _excluded2);
              DotpayPaymentFrame.init({
                auto_redirect: false,
                frame_visible_callback: function frame_visible_callback() {
                  return setIsIframeReady(true);
                },
                payment_result_callback: function payment_result_callback() {
                  return setIsFormSubmitted(true);
                },
                redirect_callback: function redirect_callback(confirmURL) {
                  return setConfirmURL(confirmURL);
                }
              });
              // Break useEffect when user has credit card saved.
              // Save all the payment data so we can use it later on
              if (!credit_card_id) {
                _context.next = 9;
                break;
              }
              setPaymentData(_extends({
                credit_card_id: credit_card_id
              }, rest));
              return _context.abrupt("return");
            case 9:
              DotpayPaymentFrame.payment(_extends({}, rest));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getUserData() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (!isTransactionAmountValid) return;
    if (scriptStatus === READY) {
      getUserData();
    }
  }, [isTransactionAmountValid, transactionAmount, scriptStatus]);
  useEffect(function () {
    setIsIframeReady(false);
  }, [currentAmount]);
  // Share amount between other payment options
  useDebounce(function () {
    updateTransactionAmount(currentAmount);
    setConfirmURL(undefined);
  }, 500, [currentAmount]);
  return React.createElement(React.Fragment, null, React.createElement(Summary$1, {
    providerId: providerId$8
  }), React.createElement(Form, {
    onSubmit: onSubmit,
    noValidate: true,
    autoComplete: 'off'
  }, React.createElement(Container$4, null, React.createElement(Row$4, null, !!amounts && !!amounts.length && React.createElement(Column$4, null, React.createElement(Row$4, null, amounts.map(function (amount) {
    return React.createElement(Column1$2, {
      key: amount
    }, React.createElement(AmountButton$3, {
      amount: amount,
      currentAmount: currentAmount,
      setAmount: setAmount
    }));
  })))), React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(InputWrap$3, null, React.createElement(InputInner$2, null, React.createElement(InputNumber$4, {
    ref: register(Register$4[AMOUNT$2]),
    name: AMOUNT$2,
    id: "_" + AMOUNT$2,
    hasValue: !!currentAmount
  }), React.createElement(InputLabel$2, {
    htmlFor: "_" + AMOUNT$2
  }, intl.get("account_deposit_amountInputLabel")), !!position && React.createElement(InputSuffix$2, {
    position: position
  }, intl.get("account_deposit_currencySuffix"))), React.createElement(AnimatePresence, null, ((_errors$AMOUNT = errors[AMOUNT$2]) == null ? void 0 : _errors$AMOUNT.message) && React.createElement(InputError$5, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$2
  }, intl.get((_errors$AMOUNT2 = errors[AMOUNT$2]) == null ? void 0 : _errors$AMOUNT2.message) || ((_errors$AMOUNT3 = errors[AMOUNT$2]) == null ? void 0 : _errors$AMOUNT3.message)))))))), React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(Wrapper$4, {
    initial: 'collapsed',
    animate: isIframeReady ? "open" : "collapsed",
    variants: variants$2
  }, React.createElement(MountingDiv, null)))), React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(InputWrap$3, null, React.createElement(InputInner$2, null, React.createElement(Checkbox$1, {
    ref: register(Register$4[ACCEPT]),
    name: ACCEPT,
    id: "_" + ACCEPT
  }), React.createElement(CheckboxLabel$2, {
    htmlFor: "_" + ACCEPT
  }, intl.getHTML("account_deposit_acceptDotPayRules"))), React.createElement(AnimatePresence, null, ((_errors$ACCEPT = errors[ACCEPT]) == null ? void 0 : _errors$ACCEPT.message) && React.createElement(InputError$5, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$2
  }, intl.get((_errors$ACCEPT2 = errors[ACCEPT]) == null ? void 0 : _errors$ACCEPT2.message) || ((_errors$ACCEPT3 = errors[ACCEPT]) == null ? void 0 : _errors$ACCEPT3.message)))))), React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(Submit$5, {
    disabled: !!confirmURL
  }, intl.get("account_deposit_makeDeposit")))), confirmURL && React.createElement(Row$4, null, React.createElement(Column$4, null, React.createElement(Button$3, {
    onClick: onClick
  }, intl.get("accont_deposit_confirmDeposit")))))));
};

var providerId$9 = 77;

var img$9 = "data:image/png;base64,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";

var Deposit$8 = function Deposit(_ref) {
  var currencies = _ref.currencies,
    settings = _ref.settings;
  var transactionCurrency = String(currencies);
  var amounts = settings.amounts;
  var payByLink = usePayByLink({
    callbackUrl: "" + window.location.origin + (window.location.pathname.includes("/mobile-platform") ? "/mobile-platform" : ""),
    providerId: providerId$9,
    transactionCurrency: transactionCurrency
  });
  return React.createElement(Form$4, {
    processPayment: payByLink,
    amounts: amounts
  });
};

var providerId$a = 283;
var Pattern$5 = function Pattern() {};
Pattern$5.voucherCode = /^[0-9]{6}$/;
Pattern$5.transactionAmount = /^[0-9]+([,.]([0-9]{1,2})){0,1}$/;
var MIN_TRANSACTION_AMOUNT$3 = 1;
var Register$5 = {
  transactionAmount: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$5.transactionAmount,
      message: "validateMsg_pattern"
    },
    validate: {
      min: function min(value) {
        return Number(value.replace(/,/g, ".")) >= MIN_TRANSACTION_AMOUNT$3 || "validateMsg_transactionAmount_minAmountValue";
      }
    }
  },
  voucherCode: {
    required: "validateMsg_required",
    pattern: {
      value: Pattern$5.voucherCode,
      message: "validateMsg_pattern"
    }
  },
  regulationAccept: {
    required: "validateMsg_required"
  }
};

var img$a = "data:image/png;base64,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";

var _templateObject$6;
var Container$5 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-e2x7vc-0"
})(["padding:2em 0.188em 0;@media ", "{padding-top:1.25em;}"], devices.mobile);
var Wrapper$5 = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-e2x7vc-1"
})([""]);
var Row$5 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Row",
  componentId: "sc-e2x7vc-2"
})(["align-items:stretch;display:flex;flex-wrap:nowrap;margin:0 -0.188em;@media ", "{flex-wrap:wrap;}"], devices.mobile);
var Column1$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column1",
  componentId: "sc-e2x7vc-3"
})(["flex:1;padding:0 0.188em;"]);
var AmountButton$4 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__AmountButton",
  componentId: "sc-e2x7vc-4"
})(["background-color:", ";border-radius:0.125em;color:", ";font-size:1em;font-weight:600;height:", ";width:100%;@media ", "{height:2.625em;}"], function (_ref) {
  var isActive = _ref.isActive,
    _ref$theme = _ref.theme,
    grey1 = _ref$theme.grey1,
    red1 = _ref$theme.red1;
  return isActive ? red1 : grey1;
}, function (_ref2) {
  var isActive = _ref2.isActive,
    _ref2$theme = _ref2.theme,
    white = _ref2$theme.white,
    black = _ref2$theme.black;
  return isActive ? white : black;
}, 42 / 16 + "em", devices.mobile);
var InputWrap$4 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputWrap",
  componentId: "sc-e2x7vc-5"
})(["margin:1em 0 -0.25em;position:relative;"]);
var Column$5 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__Column",
  componentId: "sc-e2x7vc-6"
})(["flex:1;padding:0 0.188em;@media ", "{flex-basis:100%;& + &{& > ", "{margin-top:0;}}}"], devices.mobile, InputWrap$4);
var InputInner$3 = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__InputInner",
  componentId: "sc-e2x7vc-7"
})(["overflow:hidden;padding:0.25em 0;position:relative;"]);
var InputLabel$3 = /*#__PURE__*/_styled.label.withConfig({
  displayName: "indexstyled__InputLabel",
  componentId: "sc-e2x7vc-8"
})(["font-size:", ";font-weight:400;left:", ";line-height:", ";pointer-events:none;position:absolute;top:0;transform:translateY(50%) translateY(", ");transition:all 0.15s linear;::before{background-color:", ";bottom:0;content:\"\";left:", ";position:absolute;right:", ";top:0;z-index:-1;}"], 14 / 16 + "em", 18 / 14 + "em", 20 / 14 + "em", 4 / 14 + "em", function (_ref3) {
  var white = _ref3.theme.white;
  return white;
}, "-" + 3 / 14 + "em", "-" + 3 / 14 + "em");
var InputSuffix$3 = /*#__PURE__*/_styled.span.withConfig({
  displayName: "indexstyled__InputSuffix",
  componentId: "sc-e2x7vc-9"
})(["font-size:", ";left:", ";line-height:", ";pointer-events:none;position:absolute;top:0;transform:", ";"], 14 / 16 + "em", 18 / 14 + "em", 20 / 14 + "em", function (_ref4) {
  var position = _ref4.position;
  return "translateY(50%) translateY(" + (5 / 14 + "em") + ") translateX(" + position + "px)";
});
var InputNumber$5 = /*#__PURE__*/_styled(InputNumber).withConfig({
  displayName: "indexstyled__InputNumber",
  componentId: "sc-e2x7vc-10"
})(["border-radius:0.188em;border-width:1px;font-size:", ";height:", ";padding:0 0 0 ", ";:focus{border-color:", ";box-shadow:", ";color:", ";+ ", "{color:", ";font-size:", ";transform:translateY(-50%) translateY(", ");}}", ""], 14 / 16 + "em", 42 / 14 + "em", 18 / 14 + "em", function (_ref5) {
  var red1 = _ref5.theme.red1;
  return red1;
}, function (_ref6) {
  var red1 = _ref6.theme.red1;
  return "inset 0 0 0 1px " + red1;
}, function (_ref7) {
  var black = _ref7.theme.black;
  return black;
}, InputLabel$3, function (_ref8) {
  var red1 = _ref8.theme.red1;
  return red1;
}, 10 / 16 + "em", 4 / 10 + "em", function (_ref9) {
  var hasValue = _ref9.hasValue;
  return hasValue && css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n      box-shadow: ", ";\n      color: ", ";\n\n      + ", " {\n        color: ", ";\n        font-size: ", ";\n        transform: translateY(-50%) translateY(", ");\n      }\n    "])), function (_ref10) {
    var red1 = _ref10.theme.red1;
    return red1;
  }, function (_ref11) {
    var red1 = _ref11.theme.red1;
    return "inset 0 0 0 1px " + red1;
  }, function (_ref12) {
    var black = _ref12.theme.black;
    return black;
  }, InputLabel$3, function (_ref13) {
    var red1 = _ref13.theme.red1;
    return red1;
  }, 10 / 16 + "em", 4 / 10 + "em");
});
var InputError$6 = /*#__PURE__*/_styled(InputError).withConfig({
  displayName: "indexstyled__InputError",
  componentId: "sc-e2x7vc-11"
})(["padding:0 0 0.25em;"]);
var Submit$6 = /*#__PURE__*/_styled(Submit).withConfig({
  displayName: "indexstyled__Submit",
  componentId: "sc-e2x7vc-12"
})(["border-radius:0.188em;font-size:1em;font-weight:400;margin:", " 0;height:", ";width:100%;"], 16 / 16 + "em", 42 / 16 + "em");
var CheckboxLabel$3 = /*#__PURE__*/_styled(Label).withConfig({
  displayName: "indexstyled__CheckboxLabel",
  componentId: "sc-e2x7vc-13"
})(["font-size:15px;font-weight:400;margin:0;"]);
var Checkbox$2 = /*#__PURE__*/_styled(Checkbox).withConfig({
  displayName: "indexstyled__Checkbox",
  componentId: "sc-e2x7vc-14"
})(["+ ", "{padding-left:", ";::before{border-radius:", ";border-width:", ";height:", ";width:", ";}}"], CheckboxLabel$3, 32 / 15 + "em", 2 / 15 + "em", 3 / 15 + "em", 20 / 15 + "em", 20 / 15 + "em");
var Button$4 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Button",
  componentId: "sc-e2x7vc-15"
})(["background-color:", ";border-radius:", ";color:", ";font-size:", ";height:", ";text-align:center;text-transform:", ";width:100%;:hover,:focus{background-color:", ";color:", ";}"], function (_ref14) {
  var isAlternative = _ref14.isAlternative,
    red1 = _ref14.theme.red1;
  return isAlternative ? "transparent" : red1;
}, function (_ref15) {
  var isAlternative = _ref15.isAlternative;
  return isAlternative ? 0 : 3 / 16 + "em";
}, function (_ref16) {
  var isAlternative = _ref16.isAlternative,
    white = _ref16.theme.white;
  return isAlternative ? "inherit" : white;
}, function (_ref17) {
  var isAlternative = _ref17.isAlternative;
  return isAlternative ? 15 / 16 + "em" : 16 / 16 + "em";
}, function (_ref18) {
  var isAlternative = _ref18.isAlternative;
  return isAlternative ? "auto" : 42 / 16 + "em";
}, function (_ref19) {
  var isAlternative = _ref19.isAlternative;
  return isAlternative ? "none" : "uppercase";
}, function (_ref20) {
  var isAlternative = _ref20.isAlternative,
    red1 = _ref20.theme.red1;
  return isAlternative ? "transparent" : red1;
}, function (_ref21) {
  var isAlternative = _ref21.isAlternative,
    white = _ref21.theme.white;
  return isAlternative ? "inherit" : white;
});

var AmountButton$5 = function AmountButton(_ref) {
  var amount = _ref.amount,
    currentAmount = _ref.currentAmount,
    setAmount = _ref.setAmount;
  var onClick = useCallback(function () {
    setAmount(amount);
  }, [setAmount, amount]);
  var isActive = useMemo(function () {
    return amount === currentAmount;
  }, [amount, currentAmount]);
  return React.createElement(AmountButton$4, {
    isActive: isActive,
    onClick: onClick
  }, amount, " ", intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix"));
};

var AMOUNT$3 = "transactionAmount";
var CODE = "voucherCode";
var SAVE = "saveBlikAlias";
var ACCEPT$1 = "regulationAccept";
var variants$3 = {
  open: {
    opacity: 1,
    height: "auto"
  },
  collapsed: {
    opacity: 0,
    height: 0
  }
};
var Deposit$9 = function Deposit(_ref) {
  var _defaultValues, _errors$AMOUNT, _errors$AMOUNT2, _errors$AMOUNT3, _errors$CODE, _errors$CODE2, _errors$CODE3, _errors$ACCEPT, _errors$ACCEPT2, _errors$ACCEPT3;
  var currencies = _ref.currencies,
    settings = _ref.settings;
  var amounts = settings.amounts;
  var _useState = useState(false),
    isBlikSaved = _useState[0],
    setIsBlikSaved = _useState[1];
  var _useState2 = useState(false),
    shouldUseSavedAlias = _useState2[0],
    setShouldUseSavedAlias = _useState2[1];
  var _useTransaction = useTransaction(),
    transactionAmount = _useTransaction.transactionAmount,
    updateTransactionAmount = _useTransaction.updateTransactionAmount;
  var transactionCurrency = String(currencies);
  var dispatch = useDispatch();
  var _useForm = useForm({
      defaultValues: (_defaultValues = {}, _defaultValues[AMOUNT$3] = transactionAmount, _defaultValues)
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    watch = _useForm.watch,
    errors = _useForm.errors,
    setValue = _useForm.setValue,
    triggerValidation = _useForm.trigger,
    resetForm = _useForm.reset;
  var _useSummary = useSummary(),
    showSummary = _useSummary.show,
    setSummaryData = _useSummary.setData;
  var currentAmount = watch(AMOUNT$3);
  var blikCode = watch(CODE);
  var position = useInputSuffix({
    value: String(currentAmount)
  });
  var setAmount = function setAmount(amount) {
    setValue(AMOUNT$3, amount);
    triggerValidation(AMOUNT$3);
  };
  var onSubmit = handleSubmit( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var voucherCode, saveBlikAlias, regulationAccept, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            voucherCode = _ref2.voucherCode, saveBlikAlias = _ref2.saveBlikAlias, regulationAccept = _ref2.regulationAccept;
            _context.next = 3;
            return dispatch(processProviderPayment$1({
              providerId: providerId$a,
              voucherCode: voucherCode,
              transactionAmount: transactionAmount,
              transactionCurrency: transactionCurrency,
              additionalData: JSON.stringify(_extends({}, saveBlikAlias && {
                saveBlikAlias: String(saveBlikAlias)
              }, regulationAccept && {
                regulationAccept: String(regulationAccept)
              }, shouldUseSavedAlias && {
                useSavedAlias: String(shouldUseSavedAlias)
              }))
            }));
          case 3:
            response = _context.sent;
            setSummaryData(response);
            showSummary();
            resetForm();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
  var onClick = function onClick() {
    setShouldUseSavedAlias(!shouldUseSavedAlias);
  };
  // Check if user has BLIK code saved
  useEffect(function () {
    var init = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$dispatch, additionalResponseText;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(initializeProviderPayment$1({
                providerId: providerId$a,
                transactionAmount: transactionAmount || "1",
                transactionCurrency: transactionCurrency
              }));
            case 2:
              _yield$dispatch = _context2.sent;
              additionalResponseText = _yield$dispatch.additionalResponseText;
              setIsBlikSaved(!!additionalResponseText);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function init() {
        return _ref4.apply(this, arguments);
      };
    }();
    init();
  }, [dispatch]);
  // Share amount between other payment options
  useEffect(function () {
    updateTransactionAmount(currentAmount);
  }, [currentAmount]);
  // When available, show saved Blik option first
  useEffect(function () {
    setShouldUseSavedAlias(isBlikSaved);
  }, [isBlikSaved, setShouldUseSavedAlias]);
  return React.createElement(React.Fragment, null, React.createElement(Summary$1, {
    providerId: providerId$a
  }), React.createElement(Form, {
    onSubmit: onSubmit,
    noValidate: true,
    autoComplete: 'off'
  }, React.createElement(Container$5, null, React.createElement(Row$5, null, !!amounts && !!amounts.length && React.createElement(Column$5, null, React.createElement(Row$5, null, amounts.map(function (amount) {
    return React.createElement(Column1$3, {
      key: amount
    }, React.createElement(AmountButton$5, {
      amount: amount,
      currentAmount: currentAmount,
      setAmount: setAmount
    }));
  })))), React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(InputWrap$4, null, React.createElement(InputInner$3, null, React.createElement(InputNumber$5, {
    ref: register(Register$5[AMOUNT$3]),
    name: AMOUNT$3,
    id: "_" + AMOUNT$3,
    hasValue: !!currentAmount
  }), React.createElement(InputLabel$3, {
    htmlFor: "_" + AMOUNT$3
  }, intl.get("account_deposit_amountInputLabel")), !!position && React.createElement(InputSuffix$3, {
    position: position
  }, intl.get("account_deposit_currencySuffix") || "" + (process.env.NODE_ENV !== "production" ? "zł" : "account_deposit_currencySuffix"))), React.createElement(AnimatePresence, null, ((_errors$AMOUNT = errors[AMOUNT$3]) == null ? void 0 : _errors$AMOUNT.message) && React.createElement(InputError$6, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$3
  }, intl.get((_errors$AMOUNT2 = errors[AMOUNT$3]) == null ? void 0 : _errors$AMOUNT2.message) || ((_errors$AMOUNT3 = errors[AMOUNT$3]) == null ? void 0 : _errors$AMOUNT3.message)))))), React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(AnimatePresence, {
    initial: false
  }, !shouldUseSavedAlias && React.createElement(Wrapper$5, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$3
  }, React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(InputWrap$4, null, React.createElement(InputInner$3, null, React.createElement(InputNumber$5, {
    ref: register(Register$5[CODE]),
    name: CODE,
    id: "_" + CODE,
    hasValue: !!blikCode
  }), React.createElement(InputLabel$3, {
    htmlFor: "_" + CODE
  }, intl.get("account_deposit_blikCode"))), React.createElement(AnimatePresence, null, ((_errors$CODE = errors[CODE]) == null ? void 0 : _errors$CODE.message) && React.createElement(InputError$6, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$3
  }, intl.get((_errors$CODE2 = errors[CODE]) == null ? void 0 : _errors$CODE2.message) || ((_errors$CODE3 = errors[CODE]) == null ? void 0 : _errors$CODE3.message)))))), React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(InputWrap$4, null, React.createElement(InputInner$3, null, React.createElement(Checkbox$2, {
    ref: register,
    name: SAVE,
    id: "_" + SAVE
  }), React.createElement(CheckboxLabel$3, {
    htmlFor: "_" + SAVE
  }, intl.get("account_deposit_saveBlikCode")))))))))), React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(InputWrap$4, null, React.createElement(InputInner$3, null, React.createElement(Checkbox$2, {
    ref: register(Register$5[ACCEPT$1]),
    name: ACCEPT$1,
    id: "_" + ACCEPT$1
  }), React.createElement(CheckboxLabel$3, {
    htmlFor: "_" + ACCEPT$1
  }, intl.getHTML("account_deposit_acceptBlikRules"))), React.createElement(AnimatePresence, null, ((_errors$ACCEPT = errors[ACCEPT$1]) == null ? void 0 : _errors$ACCEPT.message) && React.createElement(InputError$6, {
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
    variants: variants$3
  }, intl.get((_errors$ACCEPT2 = errors[ACCEPT$1]) == null ? void 0 : _errors$ACCEPT2.message) || ((_errors$ACCEPT3 = errors[ACCEPT$1]) == null ? void 0 : _errors$ACCEPT3.message)))))), React.createElement(Row$5, null, React.createElement(Column$5, null, React.createElement(Submit$6, null, intl.get("account_deposit_makeDeposit")))), React.createElement(Row$5, null, React.createElement(Column$5, null, isBlikSaved && React.createElement(Button$4, {
    isAlternative: shouldUseSavedAlias,
    onClick: onClick
  }, intl.get(shouldUseSavedAlias ? "account_deposit_enterNewBlik" : "account_deposit_useSavedBlik")))))));
};

var _excluded$5 = ["providerId"];
var _mapping$1, _logos;
var mapping$1 = (_mapping$1 = {}, _mapping$1[providerId$1] = Deposit, _mapping$1[providerId$3] = Deposit$2, _mapping$1[providerId$2] = Deposit$1, _mapping$1[providerId$4] = Deposit$3, _mapping$1[providerId$6] = Deposit$5, _mapping$1[providerId$7] = Deposit$6, _mapping$1[providerId$8] = Deposit$7, _mapping$1[providerId$9] = Deposit$8, _mapping$1[providerId$5] = Deposit$4, _mapping$1[providerId$a] = Deposit$9, _mapping$1);
var Deposit$a = function Deposit(_ref) {
  var _mapping$providerId;
  var providerId = _ref.providerId,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return (_mapping$providerId = mapping$1[providerId]) == null ? void 0 : _mapping$providerId.call(mapping$1, rest);
};
var logos = (_logos = {}, _logos[providerId$7] = img$7, _logos[providerId$8] = img$8, _logos[providerId$6] = img$6, _logos[providerId$9] = img$9, _logos[providerId$5] = img$5, _logos[providerId$a] = img$a, _logos);

var Wrapper$6 = Tabs$1.Wrapper,
  Header$4 = Tabs$1.Header,
  Tab$3 = Tabs$1.Tab,
  Item$3 = Tabs$1.Item;
var Index$1 = function Index() {
  var _useProviders = useProviders(),
    depositProviders = _useProviders.depositProviders;
  var regMethod = 0;
  // Just for testing purposes
  // let app ={
  //   config:{
  //   deviceProfile:'test'
  // }};
  // method checks what device is currently setted more info in ETOTO #82653 
  if (app.config.deviceProfile && typeof app.config.deviceProfile != undefined) {
    if (app.config.deviceProfile == 'mobile-app-android') {
      regMethod = 21; // android
    } else if (app.config.deviceProfile == 'mobile-app-ios') {
      regMethod = 22; //  ios
    } else {
      regMethod = 7; // mobile
    }
  } else {
    regMethod = 1; // web/desktop
  }
  var filteredDepositProviders = depositProviders.filter(function (item) {
    var _item$settings;
    if (regMethod == 21 || regMethod == 22) {
      return item;
    } else if (((_item$settings = item.settings) == null ? void 0 : _item$settings.enabledRegMethods) == undefined) {
      return item;
    }
  });
  return React.createElement(Wrapper$2, null, React.createElement(Wrapper$6, null, React.createElement(Header$4, null, filteredDepositProviders.map(function (provider) {
    return React.createElement(Tab$3, {
      index: provider.providerId,
      key: provider.providerId
    }, provider.providerName);
  })), filteredDepositProviders.map(function (provider) {
    return React.createElement(Item$3, {
      index: provider.providerId,
      key: provider.providerId
    }, React.createElement(Deposit$a, Object.assign({}, provider)));
  })));
};

var ModalIsOpen = /*#__PURE__*/createContext(undefined);
var ModalSetIsOpen = /*#__PURE__*/createContext(undefined);
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  return React.createElement(ModalIsOpen.Provider, {
    value: isOpen
  }, React.createElement(ModalSetIsOpen.Provider, {
    value: setIsOpen
  }, children));
};
var useModalIsOpen = function useModalIsOpen() {
  var context = useContext(ModalIsOpen);
  if (context === undefined) {
    throw new Error("'useModalIsOpen' must be used within a ModalProvider");
  }
  return context;
};
var useModalSetIsOpen = function useModalSetIsOpen() {
  var dispatch = useContext(ModalSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'useModalSetIsOpen' must be used within a ModalProvider");
  }
  return dispatch;
};
var open = function open() {
  var dispatch = useContext(ModalSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'open [Modal]' must be used within a ModalProvider");
  }
  return function () {
    return dispatch(true);
  };
};
var close = function close() {
  var dispatch = useContext(ModalSetIsOpen);
  if (dispatch === undefined) {
    throw new Error("'close [Modal]' must be used within a ModalProvider");
  }
  return function () {
    return dispatch(false);
  };
};
var useModal = function useModal() {
  return {
    isOpen: useModalIsOpen(),
    setIsOpen: useModalSetIsOpen(),
    open: open(),
    close: close()
  };
};

var ModalWrap = /*#__PURE__*/_styled(motion.div).withConfig({
  displayName: "indexstyled__ModalWrap",
  componentId: "sc-1g7pxi8-0"
})(["align-items:center;bottom:0;display:flex;left:0;justify-content:center;pointer-events:none;position:fixed;right:0;top:0;z-index:1000;*,*::after,*::before{font-family:\"Oswald\",sans-serif;box-sizing:border-box;}::after{background-color:", ";bottom:0;content:\"\";left:0;opacity:0.8;position:absolute;right:0;top:0;z-index:-1;@media ", "{display:none;}}"], function (_ref) {
  var blue4 = _ref.theme.blue4;
  return blue4;
}, devices.mobile);
var ModalHeader = /*#__PURE__*/_styled.header.withConfig({
  displayName: "indexstyled__ModalHeader",
  componentId: "sc-1g7pxi8-1"
})(["align-items:center;background-color:", ";border-radius:", ";border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:1px solid ", ";color:", ";display:flex;flex-shrink:0;font-size:", ";height:", ";justify-content:center;text-transform:uppercase;@media ", "{background-color:transparent;border:0;font-size:", ";height:", ";justify-content:flex-start;padding:0 0 0 ", ";}"], function (_ref2) {
  var blue0 = _ref2.theme.blue0;
  return blue0;
}, 5 / 30 + "em", function (_ref3) {
  var grey6 = _ref3.theme.grey6;
  return grey6;
}, function (_ref4) {
  var blue4 = _ref4.theme.blue4;
  return blue4;
}, 30 / 16 + "em", 132 / 30 + "em", devices.mobile, 24 / 16 + "em", 64 / 24 + "em", 84 / 24 + "em");
var ModalBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "indexstyled__ModalBody",
  componentId: "sc-1g7pxi8-2"
})(["overflow:auto;display:flex;flex-grow:1;justify-content:center;> main{height:auto;@media ", "{padding:0;}}"], devices.mobile);
var Modal = /*#__PURE__*/_styled(motion.aside).withConfig({
  displayName: "indexstyled__Modal",
  componentId: "sc-1g7pxi8-3"
})(["background-color:", ";border-radius:", ";display:flex;flex-direction:column;font-size:16px;pointer-events:all;position:relative;width:", ";height:", ";@media ", "{border-radius:0;height:100%;width:100%;}"], function (_ref5) {
  var white = _ref5.theme.white;
  return white;
}, 5 / 16 + "em", 1200 / 16 + "em", 400 / 9 + "em", devices.mobile);
var Close$2 = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "indexstyled__Close",
  componentId: "sc-1g7pxi8-4"
})(["background-color:", ";border-radius:50%;font-size:", ";height:", ";position:absolute;right:0;top:0;transform:translate(50%,-50%);width:", ";:hover,:focus{background-color:", ";}::after,::before{background-color:", ";content:\"\";height:", ";position:absolute;right:50%;top:50%;width:50%;}::after{transform:translate(50%,-50%) rotate(45deg);}::before{transform:translate(50%,-50%) rotate(135deg);}@media ", "{background-color:", ";border-radius:0;height:", ";left:0;right:auto;transform:none;width:", ";:hover,:focus{background-color:", ";}::after{background-color:transparent;border:", " solid ", ";border-top:0;border-right:0;height:", ";width:", ";}::before{display:none;}}"], function (_ref6) {
  var red5 = _ref6.theme.red5;
  return red5;
}, 16 / 16 + "em", 36 / 16 + "em", 36 / 16 + "em", function (_ref7) {
  var red5 = _ref7.theme.red5;
  return darken(0.1, red5);
}, function (_ref8) {
  var white = _ref8.theme.white;
  return white;
}, 2 / 16 + "em", devices.mobile, function (_ref9) {
  var blue0 = _ref9.theme.blue0;
  return blue0;
}, 64 / 16 + "em", 64 / 16 + "em", function (_ref10) {
  var blue0 = _ref10.theme.blue0;
  return darken(0.1, blue0);
}, 2 / 16 + "em", function (_ref11) {
  var blue4 = _ref11.theme.blue4;
  return blue4;
}, 16 / 16 + "em", 16 / 16 + "em");

var Modal$1 = function Modal$1(_ref) {
  var header = _ref.header,
    handleClose = _ref.handleClose,
    children = _ref.children;
  var _useModal = useModal(),
    isOpen = _useModal.isOpen,
    close = _useModal.close;
  var ref = useRef(null);
  var onClick = useCallback(function () {
    handleClose && handleClose();
    close();
  }, [handleClose, close]);
  useOnClickOutside(ref, close);
  return React.createElement(AnimatePresence, null, isOpen ? React.createElement(ModalWrap, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React.createElement(Modal, {
    ref: ref,
    initial: {
      y: -100,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: -100,
      opacity: 0
    }
  }, React.createElement(Close$2, {
    onClick: onClick
  }), React.createElement(ModalHeader, null, header), React.createElement(ModalBody, null, children))) : null);
};

var IndexModal = function IndexModal() {
  return React.createElement(Modal$1, {
    header: intl.get("account_deposit_depositHeading")
  }, React.createElement(Index$1, null));
};

var accountTypesAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var accountType = _ref.accountType;
    return accountType;
  }
});
var fetchAccountTypes = /*#__PURE__*/createAsyncThunk("AccountTypes/FetchAccountTypes", /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_, _ref2) {
    var getState, rejectWithValue, _yield$getAccountType, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
          _context.next = 3;
          return getAccountTypes(getState().session)();
        case 3:
          _yield$getAccountType = _context.sent;
          data = _yield$getAccountType.data;
          return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(accountTypesAdapter.getInitialState()));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var accountTypes = /*#__PURE__*/createSlice({
  name: "AccountTypes",
  initialState: /*#__PURE__*/accountTypesAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchAccountTypes.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      accountTypesAdapter.setAll(state, payload);
    });
  }
});
var accountTypes$1 = accountTypes.reducer;

var rootReducer = /*#__PURE__*/combineReducers({
  accounts: accounts$1,
  accountTypes: accountTypes$1,
  balance: balance$1,
  banks: banks$1,
  cards: cards$1,
  providers: providers$1,
  session: session$1,
  transaction: transaction$1
});

var store = /*#__PURE__*/configureStore({
  reducer: rootReducer,
  devTools: {
    name: "SB-payments"
  }
});

var getLocale = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", http2.get("/static/lang2/" + lang + ".json"));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchLocale = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", getLocale(lang));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();

var queryOptions$4 = {
  refetchOnWindowFocus: false
};
var useI18n = function useI18n(lang, key) {
  var _useState = useState(false),
    isReady = _useState[0],
    setIsReady = _useState[1];
  var localeFetcher = function localeFetcher() {
    return fetchLocale(lang);
  };
  var onSuccess = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = _ref.data;
            intl.init({
              currentLocale: 'default',
              locales: {
                'default': data
              }
            }).then(function () {
              setIsReady(true);
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSuccess(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useQuery(['i18n', key], localeFetcher, _extends({}, queryOptions$4, {
    onSuccess: onSuccess
  }));
  return isReady;
};

var Payments = function Payments(_ref) {
  var lang = _ref.lang,
    session = _ref.session;
  var isI18nReady = useI18n(lang, "payments");
  return isI18nReady ? React.createElement(Provider, {
    store: store
  }, React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SessionProvider, {
    session: session
  }, React.createElement(ConfirmationProvider, null, React.createElement(Index$1, null))))) : null;
};
var PaymentsModal = function PaymentsModal(_ref2) {
  var lang = _ref2.lang,
    session = _ref2.session;
  var isI18nReady = useI18n(lang, "paymentsModal");
  return isI18nReady ? React.createElement(Provider, {
    store: store
  }, React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SessionProvider, {
    session: session
  }, React.createElement(ConfirmationProvider, null, React.createElement(IndexModal, null))))) : null;
};
var Summary$2 = function Summary(_ref3) {
  var lang = _ref3.lang;
  var isI18nReady = useI18n(lang, "summary");
  return isI18nReady ? React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Summary$1, null)) : null;
};
var Withdraw$2 = function Withdraw(_ref4) {
  var lang = _ref4.lang,
    session = _ref4.session,
    balance = _ref4.balance,
    currencyCode = _ref4.currencyCode,
    shouldWithdrawButtonBeDisabled = _ref4.shouldWithdrawButtonBeDisabled,
    onSuccess = _ref4.onSuccess;
  var isI18nReady = useI18n(lang, "withdraw");
  return isI18nReady ? React.createElement(Provider, {
    store: store
  }, React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SessionProvider, {
    session: session
  }, React.createElement(BalanceProvider, {
    balance: balance,
    currencyCode: currencyCode,
    onSuccess: onSuccess
  }, React.createElement(Index, {
    shouldWithdrawButtonBeDisabled: shouldWithdrawButtonBeDisabled
  }))))) : null;
};
var SBPayments = {
  Payments: Payments,
  PaymentsModal: {
    Modal: PaymentsModal,
    useModal: useModal,
    ModalProvider: ModalProvider
  },
  Summary: Summary$2,
  Withdraw: Withdraw$2,
  useSession: useSession,
  useLang: useLang
};

export { SBPayments };
//# sourceMappingURL=sb-payments.esm.js.map
